/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 457:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ PostQuestionCategories_PostQuestionCategories)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(689);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "react-bootstrap/Row"
var Row_ = __webpack_require__(907);
var Row_default = /*#__PURE__*/__webpack_require__.n(Row_);
// EXTERNAL MODULE: external "react-bootstrap/Col"
var Col_ = __webpack_require__(511);
var Col_default = /*#__PURE__*/__webpack_require__.n(Col_);
// EXTERNAL MODULE: external "react-bootstrap/Button"
var Button_ = __webpack_require__(937);
var Button_default = /*#__PURE__*/__webpack_require__.n(Button_);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(379);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(795);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(569);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(565);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(216);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(589);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/VidioSection/PostQuestionCategories/PostQuestionCategories.module.scss
var PostQuestionCategories_module = __webpack_require__(906);
;// CONCATENATED MODULE: ./src/components/VidioSection/PostQuestionCategories/PostQuestionCategories.module.scss

      var exported = {};

      
      
      
      
      
      
      
      
      if (PostQuestionCategories_module/* default */.Z && PostQuestionCategories_module/* default.locals */.Z.locals) {
              exported.locals = PostQuestionCategories_module/* default.locals */.Z.locals;
            }
            

var refs = 0;
var update;
var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

exported.use = function(insertOptions) {
  options.options = insertOptions || {};

  if (!(refs++)) {
    update = injectStylesIntoStyleTag_default()(PostQuestionCategories_module/* default */.Z, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};




       /* harmony default export */ const PostQuestionCategories_PostQuestionCategories_module = (exported);

;// CONCATENATED MODULE: ./src/components/VidioSection/PostQuestionCategories/PostQuestionCategories.js






/**
 * Post-Question Form category Selections
 *  User can pick one category (only)
 *
 * On Selection:
 *  Vidio Modal: Vidio modal will close, PQ modal will open
 *  Vidio Inline: Categories will remain until
 *    successful PQ form submission
 */

var PostQuestionCategories = _ref => {
  var _ref2, _pqHeading$language, _ref3, _pqMessage$language, _postQuestions$catego, _postQuestions$compan;
  var {
    postQuestions = {},
    language = 'en',
    color = '#000000',
    onCategorySelect = () => {},
    isModal = false,
    previewMode = false,
    baseImageUrl = '',
    submittedCategoryIds
  } = _ref;
  (0,external_react_.useEffect)(() => {
    PostQuestionCategories_PostQuestionCategories_module.use();
  }, []);
  var pqHeading = postQuestions.introHeading;
  var pqMessage = postQuestions.introMessage;
  // eslint-disable-next-line no-nested-ternary
  var companyImageUrl = postQuestions.companyImageUrl ? postQuestions.companyImageUrl.includes('http') ? postQuestions.companyImageUrl : "".concat(baseImageUrl, "/").concat(postQuestions.companyImageUrl) : null;
  var heading = (_ref2 = (_pqHeading$language = pqHeading === null || pqHeading === void 0 ? void 0 : pqHeading[language]) !== null && _pqHeading$language !== void 0 ? _pqHeading$language : pqHeading === null || pqHeading === void 0 ? void 0 : pqHeading.en) !== null && _ref2 !== void 0 ? _ref2 : '';
  var intro = (_ref3 = (_pqMessage$language = pqMessage === null || pqMessage === void 0 ? void 0 : pqMessage[language]) !== null && _pqMessage$language !== void 0 ? _pqMessage$language : pqMessage === null || pqMessage === void 0 ? void 0 : pqMessage.en) !== null && _ref3 !== void 0 ? _ref3 : '';
  var categories = (_postQuestions$catego = postQuestions === null || postQuestions === void 0 ? void 0 : postQuestions.categories) !== null && _postQuestions$catego !== void 0 ? _postQuestions$catego : [];
  if (previewMode && !categories.length) {
    return /*#__PURE__*/external_react_default().createElement("div", null, "Categories have not yet been configured.");
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    style: {
      marginTop: 25
    }
  }, /*#__PURE__*/external_react_default().createElement("h2", {
    style: {
      color
    }
  }, heading), /*#__PURE__*/external_react_default().createElement("p", {
    style: {
      color
    }
  }, intro), /*#__PURE__*/external_react_default().createElement((Row_default()), {
    style: {
      marginTop: 10
    }
  }, companyImageUrl ? /*#__PURE__*/external_react_default().createElement((Col_default()), {
    key: companyImageUrl,
    xs: 6,
    sm: isModal ? 6 : 3,
    style: {
      paddingLeft: 5,
      paddingRight: 5
    }
  }, /*#__PURE__*/external_react_default().createElement((Button_default()), {
    onClick: () => {
      /* No action */
    },
    style: {
      outline: 0,
      width: '100%',
      boxShadow: 'none',
      padding: 0,
      marginBottom: 25,
      backgroundColor: 'transparent',
      borderWidth: 0
    }
  }, /*#__PURE__*/external_react_default().createElement("div", {
    style: {
      aspectRatio: '1/1'
    }
  }, /*#__PURE__*/external_react_default().createElement("img", {
    alt: (_postQuestions$compan = postQuestions.companyName) !== null && _postQuestions$compan !== void 0 ? _postQuestions$compan : '',
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    },
    src: companyImageUrl
  })))) : null, categories.map(category => {
    var _pqCategory$language;
    var pqCategory = category.categoryLabel;
    var checkboxID = "myCheckbox".concat(category.id);
    var categoryLabel = (_pqCategory$language = pqCategory === null || pqCategory === void 0 ? void 0 : pqCategory[language]) !== null && _pqCategory$language !== void 0 ? _pqCategory$language : pqCategory.en;
    var categoryImage = category.categoryImgUrl.includes('http') ? category.categoryImgUrl : "".concat(baseImageUrl, "/").concat(category.categoryImgUrl);
    return /*#__PURE__*/external_react_default().createElement((Col_default()), {
      key: category.id,
      xs: 6,
      sm: isModal ? 6 : 3,
      style: {
        paddingLeft: 5,
        paddingRight: 5
      }
    }, /*#__PURE__*/external_react_default().createElement((Button_default()), {
      onClick: () => {
        onCategorySelect(postQuestions.cpdcId, category.id);
      },
      style: {
        width: '100%',
        padding: 0,
        marginBottom: 25,
        backgroundColor: 'transparent',
        borderWidth: 0,
        outline: 0
      },
      className: "postQuestionBtnCustomStyle postQuestionButtonCheckedStyle"
    }, submittedCategoryIds && submittedCategoryIds.includes(category.id) ? /*#__PURE__*/external_react_default().createElement("input", {
      type: "checkbox",
      id: checkboxID,
      checked: true,
      className: "postQuestionInputCheckStyle"
    }) : null, /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null), /*#__PURE__*/external_react_default().createElement("label", {
      style: {
        aspectRatio: '1/1'
      },
      className: "postQuestionsCheckBoxLabelContainerStyle",
      htmlFor: checkboxID
    }, /*#__PURE__*/external_react_default().createElement("img", {
      alt: categoryLabel,
      style: {
        width: '100%',
        height: '100%',
        objectFit: 'contain'
      },
      src: categoryImage
    })), /*#__PURE__*/external_react_default().createElement("h5", {
      style: {
        marginTop: 10,
        padding: 5,
        fontSize: '1rem',
        letterSpacing: 0,
        color
      }
    }, categoryLabel)));
  })));
};
/* harmony default export */ const PostQuestionCategories_PostQuestionCategories = (PostQuestionCategories);

/***/ }),

/***/ 547:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Form-module__formOuter___\\+60Y-{background:#fff;padding:30px;border-radius:16px}@media(min-width: 415px){.Form-module__formOuter___\\+60Y-{border-radius:8px}}.form-control{border-radius:10px;padding:12px 16px}.Form-module__phoneInput___hwPpJ{padding-left:50px;padding-top:12px;padding-right:.75rem;padding-bottom:12px;width:100%}.Form-module__phoneInput___hwPpJ.form-control{padding-left:50px;padding-top:12px;padding-right:.75rem;padding-bottom:12px;width:100%}.Form-module__phoneDropdown___jmdDX{color:#000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formOuter": "Form-module__formOuter___+60Y-",
	"phoneInput": "Form-module__phoneInput___hwPpJ",
	"phoneDropdown": "Form-module__phoneDropdown___jmdDX"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 459:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FormCheckbox-module__checkbox___EB78c{display:flex;margin-bottom:1rem}.FormCheckbox-module__checkbox___EB78c .form-check-input:checked,.FormCheckbox-module__checkbox___EB78c .was-validated .form-check-input:checked{background-color:#ff6f00}.FormCheckbox-module__checkbox___EB78c .form-check-input,.FormCheckbox-module__checkbox___EB78c .was-validated .form-check-input:valid{border-color:#ff6f00}.FormCheckbox-module__checkbox___EB78c .form-check-input.is-invalid~.form-check-label,.FormCheckbox-module__checkbox___EB78c .was-validated .form-check-input:invalid~.form-check-label{color:inherit}.FormCheckbox-module__label___N0VnY{margin-top:-1px;margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox": "FormCheckbox-module__checkbox___EB78c",
	"label": "FormCheckbox-module__label___N0VnY"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 904:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FormInput-module__formSelectText___G6zd7{color:#000}.FormInput-module__customSelectError___RyhIs div{border-color:#e74c3c}.FormInput-module__visuallyHidden___84gEe{position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formSelectText": "FormInput-module__formSelectText___G6zd7",
	"customSelectError": "FormInput-module__customSelectError___RyhIs",
	"visuallyHidden": "FormInput-module__visuallyHidden___84gEe"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 509:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FormInputLanguage-module__flag___oYCx-{display:flex;width:22px;height:18px}@media(min-width: 415px){.FormInputLanguage-module__flag___oYCx-{width:26px;height:23px}}.FormInputLanguage-module__selectedOption___VQqhL+input{height:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flag": "FormInputLanguage-module__flag___oYCx-",
	"selectedOption": "FormInputLanguage-module__selectedOption___VQqhL"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 562:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GenericSelect-module__inputContainer___a0wh3{width:100%}@media(min-width: 992px){.GenericSelect-module__inputContainer___a0wh3{width:auto}}.GenericSelect-module__label___SsYwz{font-weight:700;margin-bottom:10px;display:block}.GenericSelect-module__error___P\\+K0A{font-size:14px !important;font-weight:500;margin-bottom:0}.GenericSelect-module__select___kr8P- .form-group,.GenericSelect-module__selectFormGroup___Lfp3i .form-group{width:100%}@media(min-width: 992px){.GenericSelect-module__select___kr8P- .form-group,.GenericSelect-module__selectFormGroup___Lfp3i .form-group{width:367px}}.GenericSelect-module__select___kr8P- .form-label,.GenericSelect-module__selectFormGroup___Lfp3i .form-label{font-weight:700;margin-bottom:10px;display:block}.GenericSelect-module__select___kr8P- .react-select__control,.GenericSelect-module__selectFormGroup___Lfp3i .react-select__control{width:100%;min-height:44px;border:1px solid #d3d3d3;border-radius:4px;font-size:16px;box-shadow:none}@media(min-width: 992px){.GenericSelect-module__select___kr8P- .react-select__control,.GenericSelect-module__selectFormGroup___Lfp3i .react-select__control{width:367px}}.GenericSelect-module__select___kr8P- .react-select__control:hover,.GenericSelect-module__selectFormGroup___Lfp3i .react-select__control:hover{border-color:#aaa}.GenericSelect-module__select___kr8P- .react-select__control:focus-visible,.GenericSelect-module__selectFormGroup___Lfp3i .react-select__control:focus-visible{outline:#000 auto 1px !important}.GenericSelect-module__select___kr8P- react-select__value-container,.GenericSelect-module__selectFormGroup___Lfp3i react-select__value-container{margin-left:8px}.GenericSelect-module__select___kr8P- .react-select__indicator-separator,.GenericSelect-module__selectFormGroup___Lfp3i .react-select__indicator-separator{display:none}.GenericSelect-module__select___kr8P- .react-select__multi-value,.GenericSelect-module__select___kr8P- .react-select__option--is-selected,.GenericSelect-module__selectFormGroup___Lfp3i .react-select__multi-value,.GenericSelect-module__selectFormGroup___Lfp3i .react-select__option--is-selected{background-color:#f57300}.GenericSelect-module__select___kr8P- .react-select__option--is-focused,.GenericSelect-module__selectFormGroup___Lfp3i .react-select__option--is-focused{background-color:rgba(245,115,0,.25);color:#000}.GenericSelect-module__select___kr8P- .react-select__multi-value__label,.GenericSelect-module__selectFormGroup___Lfp3i .react-select__multi-value__label{color:#fff}.GenericSelect-module__select___kr8P- .react-select__multi-value__remove svg,.GenericSelect-module__selectFormGroup___Lfp3i .react-select__multi-value__remove svg{fill:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": "GenericSelect-module__inputContainer___a0wh3",
	"label": "GenericSelect-module__label___SsYwz",
	"error": "GenericSelect-module__error___P+K0A",
	"select": "GenericSelect-module__select___kr8P-",
	"selectFormGroup": "GenericSelect-module__selectFormGroup___Lfp3i"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 385:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Header-module__Header___dL45E{color:inherit}h1.Header-module__Header___dL45E{font-size:2.5rem}h2.Header-module__Header___dL45E{font-size:2rem}h3.Header-module__Header___dL45E{font-size:1.75rem}h4.Header-module__Header___dL45E{font-size:1.5rem}h5.Header-module__Header___dL45E{font-size:1.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Header": "Header-module__Header___dL45E"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 437:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ImageSection-module__image___1W06c{display:block;margin:0 auto;width:100% !important;max-width:100%;object-fit:contain}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": "ImageSection-module__image___1W06c"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 198:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LanguageSelect-module__languageSelect___ybuJa{display:flex;align-items:center;justify-content:flex-end}.LanguageSelect-module__languageSelect___ybuJa .form-label{padding:2px 5px;opacity:.5;margin-bottom:0}.LanguageSelect-module__languageSelect___ybuJa .custom-select{width:60px;padding:2px 6px;height:auto}.LanguageSelect-module__languageSelect___ybuJa.LanguageSelect-module__mbSpace___KHt13{margin-bottom:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"languageSelect": "LanguageSelect-module__languageSelect___ybuJa",
	"mbSpace": "LanguageSelect-module__mbSpace___KHt13"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 356:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ModalForm-module__defaultModalForm___0boT\\+{box-shadow:0 0 5px rgba(0,0,0,.13)}.ModalForm-module__defaultModalForm___0boT\\+ iframe{background-color:#fff}.ModalForm-module__defaultModalForm___0boT\\+ .modal-content{border:none}.ModalForm-module__defaultModalForm___0boT\\+ .modal-header{border:none;background-color:#fff;color:#000;padding:30px;position:relative;justify-content:center}@media(max-width: 450px){.ModalForm-module__defaultModalForm___0boT\\+ .modal-header{padding:15px 30px}}.ModalForm-module__defaultModalForm___0boT\\+ .modal-header .modal-title{font-size:20px}.ModalForm-module__defaultModalForm___0boT\\+ .modal-header .modal-title span{display:block;font-size:14px;font-weight:300;margin-bottom:10px}.ModalForm-module__defaultModalForm___0boT\\+ .modal-header .modal-title img{display:block;max-width:90%;margin:30px auto 10px auto}@media(max-width: 768px){.ModalForm-module__defaultModalForm___0boT\\+ .modal-header .modal-title img{margin:20px auto 10px auto}}.ModalForm-module__defaultModalForm___0boT\\+ .modal-header .close{color:#000;padding:5px 0;opacity:1;font-size:28px;z-index:10;position:absolute;right:10px;top:0;margin:0}.ModalForm-module__defaultModalForm___0boT\\+ .modal-body{padding:20px 30px;max-height:calc(100vh - 210px);overflow-y:initial}@media(max-width: 450px){.ModalForm-module__defaultModalForm___0boT\\+ .modal-body{padding:30px 15px;font-size:14px}}.ModalForm-module__defaultModalForm___0boT\\+ .modal-body a{color:#ff6f00;text-decoration:underline}.ModalForm-module__defaultModalForm___0boT\\+ .modal-body form select{height:100%;border:1px solid #ebebeb;box-shadow:0 0 5px rgba(0,0,0,.13)}.ModalForm-module__defaultModalForm___0boT\\+ .modal-footer{border:none;background-color:#ebebeb;padding:20px 10px}.ModalForm-module__defaultModalForm___0boT\\+ .form-label{display:block;font-weight:normal;font-size:14px;margin-bottom:.25rem}@media(max-width: 450px){.ModalForm-module__defaultModalForm___0boT\\+ .form-label{font-size:12px}}.ModalForm-module__defaultModalForm___0boT\\+ .form-control,.ModalForm-module__defaultModalForm___0boT\\+ .custom-form-control>div{background-image:none;border:1px solid #ebebeb;box-shadow:0 0 5px rgba(0,0,0,.13)}.ModalForm-module__defaultModalForm___0boT\\+ .form-control:focus,.ModalForm-module__defaultModalForm___0boT\\+ .custom-form-control>div:focus{outline:none;background-color:#ebebeb}@media(max-width: 450px){.ModalForm-module__defaultModalForm___0boT\\+ .form-control,.ModalForm-module__defaultModalForm___0boT\\+ .custom-form-control>div{font-size:14px}}.ModalForm-module__defaultModalForm___0boT\\+ .form-control.is-invalid,.ModalForm-module__defaultModalForm___0boT\\+ .custom-form-control.is-invalid>div{border-color:#e74c3c}.ModalForm-module__defaultModalForm___0boT\\+ .form-group{width:100%;box-sizing:border-box}.ModalForm-module__defaultModalForm___0boT\\+ .formInputError{font-size:12px;color:#e74c3c;padding-left:5px}.ModalForm-module__defaultModalForm___0boT\\+ .btn-primary{display:block;padding:12px 20px;border:none;border-radius:6px;color:#fff;text-transform:uppercase;letter-spacing:1px;background-color:#ff6f00;transition:opacity .2s ease-in-out;box-shadow:2px 2px 2px 0 rgba(0,0,0,.13);margin:50px auto 0 auto;max-width:100%;white-space:normal}.ModalForm-module__defaultModalForm___0boT\\+ .btn-primary:hover{background-color:#ff6f00;opacity:.7;color:#fff;text-decoration:none}.ModalForm-module__defaultModalForm___0boT\\+ .btn-primary:disabled{cursor:not-allowed}.ModalForm-module__defaultModalForm___0boT\\+ .btn-primary:disabled:hover{color:#fff}.ModalForm-module__defaultModalForm___0boT\\+ .btn-primary:focus,.ModalForm-module__defaultModalForm___0boT\\+ .btn-primary:active{outline-offset:1px;outline-width:2px;outline-color:#000;outline-style:solid}@media(max-width: 450px){.ModalForm-module__defaultModalForm___0boT\\+ .btn-primary{padding:8px 20px;font-size:14px;white-space:normal}}.ModalForm-module__loader___fUb9q{text-align:center;color:#000}.ModalForm-module__center___nFGRz{text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"defaultModalForm": "ModalForm-module__defaultModalForm___0boT+",
	"loader": "ModalForm-module__loader___fUb9q",
	"center": "ModalForm-module__center___nFGRz"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 726:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TextParagraph-module__defaultText___EL6vy{color:inherit}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"defaultText": "TextParagraph-module__defaultText___EL6vy"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 706:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Button-module__primary___9BmWs{background-color:#000;outline-color:#000;border-color:#000;border-radius:50px;padding:14px 24px;font-size:18px;font-weight:500;text-transform:uppercase;color:#fff}.Button-module__primary___9BmWs.Button-module__disabled___zU7\\+G{opacity:.5}.Button-module__text___bxHG\\+{padding:0;border:0;color:currentColor;background:none;display:inline-block;vertical-align:inherit}.Button-module__text___bxHG\\+,.Button-module__text___bxHG\\+:hover,.Button-module__text___bxHG\\+:active,.Button-module__text___bxHG\\+:focus{text-decoration:underline}.Button-module__text___bxHG\\+:hover,.Button-module__text___bxHG\\+:active,.Button-module__text___bxHG\\+:focus{color:#ff6f00}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary": "Button-module__primary___9BmWs",
	"disabled": "Button-module__disabled___zU7+G",
	"text": "Button-module__text___bxHG+"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 906:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PostQuestionCategories-module__postQuestionButtonCheckedStyle___DHPav{list-style-type:none}.PostQuestionCategories-module__postQuestionInputCheckStyle___TEyqL{display:none}.PostQuestionCategories-module__postQuestionsCheckBoxLabelContainerStyle___ya07m{border:1px solid #fff;padding:0px;display:block;position:relative;margin:0px;cursor:pointer}.PostQuestionCategories-module__postQuestionsCheckBoxLabelContainerStyle___ya07m :before{background-color:#fff;color:#fff;content:\" \";display:block;border-radius:50%;border:1px solid #81a881;position:absolute;top:0px;right:-1px;width:20px;height:20px;text-align:center;line-height:13px;transition-duration:.4s;transform:scale(0)}.PostQuestionCategories-module__postQuestionsCheckBoxLabelContainerStyle___ya07m img{height:100px;width:100px;transition-duration:.2s;transform-origin:50% 50%}:checked+.PostQuestionCategories-module__postQuestionsCheckBoxLabelContainerStyle___ya07m{border-color:#81a881;border-radius:8%;border-width:2px}:checked+.PostQuestionCategories-module__postQuestionsCheckBoxLabelContainerStyle___ya07m:before{content:\"✓\";background-color:#81a881;transform:scale(1);z-index:10;border-radius:10px 6px 10px 10px;float:right;width:20px;height:20px;font-size:10px;padding:1px}:checked+.PostQuestionCategories-module__postQuestionsCheckBoxLabelContainerStyle___ya07m img{transform:scale(0.9);z-index:-1}.PostQuestionCategories-module__postQuestionBtnCustomStyle___gl3\\+z:focus{outline:none !important;outline-offset:none !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"postQuestionButtonCheckedStyle": "PostQuestionCategories-module__postQuestionButtonCheckedStyle___DHPav",
	"postQuestionInputCheckStyle": "PostQuestionCategories-module__postQuestionInputCheckStyle___TEyqL",
	"postQuestionsCheckBoxLabelContainerStyle": "PostQuestionCategories-module__postQuestionsCheckBoxLabelContainerStyle___ya07m",
	"postQuestionBtnCustomStyle": "PostQuestionCategories-module__postQuestionBtnCustomStyle___gl3+z"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 629:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".InlineHeader-module__inlineHeaderTitle___MMjur{margin-bottom:0}.InlineHeader-module__inlineHeader___5xRr6{border:none;color:#fff;padding:0;position:relative;justify-content:center;display:flex}.InlineHeader-module__inlineHeader___5xRr6 .InlineHeader-module__title___FoN38{font-size:20px;margin-bottom:0;line-height:1.5;width:100%}.InlineHeader-module__inlineHeader___5xRr6 .InlineHeader-module__title___FoN38 span{display:block;font-size:14px;font-weight:300;margin-bottom:10px}.InlineHeader-module__inlineHeader___5xRr6 .InlineHeader-module__title___FoN38 img{display:block;max-width:90%;margin:30px auto 10px auto}@media(max-width: 768px){.InlineHeader-module__inlineHeader___5xRr6 .InlineHeader-module__title___FoN38 img{margin:20px auto 10px auto}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inlineHeaderTitle": "InlineHeader-module__inlineHeaderTitle___MMjur",
	"inlineHeader": "InlineHeader-module__inlineHeader___5xRr6",
	"title": "InlineHeader-module__title___FoN38"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 219:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VidioForm-module__defaultVidioModal___rJFPu{max-width:500px;margin:0 auto}.VidioForm-module__defaultVidioModal___rJFPu .modal-content{border:none}.VidioForm-module__defaultVidioModal___rJFPu .body{padding:10px 30px;overflow-y:auto;position:relative}@media(max-width: 450px){.VidioForm-module__defaultVidioModal___rJFPu .body{padding:30px 15px;font-size:14px}}.VidioForm-module__defaultVidioModal___rJFPu .body a{color:#ff6f00;text-decoration:underline}.VidioForm-module__defaultVidioModal___rJFPu .footer{border:none;background-color:#ebebeb;padding:20px 10px}.VidioForm-module__defaultVidioModal___rJFPu .form-label{display:block;font-weight:normal;font-size:14px;margin-bottom:.25rem}@media(max-width: 450px){.VidioForm-module__defaultVidioModal___rJFPu .form-label{font-size:12px}}.VidioForm-module__defaultVidioModal___rJFPu .form-control,.VidioForm-module__defaultVidioModal___rJFPu .custom-form-control>div{background-image:none;border-radius:6px;padding:8px 12px;width:100%;border:1px solid #ebebeb;box-shadow:0 0 5px rgba(0,0,0,.13)}.VidioForm-module__defaultVidioModal___rJFPu .form-control:focus,.VidioForm-module__defaultVidioModal___rJFPu .custom-form-control>div:focus{outline:none;background-color:#ebebeb}@media(max-width: 450px){.VidioForm-module__defaultVidioModal___rJFPu .form-control,.VidioForm-module__defaultVidioModal___rJFPu .custom-form-control>div{font-size:14px}}.VidioForm-module__defaultVidioModal___rJFPu .form-control.is-invalid,.VidioForm-module__defaultVidioModal___rJFPu .custom-form-control.is-invalid>div{border-color:#e74c3c}.VidioForm-module__defaultVidioModal___rJFPu .form-group{width:100%;box-sizing:border-box}.VidioForm-module__defaultVidioModal___rJFPu .formInputError{font-size:12px;color:#e74c3c;padding-left:5px}.VidioForm-module__defaultVidioModal___rJFPu .btn-primary{display:block;padding:12px 20px;border:none;border-radius:6px;color:#fff;text-transform:uppercase;letter-spacing:1px;background-color:#ff6f00;transition:opacity .2s ease-in-out;box-shadow:2px 2px 2px 0 rgba(0,0,0,.13);white-space:nowrap;margin:20px auto 0 auto}.VidioForm-module__defaultVidioModal___rJFPu .btn-primary:hover{background-color:#ff6f00;opacity:.7;color:#fff;text-decoration:none}.VidioForm-module__defaultVidioModal___rJFPu .btn-primary:disabled{cursor:not-allowed}.VidioForm-module__defaultVidioModal___rJFPu .btn-primary:disabled:hover{color:#fff}.VidioForm-module__defaultVidioModal___rJFPu .btn-primary:focus,.VidioForm-module__defaultVidioModal___rJFPu .btn-primary:active{outline-offset:1px;outline-width:2px;outline-color:#000;outline-style:solid}@media(max-width: 450px){.VidioForm-module__defaultVidioModal___rJFPu .btn-primary{padding:8px 20px;font-size:14px;white-space:normal}}.VidioForm-module__VidioFormBrandCol___vNP1\\+{background-color:#000;display:flex;align-items:center;justify-content:center;padding-left:15px;padding-right:15px;margin:40px 0}@media(max-width: 576px){.VidioForm-module__VidioFormBrandCol___vNP1\\+{width:calc(100% + 30px);margin-left:-15px;margin-right:-15px}}.VidioForm-module__VidioFormBrandCol___vNP1\\+.VidioForm-module__BannerTop___mf70B{align-items:flex-start}.VidioForm-module__VidioFormBrandCol___vNP1\\+.VidioForm-module__BannerBottom___xOePG{align-items:flex-end}.VidioForm-module__VideoFormApplicationCol___vBI5b{padding:40px;justify-content:center;flex-direction:column}@media(max-width: 992px){.VidioForm-module__VideoFormApplicationCol___vBI5b{padding:20px}}.VidioForm-module__VideoFormApplicationCol___vBI5b form a{text-decoration:underline}.VidioForm-module__VideoFormApplicationCol___vBI5b form select{height:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"defaultVidioModal": "VidioForm-module__defaultVidioModal___rJFPu",
	"VidioFormBrandCol": "VidioForm-module__VidioFormBrandCol___vNP1+",
	"BannerTop": "VidioForm-module__BannerTop___mf70B",
	"BannerBottom": "VidioForm-module__BannerBottom___xOePG",
	"VideoFormApplicationCol": "VidioForm-module__VideoFormApplicationCol___vBI5b"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 637:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VidioModal-module__defaultVidioModal___VUKaV{box-shadow:0 0 5px rgba(0,0,0,.13)}.VidioModal-module__defaultVidioModal___VUKaV iframe{background-color:#fff}.VidioModal-module__defaultVidioModal___VUKaV .modal-content{border:none}.VidioModal-module__defaultVidioModal___VUKaV .modal-header{border:none;background-color:#ff6f00;color:#fff;padding:30px;position:relative;justify-content:center}@media(max-width: 450px){.VidioModal-module__defaultVidioModal___VUKaV .modal-header{padding:15px 30px}}.VidioModal-module__defaultVidioModal___VUKaV .modal-header .modal-title{font-size:20px}.VidioModal-module__defaultVidioModal___VUKaV .modal-header .modal-title span{display:block;font-size:14px;font-weight:300;margin-bottom:10px}.VidioModal-module__defaultVidioModal___VUKaV .modal-header .modal-title img{display:block;max-width:90%;margin:30px auto 10px auto}@media(max-width: 768px){.VidioModal-module__defaultVidioModal___VUKaV .modal-header .modal-title img{margin:20px auto 10px auto}}.VidioModal-module__defaultVidioModal___VUKaV .modal-header .close{color:#fff;padding:5px 0;opacity:1;font-size:28px;z-index:10;position:absolute;right:10px;top:0;margin:0}.VidioModal-module__defaultVidioModal___VUKaV .modal-body{padding:20px 30px;max-height:calc(100vh - 210px);overflow-y:auto}@media(max-width: 450px){.VidioModal-module__defaultVidioModal___VUKaV .modal-body{padding:30px 15px;font-size:14px}}.VidioModal-module__defaultVidioModal___VUKaV .modal-body a{color:#ff6f00;text-decoration:underline}.VidioModal-module__defaultVidioModal___VUKaV .modal-body form select{height:100%;border:1px solid #ebebeb;box-shadow:0 0 5px rgba(0,0,0,.13)}.VidioModal-module__defaultVidioModal___VUKaV .modal-footer{border:none;background-color:#ebebeb;padding:20px 10px}.VidioModal-module__defaultVidioModal___VUKaV .form-label{display:block;font-weight:normal;font-size:14px;margin-bottom:.25rem}@media(max-width: 450px){.VidioModal-module__defaultVidioModal___VUKaV .form-label{font-size:12px}}.VidioModal-module__defaultVidioModal___VUKaV .form-control,.VidioModal-module__defaultVidioModal___VUKaV .custom-form-control>div{background-image:none;border:1px solid #ebebeb;box-shadow:0 0 5px rgba(0,0,0,.13)}.VidioModal-module__defaultVidioModal___VUKaV .form-control:focus,.VidioModal-module__defaultVidioModal___VUKaV .custom-form-control>div:focus{outline:none;background-color:#ebebeb}@media(max-width: 450px){.VidioModal-module__defaultVidioModal___VUKaV .form-control,.VidioModal-module__defaultVidioModal___VUKaV .custom-form-control>div{font-size:14px}}.VidioModal-module__defaultVidioModal___VUKaV .form-control.is-invalid,.VidioModal-module__defaultVidioModal___VUKaV .custom-form-control.is-invalid>div{border-color:#e74c3c}.VidioModal-module__defaultVidioModal___VUKaV .form-group{width:100%;box-sizing:border-box}.VidioModal-module__defaultVidioModal___VUKaV .formInputError{font-size:12px;color:#e74c3c;padding-left:5px}.VidioModal-module__defaultVidioModal___VUKaV .btn-primary{display:block;padding:12px 20px;border:none;border-radius:6px;color:#fff;text-transform:uppercase;letter-spacing:1px;background-color:#ff6f00;transition:opacity .2s ease-in-out;box-shadow:2px 2px 2px 0 rgba(0,0,0,.13);margin:20px auto 0 auto;max-width:100%;white-space:normal}.VidioModal-module__defaultVidioModal___VUKaV .btn-primary:hover{background-color:#ff6f00;opacity:.7;color:#fff;text-decoration:none}.VidioModal-module__defaultVidioModal___VUKaV .btn-primary:disabled{cursor:not-allowed}.VidioModal-module__defaultVidioModal___VUKaV .btn-primary:disabled:hover{color:#fff}.VidioModal-module__defaultVidioModal___VUKaV .btn-primary:focus,.VidioModal-module__defaultVidioModal___VUKaV .btn-primary:active{outline-offset:1px;outline-width:2px;outline-color:#000;outline-style:solid}@media(max-width: 450px){.VidioModal-module__defaultVidioModal___VUKaV .btn-primary{padding:8px 20px;font-size:14px;white-space:normal}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"defaultVidioModal": "VidioModal-module__defaultVidioModal___VUKaV"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 350:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VidioSection-module__image___D9yab{display:block;width:100%;cursor:pointer}.VidioSection-module__vidioFormBanner___C-7xG{background-color:#000;display:flex;align-items:center;justify-content:center;margin:40px 0}.VidioSection-module__VidioFormBrandCol___JJ72T{background-color:#000;display:flex;align-items:center;justify-content:center;margin:40px 0}@media(max-width: 576px){.VidioSection-module__VidioFormBrandCol___JJ72T{width:calc(100% + 30px);margin-left:-15px;margin-right:-15px}}.VidioSection-module__VidioFormBrandCol___JJ72T.VidioSection-module__BannerTop___DWk3F{align-items:flex-start}.VidioSection-module__VidioFormBrandCol___JJ72T.VidioSection-module__BannerBottom___dMnce{align-items:flex-end}.VidioSection-module__VideoFormApplicationCol___Q51j9{display:flex;justify-content:center;flex-direction:column;padding:0 0 40px}@media(min-width: 768px){.VidioSection-module__VideoFormApplicationCol___Q51j9{padding:0 0 40px}}@media(min-width: 992px){.VidioSection-module__VideoFormApplicationCol___Q51j9{padding:40px 0 40px 40px}}.VidioSection-module__VideoFormApplicationCol___Q51j9 form a{text-decoration:underline}.VidioSection-module__VideoFormApplicationCol___Q51j9 form select{height:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": "VidioSection-module__image___D9yab",
	"vidioFormBanner": "VidioSection-module__vidioFormBanner___C-7xG",
	"VidioFormBrandCol": "VidioSection-module__VidioFormBrandCol___JJ72T",
	"BannerTop": "VidioSection-module__BannerTop___DWk3F",
	"BannerBottom": "VidioSection-module__BannerBottom___dMnce",
	"VideoFormApplicationCol": "VidioSection-module__VideoFormApplicationCol___Q51j9"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 718:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".YoutubeVideo-module__videoContainer___vL7Mo{overflow:hidden;position:relative;width:100%;border-radius:10px}.YoutubeVideo-module__videoContainer___vL7Mo::after{padding-top:56.25%;display:block;content:\"\"}.YoutubeVideo-module__videoContainer___vL7Mo iframe{position:absolute;top:0;left:0;width:100%;height:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"videoContainer": "YoutubeVideo-module__videoContainer___vL7Mo"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 645:
/***/ ((module) => {



/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (cssWithMappingToString) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join("");
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === "string") {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, ""]];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

/***/ }),

/***/ 379:
/***/ ((module) => {



var stylesInDOM = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };

    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);

  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }

      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };

  return updater;
}

module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();

        stylesInDOM.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 569:
/***/ ((module) => {



var memo = {};
/* istanbul ignore next  */

function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }

    memo[target] = styleTarget;
  }

  return memo[target];
}
/* istanbul ignore next  */


function insertBySelector(insert, style) {
  var target = getTarget(insert);

  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }

  target.appendChild(style);
}

module.exports = insertBySelector;

/***/ }),

/***/ 216:
/***/ ((module) => {



/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}

module.exports = insertStyleElement;

/***/ }),

/***/ 565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;

  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}

module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 795:
/***/ ((module) => {



/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";

  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }

  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }

  var needLayer = typeof obj.layer !== "undefined";

  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }

  css += obj.css;

  if (needLayer) {
    css += "}";
  }

  if (obj.media) {
    css += "}";
  }

  if (obj.supports) {
    css += "}";
  }

  var sourceMap = obj.sourceMap;

  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  options.styleTagTransform(css, styleElement, options.options);
}

function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }

  styleElement.parentNode.removeChild(styleElement);
}
/* istanbul ignore next  */


function domAPI(options) {
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}

module.exports = domAPI;

/***/ }),

/***/ 589:
/***/ ((module) => {



/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }

    styleElement.appendChild(document.createTextNode(css));
  }
}

module.exports = styleTagTransform;

/***/ }),

/***/ 689:
/***/ ((module) => {

module.exports = require("react");

/***/ }),

/***/ 937:
/***/ ((module) => {

module.exports = require("react-bootstrap/Button");

/***/ }),

/***/ 511:
/***/ ((module) => {

module.exports = require("react-bootstrap/Col");

/***/ }),

/***/ 907:
/***/ ((module) => {

module.exports = require("react-bootstrap/Row");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Form": () => (/* reexport */ Form_Form),
  "FormSelectAsync": () => (/* reexport */ FormSelectAsync_FormSelectAsync),
  "GenericSelect": () => (/* reexport */ GenericSelect),
  "Header": () => (/* reexport */ Header_Header),
  "ImageSection": () => (/* reexport */ ImageSection_ImageSection),
  "ImagesCarousel": () => (/* reexport */ ImagesCarousel_ImagesCarousel),
  "LanguageSelect": () => (/* reexport */ LanguageSelect_LanguageSelect),
  "PostQuestions": () => (/* reexport */ PostQuestions_PostQuestions),
  "TextParagraph": () => (/* reexport */ TextParagraph_TextParagraph),
  "VidioForm": () => (/* reexport */ VidioForm_VidioForm),
  "VidioSection": () => (/* reexport */ VidioSection_VidioSection),
  "YoutubeVideo": () => (/* reexport */ YoutubeVideo_YoutubeVideo)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(689);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
;// CONCATENATED MODULE: external "react-bootstrap/Image"
const Image_namespaceObject = require("react-bootstrap/Image");
var Image_default = /*#__PURE__*/__webpack_require__.n(Image_namespaceObject);
;// CONCATENATED MODULE: external "react-bootstrap/Container"
const Container_namespaceObject = require("react-bootstrap/Container");
var Container_default = /*#__PURE__*/__webpack_require__.n(Container_namespaceObject);
// EXTERNAL MODULE: external "react-bootstrap/Row"
var Row_ = __webpack_require__(907);
var Row_default = /*#__PURE__*/__webpack_require__.n(Row_);
// EXTERNAL MODULE: external "react-bootstrap/Col"
var Col_ = __webpack_require__(511);
var Col_default = /*#__PURE__*/__webpack_require__.n(Col_);
;// CONCATENATED MODULE: ./src/containers/ComponentContainer.js




var ComponentContainer = _ref => {
  var {
    children,
    style,
    fullWidth,
    noGutters
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((Container_default()), {
    fluid: fullWidth,
    className: fullWidth && 'px-0'
  }, /*#__PURE__*/external_react_default().createElement((Row_default()), {
    className: noGutters && 'g-0'
  }, /*#__PURE__*/external_react_default().createElement((Col_default()), {
    style: style
  }, children)));
};
/* harmony default export */ const containers_ComponentContainer = (ComponentContainer);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(379);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(795);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(569);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(565);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(216);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(589);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/ImageSection/ImageSection.module.scss
var ImageSection_module = __webpack_require__(437);
;// CONCATENATED MODULE: ./src/components/ImageSection/ImageSection.module.scss

      var exported = {};

      
      
      
      
      
      
      
      
      if (ImageSection_module/* default */.Z && ImageSection_module/* default.locals */.Z.locals) {
              exported.locals = ImageSection_module/* default.locals */.Z.locals;
            }
            

var refs = 0;
var update;
var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

exported.use = function(insertOptions) {
  options.options = insertOptions || {};

  if (!(refs++)) {
    update = injectStylesIntoStyleTag_default()(ImageSection_module/* default */.Z, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};




       /* harmony default export */ const ImageSection_ImageSection_module = (exported);

;// CONCATENATED MODULE: ./src/components/ImageSection/LinkBox/LinkBox.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var LinkBox = props => {
  var {
    linkBox = {},
    linkBoxMapStyle = {},
    onLinkClick = () => {},
    index = 0
  } = props;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/control-has-associated-label
    external_react_default().createElement("a", {
      href: linkBox.targetUrl,
      title: linkBox.title || '',
      onClick: onLinkClick,
      onAuxClick: onLinkClick,
      target: "_blank",
      rel: "noreferrer",
      key: index,
      style: _objectSpread(_objectSpread({}, linkBoxMapStyle), {}, {
        position: 'absolute',
        width: linkBox.width,
        height: linkBox.height,
        top: linkBox.top,
        left: linkBox.left
      })
    })
  );
};
/* harmony default export */ const LinkBox_LinkBox = (LinkBox);
;// CONCATENATED MODULE: ./src/components/ImageSection/ImageSection.js
function ImageSection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function ImageSection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ImageSection_ownKeys(Object(source), !0).forEach(function (key) { ImageSection_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ImageSection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function ImageSection_defineProperty(obj, key, value) { key = ImageSection_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function ImageSection_toPropertyKey(arg) { var key = ImageSection_toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function ImageSection_toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }





var ImageSection = props => {
  var {
    src = '',
    alt = '',
    url = '',
    onLinkClick = () => {},
    onImgClick = () => {},
    fullViewportWidth = false,
    imageHeight = 'auto',
    imageFit = 'contain',
    imagePosition = 'center center',
    customStyle = {},
    linkBoxesMap = [],
    linkBoxMapStyle = {},
    linkBoxMapWrapperStyle = {},
    LinkBoxArea = null
  } = props;
  var containerRef = (0,external_react_.useRef)(null);
  var [imageDimensions, setImageDimensions] = (0,external_react_.useState)(null);
  var [imageContainerSize, setContainerSize] = (0,external_react_.useState)();
  var classes = ImageSection_ImageSection_module.locals || {};
  (0,external_react_.useEffect)(() => {
    ImageSection_ImageSection_module.use();
  }, []);

  /**
   * Calculate container style to offset all links positions when it matters
   */
  var linkMapContainerStyles = (0,external_react_.useMemo)(() => {
    // no need for fake repositioning when image is automatic height
    // also, we can be missing some essential info (e.g. about container)
    if (!imageHeight || imageHeight === 'auto' || !imageDimensions || !imageContainerSize) {
      return {};
    }
    var desiredWHRatio = imageDimensions ? imageDimensions.width / imageDimensions.height : 1;
    var actualWHRatio = imageContainerSize.width / imageHeight;
    if (
    // tall cover or wide contain - adjust horizontally
    imageFit === 'cover' && actualWHRatio < desiredWHRatio || imageFit === 'contain' && actualWHRatio > desiredWHRatio) {
      var width = imageContainerSize.height * desiredWHRatio;
      if (/left/i.test(imagePosition)) {
        return {
          width
        };
      }
      if (/right/i.test(imagePosition)) {
        return {
          width,
          left: 'auto',
          right: 0
        };
      }
      return {
        width,
        left: -(width - imageContainerSize.width) / 2
      };
    }
    if (
    // tall contain or wide cover - adjust vertically
    imageFit === 'contain' && actualWHRatio < desiredWHRatio || imageFit === 'cover' && actualWHRatio > desiredWHRatio) {
      var height = imageContainerSize.width / desiredWHRatio;
      if (/top/i.test(imagePosition)) {
        return {
          height
        };
      }
      if (/bottom/i.test(imagePosition)) {
        return {
          height,
          top: 'auto',
          bottom: 0
        };
      }
      return {
        height,
        top: -(height - imageContainerSize.height) / 2
      };
    }
    return {};
  }, [imageHeight, imageFit, imageDimensions, imagePosition, imageContainerSize]);

  /**
   * Get image natural size
   */
  (0,external_react_.useEffect)(() => {
    var img = new window.Image();
    img.src = src;
    img.onload = () => {
      setImageDimensions({
        width: img.naturalWidth,
        height: img.naturalHeight
      });
    };
  }, [src]);

  /**
   * Track the container width
   */
  (0,external_react_.useEffect)(() => {
    var resizeDebounce = null;
    function resizeCallback() {
      clearTimeout(resizeDebounce);
      resizeDebounce = setTimeout(() => {
        var boundingRect = containerRef.current.getBoundingClientRect();
        setContainerSize({
          width: boundingRect.width,
          height: boundingRect.height
        });
      }, 250);
    }
    window.addEventListener('resize', resizeCallback);
    return () => {
      window.removeEventListener('resize', resizeCallback);
    };
  }, []);
  (0,external_react_.useEffect)(() => {
    var boundingRect = containerRef.current.getBoundingClientRect();
    setContainerSize({
      width: boundingRect.width,
      height: boundingRect.height
    });
  }, [imageHeight, fullViewportWidth]);
  function getImg() {
    return /*#__PURE__*/external_react_default().createElement((Image_default()), {
      className: classes.image,
      src: src,
      alt: alt,
      height: imageHeight,
      style: {
        objectFit: imageFit,
        objectPosition: imagePosition
      },
      onClick: onImgClick
    });
  }
  function getLinkBox() {
    return /*#__PURE__*/external_react_default().createElement("div", {
      style: ImageSection_objectSpread(ImageSection_objectSpread(ImageSection_objectSpread({
        top: 0,
        left: 0,
        height: '100%',
        width: '100%'
      }, linkBoxMapWrapperStyle), linkMapContainerStyles), {}, {
        position: 'absolute'
      })
    }, LinkBoxArea ? /*#__PURE__*/external_react_default().createElement(LinkBoxArea, null) : linkBoxesMap.map((handle, index) => /*#__PURE__*/external_react_default().createElement(LinkBox_LinkBox, {
      linkBoxMapStyle: linkBoxMapStyle,
      linkBox: handle,
      onLinkClick: onLinkClick,
      index: index,
      key: index.toString()
    })));
  }
  var sectionContent = url && /*#__PURE__*/external_react_default().createElement("a", {
    href: url,
    title: alt || '',
    onClick: onLinkClick,
    onAuxClick: onLinkClick,
    target: "_blank",
    rel: "noreferrer"
  }, getImg()) || getImg();
  return /*#__PURE__*/external_react_default().createElement(containers_ComponentContainer, {
    fullWidth: fullViewportWidth,
    noGutters: fullViewportWidth,
    style: ImageSection_objectSpread({}, customStyle)
  }, /*#__PURE__*/external_react_default().createElement("div", {
    ref: containerRef,
    style: {
      position: 'relative',
      overflow: 'hidden'
    }
  }, sectionContent, linkBoxesMap && linkBoxesMap.length ? getLinkBox() : null));
};
/* harmony default export */ const ImageSection_ImageSection = (ImageSection);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/TextParagraph/TextParagraph.module.scss
var TextParagraph_module = __webpack_require__(726);
;// CONCATENATED MODULE: ./src/components/TextParagraph/TextParagraph.module.scss

      var TextParagraph_module_exported = {};

      
      
      
      
      
      
      
      
      if (TextParagraph_module/* default */.Z && TextParagraph_module/* default.locals */.Z.locals) {
              TextParagraph_module_exported.locals = TextParagraph_module/* default.locals */.Z.locals;
            }
            

var TextParagraph_module_refs = 0;
var TextParagraph_module_update;
var TextParagraph_module_options = {};

TextParagraph_module_options.styleTagTransform = (styleTagTransform_default());
TextParagraph_module_options.setAttributes = (setAttributesWithoutAttributes_default());

      TextParagraph_module_options.insert = insertBySelector_default().bind(null, "head");
    
TextParagraph_module_options.domAPI = (styleDomAPI_default());
TextParagraph_module_options.insertStyleElement = (insertStyleElement_default());

TextParagraph_module_exported.use = function(insertOptions) {
  TextParagraph_module_options.options = insertOptions || {};

  if (!(TextParagraph_module_refs++)) {
    TextParagraph_module_update = injectStylesIntoStyleTag_default()(TextParagraph_module/* default */.Z, TextParagraph_module_options);
  }

  return TextParagraph_module_exported;
};
TextParagraph_module_exported.unuse = function() {
  if (TextParagraph_module_refs > 0 && !--TextParagraph_module_refs) {
    TextParagraph_module_update();
    TextParagraph_module_update = null;
  }
};




       /* harmony default export */ const TextParagraph_TextParagraph_module = (TextParagraph_module_exported);

;// CONCATENATED MODULE: external "html-react-parser"
const external_html_react_parser_namespaceObject = require("html-react-parser");
var external_html_react_parser_default = /*#__PURE__*/__webpack_require__.n(external_html_react_parser_namespaceObject);
;// CONCATENATED MODULE: external "isomorphic-dompurify"
const external_isomorphic_dompurify_namespaceObject = require("isomorphic-dompurify");
var external_isomorphic_dompurify_default = /*#__PURE__*/__webpack_require__.n(external_isomorphic_dompurify_namespaceObject);
;// CONCATENATED MODULE: ./src/shared/htmlParse.js

 // Server render support

/**
 * Sanitise and convert html string into React components
 * https://www.npmjs.com/package/dompurify
 * https://www.npmjs.com/package/html-react-parser
 * @function
 * @name htmlParse
 */
var htmlParse = (dirtyHtml, config) => {
  var cleanHtml = external_isomorphic_dompurify_default().sanitize(dirtyHtml, config || {});
  return external_html_react_parser_default()(cleanHtml);
};
;// CONCATENATED MODULE: ./src/components/TextParagraph/TextParagraph.js




var TextParagraph = props => {
  var {
    paragraph = '',
    customStyle = {}
  } = props;
  var classes = TextParagraph_TextParagraph_module.locals || {};
  (0,external_react_.useEffect)(() => {
    TextParagraph_TextParagraph_module.use();
  }, []);
  return /*#__PURE__*/external_react_default().createElement(containers_ComponentContainer, {
    style: customStyle
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: classes.defaultText
  }, htmlParse(paragraph)));
};
/* harmony default export */ const TextParagraph_TextParagraph = (TextParagraph);
;// CONCATENATED MODULE: external "react-responsive"
const external_react_responsive_namespaceObject = require("react-responsive");
;// CONCATENATED MODULE: external "react-bootstrap/Carousel"
const Carousel_namespaceObject = require("react-bootstrap/Carousel");
var Carousel_default = /*#__PURE__*/__webpack_require__.n(Carousel_namespaceObject);
;// CONCATENATED MODULE: ./src/components/ImagesCarousel/ImagesCarousel.js







var ImagesCarousel = props => {
  var {
    slides,
    onLinkClick = () => {},
    customStyle = {},
    imagesPerSlide = 1,
    autoplay = true,
    fullViewportWidth = false
  } = props;
  var mobileMode = (0,external_react_responsive_namespaceObject.useMediaQuery)({
    query: '(max-width: 768px)'
  });
  function getImage(imageUrl, imageAlt) {
    return /*#__PURE__*/external_react_default().createElement((Image_default()), {
      className: "d-block w-100",
      src: imageUrl,
      alt: imageAlt
    });
  }
  function getItemsPerSlide() {
    if (imagesPerSlide < 1) return 1;
    if (mobileMode) return 1;
    return imagesPerSlide;
  }
  function createCarouselColumn(slide, index) {
    return /*#__PURE__*/external_react_default().createElement((Col_default()), {
      style: {
        padding: 0,
        maxWidth: "".concat(100 / getItemsPerSlide(), "%")
      },
      key: JSON.stringify(slide)
    }, slide.linkUrl ? /*#__PURE__*/external_react_default().createElement("a", {
      href: slide.linkUrl,
      target: "_blank",
      rel: "noreferrer",
      onClick: event => {
        onLinkClick(event, index);
      },
      onAuxClick: event => {
        onLinkClick(event, index);
      }
    }, getImage(slide.imageUrl, slide.imageAlt)) : getImage(slide.imageUrl, slide.imageAlt));
  }
  function createCarouselItem(slideGroup) {
    return /*#__PURE__*/external_react_default().createElement((Carousel_default()).Item, {
      key: JSON.stringify(slideGroup)
    }, /*#__PURE__*/external_react_default().createElement((Row_default()), {
      className: "justify-content-center"
    }, slideGroup.map(createCarouselColumn)));
  }
  function splitSlides(items) {
    return items.reduce((res, slide, idx) => {
      var bucektIndex = Math.floor(idx / getItemsPerSlide());
      if (!res[bucektIndex]) {
        res[bucektIndex] = [];
      }
      res[bucektIndex].push(slide);
      return res;
    }, []);
  }
  function createCarousel() {
    var groupedSlides = splitSlides(slides);
    return /*#__PURE__*/external_react_default().createElement((Carousel_default()), {
      indicators: groupedSlides.length > 1,
      controls: groupedSlides.length > 1,
      interval: autoplay ? 5000 : null
    }, groupedSlides.map(createCarouselItem));
  }
  return fullViewportWidth ? createCarousel() : /*#__PURE__*/external_react_default().createElement(containers_ComponentContainer, {
    style: customStyle
  }, createCarousel());
};
/* harmony default export */ const ImagesCarousel_ImagesCarousel = (ImagesCarousel);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/YoutubeVideo/YoutubeVideo.module.scss
var YoutubeVideo_module = __webpack_require__(718);
;// CONCATENATED MODULE: ./src/components/YoutubeVideo/YoutubeVideo.module.scss

      var YoutubeVideo_module_exported = {};

      
      
      
      
      
      
      
      
      if (YoutubeVideo_module/* default */.Z && YoutubeVideo_module/* default.locals */.Z.locals) {
              YoutubeVideo_module_exported.locals = YoutubeVideo_module/* default.locals */.Z.locals;
            }
            

var YoutubeVideo_module_refs = 0;
var YoutubeVideo_module_update;
var YoutubeVideo_module_options = {};

YoutubeVideo_module_options.styleTagTransform = (styleTagTransform_default());
YoutubeVideo_module_options.setAttributes = (setAttributesWithoutAttributes_default());

      YoutubeVideo_module_options.insert = insertBySelector_default().bind(null, "head");
    
YoutubeVideo_module_options.domAPI = (styleDomAPI_default());
YoutubeVideo_module_options.insertStyleElement = (insertStyleElement_default());

YoutubeVideo_module_exported.use = function(insertOptions) {
  YoutubeVideo_module_options.options = insertOptions || {};

  if (!(YoutubeVideo_module_refs++)) {
    YoutubeVideo_module_update = injectStylesIntoStyleTag_default()(YoutubeVideo_module/* default */.Z, YoutubeVideo_module_options);
  }

  return YoutubeVideo_module_exported;
};
YoutubeVideo_module_exported.unuse = function() {
  if (YoutubeVideo_module_refs > 0 && !--YoutubeVideo_module_refs) {
    YoutubeVideo_module_update();
    YoutubeVideo_module_update = null;
  }
};




       /* harmony default export */ const YoutubeVideo_YoutubeVideo_module = (YoutubeVideo_module_exported);

;// CONCATENATED MODULE: ./src/components/YoutubeVideo/YoutubeVideo.js



var YoutubeVideo = props => {
  var {
    src = '',
    autoplay = '0',
    customStyle = {}
  } = props;
  var classes = YoutubeVideo_YoutubeVideo_module.locals || {};
  (0,external_react_.useEffect)(() => {
    YoutubeVideo_YoutubeVideo_module.use();
  }, []);
  function getYoutubeId(url) {
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    var match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  }
  return /*#__PURE__*/external_react_default().createElement(containers_ComponentContainer, {
    style: customStyle
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: classes.videoContainer
  }, /*#__PURE__*/external_react_default().createElement("iframe", {
    title: "Youtube Video",
    src: "//www.youtube.com/embed/".concat(getYoutubeId(src), "?rel=0&autoplay=").concat(autoplay),
    frameBorder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true
  })));
};
/* harmony default export */ const YoutubeVideo_YoutubeVideo = (YoutubeVideo);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/Header/Header.module.scss
var Header_module = __webpack_require__(385);
;// CONCATENATED MODULE: ./src/components/Header/Header.module.scss

      var Header_module_exported = {};

      
      
      
      
      
      
      
      
      if (Header_module/* default */.Z && Header_module/* default.locals */.Z.locals) {
              Header_module_exported.locals = Header_module/* default.locals */.Z.locals;
            }
            

var Header_module_refs = 0;
var Header_module_update;
var Header_module_options = {};

Header_module_options.styleTagTransform = (styleTagTransform_default());
Header_module_options.setAttributes = (setAttributesWithoutAttributes_default());

      Header_module_options.insert = insertBySelector_default().bind(null, "head");
    
Header_module_options.domAPI = (styleDomAPI_default());
Header_module_options.insertStyleElement = (insertStyleElement_default());

Header_module_exported.use = function(insertOptions) {
  Header_module_options.options = insertOptions || {};

  if (!(Header_module_refs++)) {
    Header_module_update = injectStylesIntoStyleTag_default()(Header_module/* default */.Z, Header_module_options);
  }

  return Header_module_exported;
};
Header_module_exported.unuse = function() {
  if (Header_module_refs > 0 && !--Header_module_refs) {
    Header_module_update();
    Header_module_update = null;
  }
};




       /* harmony default export */ const Header_Header_module = (Header_module_exported);

;// CONCATENATED MODULE: ./src/components/Header/Header.js



var Header = props => {
  var {
    header = '',
    headerSize = 'h1',
    customStyle = {}
  } = props;
  var classes = Header_Header_module.locals || {};
  (0,external_react_.useEffect)(() => {
    Header_Header_module.use();
  }, []);
  var Heading = headerSize;
  return /*#__PURE__*/external_react_default().createElement(containers_ComponentContainer, {
    style: customStyle
  }, /*#__PURE__*/external_react_default().createElement(Heading, {
    className: classes.Header
  }, header));
};
/* harmony default export */ const Header_Header = (Header);
;// CONCATENATED MODULE: external "axios"
const external_axios_namespaceObject = require("axios");
var external_axios_default = /*#__PURE__*/__webpack_require__.n(external_axios_namespaceObject);
;// CONCATENATED MODULE: external "react-bootstrap/Modal"
const Modal_namespaceObject = require("react-bootstrap/Modal");
var Modal_default = /*#__PURE__*/__webpack_require__.n(Modal_namespaceObject);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/VidioSection/VidioModal/VidioModal.module.scss
var VidioModal_module = __webpack_require__(637);
;// CONCATENATED MODULE: ./src/components/VidioSection/VidioModal/VidioModal.module.scss

      var VidioModal_module_exported = {};

      
      
      
      
      
      
      
      
      if (VidioModal_module/* default */.Z && VidioModal_module/* default.locals */.Z.locals) {
              VidioModal_module_exported.locals = VidioModal_module/* default.locals */.Z.locals;
            }
            

var VidioModal_module_refs = 0;
var VidioModal_module_update;
var VidioModal_module_options = {};

VidioModal_module_options.styleTagTransform = (styleTagTransform_default());
VidioModal_module_options.setAttributes = (setAttributesWithoutAttributes_default());

      VidioModal_module_options.insert = insertBySelector_default().bind(null, "head");
    
VidioModal_module_options.domAPI = (styleDomAPI_default());
VidioModal_module_options.insertStyleElement = (insertStyleElement_default());

VidioModal_module_exported.use = function(insertOptions) {
  VidioModal_module_options.options = insertOptions || {};

  if (!(VidioModal_module_refs++)) {
    VidioModal_module_update = injectStylesIntoStyleTag_default()(VidioModal_module/* default */.Z, VidioModal_module_options);
  }

  return VidioModal_module_exported;
};
VidioModal_module_exported.unuse = function() {
  if (VidioModal_module_refs > 0 && !--VidioModal_module_refs) {
    VidioModal_module_update();
    VidioModal_module_update = null;
  }
};




       /* harmony default export */ const VidioModal_VidioModal_module = (VidioModal_module_exported);

;// CONCATENATED MODULE: external "lodash/merge"
const merge_namespaceObject = require("lodash/merge");
var merge_default = /*#__PURE__*/__webpack_require__.n(merge_namespaceObject);
;// CONCATENATED MODULE: external "lodash/get"
const get_namespaceObject = require("lodash/get");
var get_default = /*#__PURE__*/__webpack_require__.n(get_namespaceObject);
;// CONCATENATED MODULE: ./src/translations/en/common.json
const common_namespaceObject = JSON.parse('{"noCreditCardRequired":"(No credit card or payment required)","postQuestionInitError":"We had a problem retrieving the form. Please check you\'re still online and ","selectNoOptionMessage":"Start typing for options","selectPlaceholder":"Please select one","form":{"tryAgain":"try again","required":"is required","toLong":"Value is to long","successTitle":"Success","errorTitle":"Error","submitTitle":"Submit","selectLanguage":"Select language","submitData":"Click to accept terms and conditions","subscriptionInfo":"I agree for {brandName} to receive my personal data as outlined in the <a href=\\"{termsAndConditionsUrl}\\" target=\\"_blank\\" rel=\\"noreferrer\\" style=\\"color: {accentColor}\\">Terms and Conditions</a> in exchange for providing me a {productName} from <a href=\\"{videoProviderUrl}\\" target=\\"_blank\\" style=\\"color: {accentColor}\\"><strong>{videoProviderName}</strong></a>"},"successMessage":{"subText":"<strong>{providerName}</strong> is happy to provide you","default":"Thank you {subscriberFirstName}, an Email has been sent to {subscriberEmail} with your Free Pass Code & Access details.","phone":"Thank you {subscriberFirstName}, an SMS has been sent to {subscriberPhone} with your Free Pass Code & Access details.","ctaBackToProvider":"Go to {providerName}","campaignCallback":{"tapBelow":"Tap below to complete your submission with <strong>{providerName}</strong>.","cta":"Continue"}},"indosatMessage":{"success":"Thank you {subscriberFirstName}, your {productName} reward will be credited to your IndoSat account within 24 hours. You will receive a confirmation email when the credit has been applied","invalidPhoneNumber":"Thank you {subscriberFirstName}, in order to credit your {productName} reward to your account you need a valid IndoSat phone number. The number you have entered {subscriberPhone} is not valid. Please get in touch with IndoSat if you have any queries.","expiredPhoneNumber":"Thank you {subscriberFirstName}, in order to credit your {productName} reward to your account you need an active IndoSat phone number. The number you have entered {subscriberPhone} is not valid. Please get in touch with IndoSat if you have any queries.","rewardQuotaExceeded":"Thank you for your responses {subscriberFirstName}, unfortunately there was an error when attempting to credit your reward. You already have exceeded the amount of reward data on your account (100GB). Please get in touch with IndoSat if you have any queries.","bountyError":"Thank you for your responses {subscriberFirstName}, unfortunately there was an error when attempting to credit your reward. Our tech team have been automatically notified and we apologise for this inconvenience. Please copy and save the link below and try again later.<br/><br/>{campaignUrl}"},"vidio":{"modalHeader":"{brandName} has offered to pay for your subscription","validationError":"There was a validation error. Please check your form!","serverError":"There was an error. Please try again!","recognisedError":"Thank you. Your previous submission has been saved and no further offers are available.","campaignNotActiveError":"There was an error. This campaign is no longer active!","voucherLocation":"(free pass will be sent here)","formAlreadySubmitted":"Sorry you\'ve already submitted the form"},"input":{"select":{"placeholderMulti":"Please select one or more answers","placeholderSingle":"Please select an answer"},"country":{"label":"Country","placeholder":"Select country","required":"Country is required"},"city":{"label":"City","placeholder":"Select city","required":"City is required"},"dateOfBirth":{"label":"Date of birth","placeholder":"Date of birth","required":"Date of birth is required"},"gender":{"label":"Gender","placeholder":"Select your gender","maleOption":"Male","femaleOption":"Female","otherOption":"Other","required":"Gender is required"},"email":{"label":"Email address","placeholder":"Enter email","required":"Email is required","invalid":"Email address is not valid"},"name":{"label":"Name","placeholder":"Enter name"},"firstName":{"label":"First Name","placeholder":"Enter first name","required":"First name is required"},"lastName":{"label":"Last Name","placeholder":"Enter last name","required":"Last name is required"},"phoneNumber":{"required":"Phone number is required","toShort":"Phone number is to short"},"phoneVerification":{"verify":"Verify","placeholder":"Verification code","requestCode":"Request code","requestCodeVia":"Request code via","info":"Please enter the code we sent you","required":"Your phone number must be verified","toShort":"Code should be 4 characters","toLong":"Code can not be longer than 4 characters","failedToSend":"Failed to send, please check your number","invalid":"Code invalid, please try again","failedToVerify":"Failed to verify, please try again","whatsApp":"Whats App","sms":"SMS"},"term":{"defaultTermError":"Please agree to the above terms and conditions","additionalTermError":"Please agree to the above additional term"}},"noinputs":{"message":"We have got everything we need from you! Click the button below to get your offer."}}');
;// CONCATENATED MODULE: ./src/translations/id/common.json
const id_common_namespaceObject = JSON.parse('{"noCreditCardRequired":"(Tidak perlu kartu kredit atau pembayaran apa pun)","postQuestionInitError":"Kami mengalami masalah saat mengambil formulir. Harap periksa apakah Anda masih online dan ","selectNoOptionMessage":"Start typing for options","selectPlaceholder":"Please select one","form":{"tryAgain":"coba lagi","required":"Wajib","toLong":"Karakter yang dimasukkan terlalu panjang","successTitle":"Berhasil","errorTitle":"Terjadi Kesalahan","submitTitle":"Kirim","selectLanguage":"Pilih bahasa","submitData":"Klik untuk menyetujui ketentuan dan persyaratan","subscriptionInfo":"Saya setuju untuk {brandName} menerima data pribadi saya sebagaimana diuraikan dalam <a href=\\"{termsAndConditionsUrl}\\" target=\\"_blank\\" rel=\\"noreferrer\\" style=\\"color: {accentColor}\\">Syarat dan Ketentuan</a> sebagai imbalan karena telah memberikan {productName} dari <a href=\\"{videoProviderUrl}\\" target=\\"_blank\\" style=\\"color: {accentColor}\\"><strong>{videoProviderName}</strong></a> kepada saya"},"successMessage":{"subText":"<strong>{providerName}</strong> is happy to provide you","default":"Terima kasih {subscriberFirstName}, kami telah mengirimkan Email ke {subscriberEmail} dengan rincian Kode Pas & Akses Gratis","phone":"Terima kasih {subscriberFirstName}, kami telah mengirim SMS ke {subscriberPhone} dengan perincian Kode & Akses Gratis Anda.","ctaBackToProvider":"Go to {providerName}","campaignCallback":{"tapBelow":"Tap below to complete your submission with <strong>{providerName}</strong>.","cta":"Continue"}},"indosatMessage":{"success":"Thank you {subscriberFirstName}, your {productName} reward will be credited to your IndoSat account within 24 hours. You will receive a confirmation email when the credit has been applied","invalidPhoneNumber":"Thank you {subscriberFirstName}, in order to credit your {productName} reward to your account you need a valid IndoSat phone number. The number you have entered {subscriberPhone} is not valid. Please get in touch with IndoSat if you have any queries.","expiredPhoneNumber":"Thank you {subscriberFirstName}, in order to credit your {productName} reward to your account you need an active IndoSat phone number. The number you have entered {subscriberPhone} is not valid. Please get in touch with IndoSat if you have any queries.","rewardQuotaExceeded":"Thank you for your responses {subscriberFirstName}, unfortunately there was an error when attempting to credit your reward. You already have exceeded the amount of reward data on your account (100GB). Please get in touch with IndoSat if you have any queries.","bountyError":"Thank you for your responses {subscriberFirstName}, unfortunately there was an error when attempting to credit your reward. Our tech team have been automatically notified and we apologise for this inconvenience. Please copy and save the link below and try again later.<br/><br/>{campaignUrl}"},"vidio":{"modalHeader":"{brandName} menawarkan untuk membayar biaya langganan Anda","validationError":"Terjadi kesalahan validasi. Silakan periksa formulir Anda!","serverError":"Terjadi kesalahan. Silakan coba lagi","recognisedError":"Terima kasih. Kiriman Anda sebelumnya telah disimpan dan tidak ada penawaran lebih lanjut yang tersedia.","campaignNotActiveError":"Terjadi kesalahan. Promosi ini sudah tidak lagi aktif!","voucherLocation":"(pas gratis akan dikirimkan di sini)","formAlreadySubmitted":"Sorry you\'ve already submitted the form"},"input":{"select":{"placeholderMulti":"Silakan pilih satu jawaban atau lebih","placeholderSingle":"Silakan pilih jawaban"},"country":{"label":"Negara","placeholder":"Pilih negara","required":"Negara wajib diisi"},"city":{"label":"Kota","placeholder":"Masukkan nama kota","required":"Nama kota wajib diisi"},"dateOfBirth":{"label":"Usia","placeholder":"Usia","required":"Usia wajib diisi"},"gender":{"label":"Jenis Kelamin","placeholder":"Pilih jenis kelamin Anda","maleOption":"Laki-Laki","femaleOption":"Perempuan","otherOption":"Lainnya","required":"Jenis kelamin wajib diisi"},"email":{"label":"Alamat Email","placeholder":"Masukkan email","required":"Alamat email wajib diisi","invalid":"Alamat email tidak valid"},"name":{"label":"Nama","placeholder":"Masukkan nama"},"firstName":{"label":"Nama depan","placeholder":"Masukkan nama depan","required":"Nama depan wajib diisi"},"lastName":{"label":"Nama belakang","placeholder":"Masukkan nama belakang","required":"Nama belakang wajib diisi"},"phoneNumber":{"required":"Nomor telepon wajib diisi","toShort":"Nomor telepon terlalu pendek"},"phoneVerification":{"verify":"Memeriksa","placeholder":"Kode verifikasi","requestCode":"Kode permintaan","requestCodeVia":"Request code via","info":"Silakan masukkan kode yang kami kirimkan kepada Anda","required":"Nomor telepon Anda harus diverifikasi","toShort":"Kode harus terdiri dari 4 karakter","toLong":"Kode tidak boleh lebih dari 4 karakter","failedToSend":"Pengiriman gagal, harap periksa nomor Anda","invalid":"Kode tidak sah, silakan coba lagi","failedToVerify":"Verifikasi gagal, silakan coba lagi","whatsApp":"Whats App","sms":"SMS"},"term":{"defaultTermError":"Mohon setujui syarat dan ketentuan di atas","additionalTermError":"Mohon setujui persyaratan tambahan di atas"}},"noinputs":{"message":"We have got everything we need from you! Click the button below to get your offer."}}');
;// CONCATENATED MODULE: ./src/translations/my/common.json
const my_common_namespaceObject = JSON.parse('{"noCreditCardRequired":"(Tiada kad kredit atau pembayaran yang diperlukan)","postQuestionInitError":"Kami mendapati masalah mendapatkan borang tersebut.  Sila semak jika anda masih lagi di dalam talian dan ","selectNoOptionMessage":"Start typing for options","selectPlaceholder":"Please select one","form":{"tryAgain":"Cuba sekali lagi","required":"diperlukan","toLong":"Nilai adalah terlalu panjang","successTitle":"Berjaya","errorTitle":"Ralat","submitTitle":"Hantar","selectLanguage":"Pilih bahasa","submitData":"Klik untuk menerma terma dan syarat","subscriptionInfo":"Saya bersetuju untuk {brandName} menerima data peribadi saya seperti yang di gariskan di dalam <a href=\\"{termsAndConditionsUrl}\\" target=\\"_blank\\" rel=\\"noreferrer\\" style=\\"color: {accentColor}\\">Terma dan Syarat</a> Terma dan Syarat {productName} dari <a href=\\"{videoProviderUrl}\\" target=\\"_blank\\" style=\\"color: {accentColor}\\"><strong>{videoProviderName}</strong></a>"},"successMessage":{"subText":"<strong>{providerName}</strong> is happy to provide you","default":"Terima kasih {subscriberFirstName}, emel telah dihantar ke {subscriberEmail} berserta Kod Pas Percuma anda & butiran Akses.","phone":"Terima kasih {subscriberFirstName}, satu SMS telah dihantar ke {subscriberPhone} brsama dengan Kod Pas Percuma anda & butiran Akses.","ctaBackToProvider":"Go to {providerName}","campaignCallback":{"tapBelow":"Tap below to complete your submission with <strong>{providerName}</strong>.","cta":"Continue"}},"indosatMessage":{"success":"Thank you {subscriberFirstName}, your {productName} reward will be credited to your IndoSat account within 24 hours. You will receive a confirmation email when the credit has been applied","invalidPhoneNumber":"Thank you {subscriberFirstName}, in order to credit your {productName} reward to your account you need a valid IndoSat phone number. The number you have entered {subscriberPhone} is not valid. Please get in touch with IndoSat if you have any queries.","expiredPhoneNumber":"Thank you {subscriberFirstName}, in order to credit your {productName} reward to your account you need an active IndoSat phone number. The number you have entered {subscriberPhone} is not valid. Please get in touch with IndoSat if you have any queries.","rewardQuotaExceeded":"Thank you for your responses {subscriberFirstName}, unfortunately there was an error when attempting to credit your reward. You already have exceeded the amount of reward data on your account (100GB). Please get in touch with IndoSat if you have any queries.","bountyError":"Thank you for your responses {subscriberFirstName}, unfortunately there was an error when attempting to credit your reward. Our tech team have been automatically notified and we apologise for this inconvenience. Please copy and save the link below and try again later.<br/><br/>{campaignUrl}"},"vidio":{"modalHeader":"{brandName} telah menawar untuk langganan anda","validationError":"Terdapat ralat validasi.  Sila semak borang anda!","serverError":"Terdapat ralat. Sila cuba sekali lagi!","recognisedError":"Terima kasih, kuota pas premium telah habis digunakan.","campaignNotActiveError":"Terdapat ralat.  Kempen ini tidak lagi aktif!","voucherLocation":"(pas percuma akan dihantarkan ke sini)","formAlreadySubmitted":"Sorry you\'ve already submitted the form"},"input":{"select":{"placeholderMulti":"Sila pilih satu atau lebih jawapan","placeholderSingle":"Sila pilih satu jawapan"},"country":{"label":"Negara","placeholder":"Pilih negara","required":"Negara diperlukan"},"city":{"label":"Bandar","placeholder":"Isikan bandar","required":"Bandar diperlukan"},"dateOfBirth":{"label":"Umur","placeholder":"Umur","required":"Umur diperlukan"},"gender":{"label":"Jantina","placeholder":"Pilih Jantina anda","maleOption":"Lelaki","femaleOption":"Perempuan","otherOption":"Lain","required":"Jantina diperlukan"},"email":{"label":"Alamat emel","placeholder":"Isikan emel","required":"Emel diperlukan","invalid":"Alamat emel tidak sah"},"name":{"label":"Nama","placeholder":"Isikan nama"},"firstName":{"label":"Nama pertama","placeholder":"Isikan nama pertama","required":"Nama Pertama diperlukan"},"lastName":{"label":"Nama terakhir","placeholder":"Isikan nama terakhir","required":"Nama Keluarga diperlukan"},"phoneNumber":{"required":"Nombor telefon diperlukan","toShort":"Nombor telefon adalah terlalu pendek"},"phoneVerification":{"verify":"Sahkan","placeholder":"Kod verifikasi","requestCode":"Kod Permintaan","requestCodeVia":"Request code via","info":"Sila isikan kod yang telah kami hantarkan kepada anda","required":"Nombor telefon anda perlu disahkan","toShort":"Kod adalah 4 karakter","toLong":"Kod tidak boleh melebihi 4 karakter","failedToSend":"Gagal untuk menghantar, sila semak nombor anda","invalid":"Kod tidak sah, sila cuba sekali lagi","failedToVerify":"Gagal untuk mengesahkan, sila cuba sekali lagi","whatsApp":"Whats App","sms":"SMS"},"term":{"defaultTermError":"Sila setuju dengan terma dan syarat di atas","additionalTermError":"Sila setuju dengan terma tambahan di atas"}},"noinputs":{"message":"We have got everything we need from you! Click the button below to get your offer."}}');
;// CONCATENATED MODULE: ./src/translations/th/common.json
const th_common_namespaceObject = JSON.parse('{"noCreditCardRequired":"(ไม่ต้องการเครดิตการ์ดและไม่มีค่าใช้จ่าย)","postQuestionInitError":"เรามีปัญหาในการเรืยกคืนแบบฟอร์ม โปรดตรวจสอบว่าคุณยังคงออนไลน์อยู่หรือไม่ และ ","selectNoOptionMessage":"เริ่มพิมพ์เพื่อดูตัวเลือก","selectPlaceholder":"พิมพ์ชื่อจังหวัดเป็นภาษาไทย","form":{"tryAgain":"ลองอีกครั้ง","required":"ของคุณ","toLong":"ข้อมูลยาวเกินไป","successTitle":"สำเร็จ","errorTitle":"ผิดพลาด","submitTitle":"ส่ง","selectLanguage":"เลือกภาษา","submitData":"คลิกเพื่อยอมรับข้อตกลงและเงื่อนไข","subscriptionInfo":"ข้าพเจ้ายินยอมให้ {brandName} รับข้อมูลส่วนบุคคลของข้าพเจ้า ตามที่ระบุไว้ใน <a href=\\"{termsAndConditionsUrl}\\" target=\\"_blank\\" rel=\\"noreferrer\\" style=\\"color: {accentColor}\\">ข้อกำหนดและเงื่อนไข</a> สำหรับการแลกเปลี่ยนกับ {productName} โดย {videoProviderName}"},"successMessage":{"subText":"<strong>{providerName}</strong> is happy to provide you","default":"ขอบคุณ {subscriberFirstName},  รหัสผ่านเพื่อใช้งานฟรีและรายละเอียดการเข้าใช้บริการได้ถูกส่งไปทางอีเมลที่ {subscriberEmail}.","phone":"ขอบคุณ คุณ {subscriberFirstName} ที่ร่วมตอบแบบสอบถาม คุณจะได้รับรหัสแลก {productName} ทาง SMS ที่โทรศัพท์หมายเลข {subscriberPhone}","ctaBackToProvider":"Go to {providerName}","campaignCallback":{"tapBelow":"Tap below to complete your submission with <strong>{providerName}</strong>.","cta":"Continue"}},"indosatMessage":{"success":"Thank you {subscriberFirstName}, your {productName} reward will be credited to your IndoSat account within 24 hours. You will receive a confirmation email when the credit has been applied","invalidPhoneNumber":"Thank you {subscriberFirstName}, in order to credit your {productName} reward to your account you need a valid IndoSat phone number. The number you have entered {subscriberPhone} is not valid. Please get in touch with IndoSat if you have any queries.","expiredPhoneNumber":"Thank you {subscriberFirstName}, in order to credit your {productName} reward to your account you need an active IndoSat phone number. The number you have entered {subscriberPhone} is not valid. Please get in touch with IndoSat if you have any queries.","rewardQuotaExceeded":"Thank you for your responses {subscriberFirstName}, unfortunately there was an error when attempting to credit your reward. You already have exceeded the amount of reward data on your account (100GB). Please get in touch with IndoSat if you have any queries.","bountyError":"Thank you for your responses {subscriberFirstName}, unfortunately there was an error when attempting to credit your reward. Our tech team have been automatically notified and we apologise for this inconvenience. Please copy and save the link below and try again later.<br/><br/>{campaignUrl}"},"vidio":{"modalHeader":"{brandName} เสนอที่จะชำระค่าบริการให้แก่ท่าน","validationError":"การตรวจสอบข้อมูลผิดพลาด โปรดตรวจสอบแบบฟอร์ม!","serverError":"มีข้อผิดพลาด โปรดลองอีกครั้ง!","recognisedError":"ขอบคุณ การส่งเรื่องครั้งก่อนของคุณได้รับการบันทึกไว้แล้ว และยังไม่มีข้อเสนออื่นใดเพิ่มเติม","campaignNotActiveError":"มี่ข้อผิดพลาด แคมเปญนี้หมดอายุลงแล้ว!","voucherLocation":"(รหัสผ่านจะถูกส่งไปยังที่อยู่นี้)","formAlreadySubmitted":"Sorry you\'ve already submitted the form"},"input":{"select":{"placeholderMulti":"โปรดเลือกหนึ่งคำตอบขึ้นไป","placeholderSingle":"โปรดเลือกคำตอบ"},"country":{"label":"ประเทศ","placeholder":"เลือกประเทศ","required":"ต้องระบุประเทศ"},"city":{"label":"จังหวัด","placeholder":"จังหวัดที่พักอาศัย (พิมพ์ชื่อจังหวัดเป็นภาษาอังกฤษ)","required":"ต้องระบุจังหวัด"},"dateOfBirth":{"label":"อายุ","placeholder":"อายุ","required":"ต้องระบุอายุ"},"gender":{"label":"เพศ","placeholder":"ระบุเพศของท่าน","maleOption":"ชาย","femaleOption":"หญิง","otherOption":"อื่น","required":"ต้องระบุเพศ"},"email":{"label":"ที่อยู่อีเมล","placeholder":"ระบุอีเมล","required":"ต้องระบุอีเมล","invalid":"ที่อยู่อีเมลไม่ถูกต้อง"},"name":{"label":"ชื่อนามสกุล","placeholder":"ระบุชื่อนามสกุล"},"firstName":{"label":"ชื่อ","placeholder":"ระบุชื่อ","required":"ต้องระบุชื่อต้น"},"lastName":{"label":"นามสกุล","placeholder":"ระบุนามสกุล","required":"ต้องระบุนามสกุล"},"phoneNumber":{"required":"ต้องระบุหมายเลขโทรศัพท์","toShort":"หมายเลขโทรศัพท์สั้นเกินไป"},"phoneVerification":{"verify":"ตรวจสอบ","placeholder":"รหัสยืนยัน","requestCode":"ต้องการรหัส","requestCodeVia":"Request code via","info":"โปรดใส่รหัสที่เราได้ส่งให้ท่าน","required":"จำเป็นต้องยืนยันหมายเลขโทรศัพท์","toShort":"รหัสควรมี 4 หลัก","toLong":"รหัสจะยาวกว่า 4 หลักไม่ได้","failedToSend":"ส่งไม่สำเร็จ กรุณาตรวจสอบหมายเลขของคุณ","invalid":"รหัสไม่ถูกต้อง โปรดลองอีกครั้ง","failedToVerify":"ตรวจสอบไม่ได้ โปรดลองอีกครั้ง","whatsApp":"Whats App","sms":"SMS"},"term":{"defaultTermError":"โปรดยอมรับข้อกำหนดและเงื่อนไขข้างต้น","additionalTermError":"โปรดยอมรับข้อกำหนดเพิ่มเติมข้างต้น"}},"noinputs":{"message":"เราได้ข้อมูลครบถ้วนแล้ว! คลิกปุ่มด้านล่างเพื่อรับข้อเสนอของคุณ"}}');
;// CONCATENATED MODULE: ./src/shared/defaultTransFunction.js






var translations = {
  en: common_namespaceObject,
  id: id_common_namespaceObject,
  my: my_common_namespaceObject,
  th: th_common_namespaceObject
};
var fallbackLanguage = 'en';

/*
 * Used to find translations that can be nested such as:
 * 'input.gender.placeholder'
 */
var getTranslation = function getTranslation(key, language) {
  var _translations$languag, _dictionary$language;
  var dictionary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var originalSource = (_translations$languag = translations === null || translations === void 0 ? void 0 : translations[language]) !== null && _translations$languag !== void 0 ? _translations$languag : {};

  // _merge will mutate the source
  var _translations = merge_default()(originalSource, (_dictionary$language = dictionary === null || dictionary === void 0 ? void 0 : dictionary[language]) !== null && _dictionary$language !== void 0 ? _dictionary$language : {});
  return get_default()(_translations, key) || false;
};

/**
 * @param {*} key Translation key eg. 'fridge'
 * @param {*} language Language key eg. 'en'
 * @param {*} context Direct text replacement for any key
 * @param {*} dictionary Dynamic dictionary from BE
 * @returns
 */
var trans = function trans(key) {
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : fallbackLanguage;
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var dictionary = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var translation = getTranslation(key, language, dictionary);
  var resultText;
  if (translation) {
    resultText = translation;
  } else {
    console.error("Key \"".concat(key, "\" not found in \"").concat(language, "\" translations"));
    resultText = getTranslation(key, fallbackLanguage) || key;
  }
  if (context) {
    Object.keys(context).forEach(replaceKey => {
      var replacer = new RegExp("{".concat(replaceKey, "}"), 'g');
      resultText = resultText.replace(replacer, context[replaceKey]);
    });
  }
  return resultText;
};
/* harmony default export */ const defaultTransFunction = (trans);
;// CONCATENATED MODULE: ./src/components/VidioSection/VidioElements/VidioFormHeader.js



var VidioFormHeader = _ref => {
  var {
    formState,
    brandName,
    brandLogoUrl,
    language,
    rounded = true,
    fullWidth = false,
    isPhoneRequired,
    paywallBannerUrl = ''
  } = _ref;
  var isInlineFormat = !!fullWidth;
  var showBanner = (brandLogoUrl || paywallBannerUrl) && (!formState || isInlineFormat);
  if (showBanner) {
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, paywallBannerUrl && /*#__PURE__*/external_react_default().createElement((Image_default()), {
      "data-test-id": "modal-paywall-banner",
      src: paywallBannerUrl,
      alt: "".concat(brandName, " banner"),
      fluid: true,
      rounded: rounded,
      className: fullWidth ? 'w-100 mb-3' : 'mb-3'
    }), brandLogoUrl && /*#__PURE__*/external_react_default().createElement((Image_default()), {
      "data-test-id": "modal-brand-log",
      src: brandLogoUrl,
      alt: "".concat(brandName, " logo"),
      fluid: true,
      rounded: rounded,
      className: fullWidth ? 'w-100' : ''
    }));
  }
  if (formState && !isPhoneRequired) {
    return /*#__PURE__*/external_react_default().createElement("div", null, formState.success ? defaultTransFunction('form.successTitle', language) : defaultTransFunction('form.errorTitle', language));
  }
  if (formState !== null && formState !== void 0 && formState.error && isPhoneRequired) {
    return /*#__PURE__*/external_react_default().createElement("div", null, defaultTransFunction('form.errorTitle', language));
  }
  return null;
};
/* harmony default export */ const VidioElements_VidioFormHeader = (VidioFormHeader);
// EXTERNAL MODULE: ./src/components/VidioSection/PostQuestionCategories/PostQuestionCategories.js + 1 modules
var PostQuestionCategories = __webpack_require__(457);
// EXTERNAL MODULE: external "react-bootstrap/Button"
var Button_ = __webpack_require__(937);
var Button_default = /*#__PURE__*/__webpack_require__.n(Button_);
;// CONCATENATED MODULE: ./src/components/UI/Spinner.js

var Spinner = () => {
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "spinner-grow spinner-grow-sm text-light",
    role: "status"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "sr-only"
  }, "Loading..."));
};
/* harmony default export */ const UI_Spinner = (Spinner);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/UI/Button/Button.module.scss
var Button_module = __webpack_require__(706);
;// CONCATENATED MODULE: ./src/components/UI/Button/Button.module.scss

      var Button_module_exported = {};

      
      
      
      
      
      
      
      
      if (Button_module/* default */.Z && Button_module/* default.locals */.Z.locals) {
              Button_module_exported.locals = Button_module/* default.locals */.Z.locals;
            }
            

var Button_module_refs = 0;
var Button_module_update;
var Button_module_options = {};

Button_module_options.styleTagTransform = (styleTagTransform_default());
Button_module_options.setAttributes = (setAttributesWithoutAttributes_default());

      Button_module_options.insert = insertBySelector_default().bind(null, "head");
    
Button_module_options.domAPI = (styleDomAPI_default());
Button_module_options.insertStyleElement = (insertStyleElement_default());

Button_module_exported.use = function(insertOptions) {
  Button_module_options.options = insertOptions || {};

  if (!(Button_module_refs++)) {
    Button_module_update = injectStylesIntoStyleTag_default()(Button_module/* default */.Z, Button_module_options);
  }

  return Button_module_exported;
};
Button_module_exported.unuse = function() {
  if (Button_module_refs > 0 && !--Button_module_refs) {
    Button_module_update();
    Button_module_update = null;
  }
};




       /* harmony default export */ const Button_Button_module = (Button_module_exported);

;// CONCATENATED MODULE: ./src/components/UI/Button/Button.js




var UIButton = _ref => {
  var {
    children,
    className = '',
    style = {},
    variant = 'primary',
    isLoading = false,
    disabled = false,
    onClick: _onClick = () => {}
  } = _ref;
  var classes = Button_Button_module.locals || {};
  (0,external_react_.useEffect)(() => {
    Button_Button_module.use();
  }, []);
  return /*#__PURE__*/external_react_default().createElement((Button_default()), {
    variant: variant,
    className: "".concat(className, " ").concat(classes[variant], " ").concat(disabled ? "".concat(classes.disabled) : ""),
    disabled: disabled !== null && disabled !== void 0 ? disabled : false,
    onClick: e => !disabled && _onClick(e),
    style: style
  }, isLoading ? /*#__PURE__*/external_react_default().createElement(UI_Spinner, null) : children);
};
/* harmony default export */ const Button = (UIButton);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/Form/Form.module.scss
var Form_module = __webpack_require__(547);
;// CONCATENATED MODULE: ./src/components/Form/Form.module.scss

      var Form_module_exported = {};

      
      
      
      
      
      
      
      
      if (Form_module/* default */.Z && Form_module/* default.locals */.Z.locals) {
              Form_module_exported.locals = Form_module/* default.locals */.Z.locals;
            }
            

var Form_module_refs = 0;
var Form_module_update;
var Form_module_options = {};

Form_module_options.styleTagTransform = (styleTagTransform_default());
Form_module_options.setAttributes = (setAttributesWithoutAttributes_default());

      Form_module_options.insert = insertBySelector_default().bind(null, "head");
    
Form_module_options.domAPI = (styleDomAPI_default());
Form_module_options.insertStyleElement = (insertStyleElement_default());

Form_module_exported.use = function(insertOptions) {
  Form_module_options.options = insertOptions || {};

  if (!(Form_module_refs++)) {
    Form_module_update = injectStylesIntoStyleTag_default()(Form_module/* default */.Z, Form_module_options);
  }

  return Form_module_exported;
};
Form_module_exported.unuse = function() {
  if (Form_module_refs > 0 && !--Form_module_refs) {
    Form_module_update();
    Form_module_update = null;
  }
};




       /* harmony default export */ const Form_Form_module = (Form_module_exported);

;// CONCATENATED MODULE: ./src/providers/Translation.provider.js

/* harmony default export */ const Translation_provider = (/*#__PURE__*/(0,external_react_.createContext)(null));
;// CONCATENATED MODULE: ./src/components/Translate.js





/**
 * HTML support cannot be 'true' as
 *  default, otherwise elements such as
 *  buttons, labels and input placeholders
 *  can break if html is passed in
 */
var Translate = _ref => {
  var {
    langKey,
    language,
    context = null,
    htmlSupport = false
  } = _ref;
  var dictionary = (0,external_react_.useContext)(Translation_provider);
  var translation = defaultTransFunction(langKey, language, context, dictionary);
  if (htmlSupport) {
    return /*#__PURE__*/external_react_default().createElement("span", null, htmlParse(translation));
  }
  return /*#__PURE__*/external_react_default().createElement("span", null, translation);
};
/* harmony default export */ const components_Translate = (Translate);
;// CONCATENATED MODULE: ./src/components/VidioSection/VidioElements/VidioFormBody.js







var VidioFormBody = _ref => {
  var _videoProvider$transl, _providerTranslations, _formState$provider;
  var {
    children,
    formState,
    brandName,
    videoProvider,
    successType,
    PhaseHeader,
    additionalResponse,
    videoProviderUrl,
    campaignUrl,
    onCategorySelect,
    language,
    isModal = false,
    color = '#000000',
    baseImageUrl = '',
    onPostConnectCategorySubmitted,
    submittedCategoryIds,
    userInfo = {}
  } = _ref;
  var classes = Form_Form_module.locals || {};
  (0,external_react_.useEffect)(() => {
    Form_Form_module.use();
  }, []);
  var showPQCategories = !!(formState !== null && formState !== void 0 && formState.postQuestions);
  var showError = additionalResponse || (formState === null || formState === void 0 ? void 0 : formState.message);
  var providerTranslations = (_videoProvider$transl = videoProvider.translations) === null || _videoProvider$transl === void 0 ? void 0 : _videoProvider$transl[language];
  var providerName = (_providerTranslations = providerTranslations === null || providerTranslations === void 0 ? void 0 : providerTranslations.name) !== null && _providerTranslations !== void 0 ? _providerTranslations : formState === null || formState === void 0 ? void 0 : (_formState$provider = formState.provider) === null || _formState$provider === void 0 ? void 0 : _formState$provider.name;
  if (formState !== null && formState !== void 0 && formState.success) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: classes.formOuter
    }, PhaseHeader ? /*#__PURE__*/external_react_default().createElement(PhaseHeader, {
      success: true,
      successType: successType
    }) : null, /*#__PURE__*/external_react_default().createElement(SuccessMessage, {
      type: successType,
      language: language,
      formState: formState,
      color: color,
      videoProvider: videoProvider,
      userInfo: userInfo
    }), showPQCategories ? /*#__PURE__*/external_react_default().createElement(PostQuestionCategories["default"], {
      postQuestions: formState.postQuestions,
      language: language,
      color: color,
      onCategorySelect: onCategorySelect,
      isModal: isModal,
      baseImageUrl: baseImageUrl,
      onPostConnectCategorySubmitted: onPostConnectCategorySubmitted,
      submittedCategoryIds: submittedCategoryIds
    }) : null, /*#__PURE__*/external_react_default().createElement(CampaignCallback, {
      language: language,
      formState: formState,
      providerName: providerName,
      color: color
    }));
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: classes.formOuter
  }, showError && /*#__PURE__*/external_react_default().createElement("div", {
    style: {
      color
    },
    className: "mt-2"
  }, /*#__PURE__*/external_react_default().createElement("div", null, formState !== null && formState !== void 0 && formState.message ? /*#__PURE__*/external_react_default().createElement("div", {
    className: "text-danger mb-0"
  }, htmlParse(formState.message)) : null, additionalResponse && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("a", {
    href: videoProviderUrl,
    target: "_blank",
    rel: "noreferrer"
  }, videoProvider), /*#__PURE__*/external_react_default().createElement("a", {
    href: campaignUrl,
    target: "_blank",
    rel: "noreferrer"
  }, brandName)))), formState !== null && formState !== void 0 && formState.hideForm ? null : /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, children));
};
var SuccessMessage = _ref2 => {
  var _formState$provider2, _videoProvider$transl2, _providerTranslations2, _formState$provider3, _providerTranslations3, _formState$provider4;
  var {
    type,
    language,
    formState,
    userInfo,
    videoProvider
  } = _ref2;
  var languageKey = null;
  var isProviderOfTypeAR = (formState === null || formState === void 0 ? void 0 : (_formState$provider2 = formState.provider) === null || _formState$provider2 === void 0 ? void 0 : _formState$provider2.productType) === 'automaticRedemption';
  if (!isProviderOfTypeAR) {
    languageKey = type === 'sms' ? 'successMessage.phone' : 'successMessage.default';
  } else {
    languageKey = 'indosatMessage.success';
  }
  var getUserData = key => {
    var _formState$subscriber;
    return (formState === null || formState === void 0 ? void 0 : (_formState$subscriber = formState.subscriber) === null || _formState$subscriber === void 0 ? void 0 : _formState$subscriber[key]) || (userInfo === null || userInfo === void 0 ? void 0 : userInfo[key]) || '';
  };
  var subscriberFirstName = getUserData('firstName');
  var subscriberEmail = getUserData('email');
  var subscriberPhone = getUserData('phoneNumber');
  var providerTranslations = (_videoProvider$transl2 = videoProvider.translations) === null || _videoProvider$transl2 === void 0 ? void 0 : _videoProvider$transl2[language];
  var productName = (_providerTranslations2 = providerTranslations === null || providerTranslations === void 0 ? void 0 : providerTranslations.productName) !== null && _providerTranslations2 !== void 0 ? _providerTranslations2 : formState === null || formState === void 0 ? void 0 : (_formState$provider3 = formState.provider) === null || _formState$provider3 === void 0 ? void 0 : _formState$provider3.productName;
  var providerName = (_providerTranslations3 = providerTranslations === null || providerTranslations === void 0 ? void 0 : providerTranslations.name) !== null && _providerTranslations3 !== void 0 ? _providerTranslations3 : formState === null || formState === void 0 ? void 0 : (_formState$provider4 = formState.provider) === null || _formState$provider4 === void 0 ? void 0 : _formState$provider4.name;
  return (
    /*#__PURE__*/
    // Color must be black within the white form container
    external_react_default().createElement("div", {
      style: {
        color: '#000'
      }
    }, providerName && productName ? /*#__PURE__*/external_react_default().createElement("p", {
      className: "text-center"
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "d-inline-block pb-3 border-bottom"
    }, /*#__PURE__*/external_react_default().createElement(components_Translate, {
      langKey: "successMessage.subText",
      language: language,
      context: {
        providerName
      },
      htmlSupport: true
    }), /*#__PURE__*/external_react_default().createElement("br", null), productName)) : null, /*#__PURE__*/external_react_default().createElement("p", {
      className: "text-center"
    }, /*#__PURE__*/external_react_default().createElement(components_Translate, {
      langKey: languageKey,
      language: language,
      context: {
        subscriberFirstName,
        subscriberEmail,
        productName,
        subscriberPhone
      },
      htmlSupport: true
    })))
  );
};
var CampaignCallback = _ref3 => {
  var _formState$callback;
  var {
    language,
    formState,
    providerName,
    color
  } = _ref3;
  var isCallbackEnabled = !!((_formState$callback = formState.callback) !== null && _formState$callback !== void 0 && _formState$callback.enabled);
  var openCallbackUrl = () => {
    window.open(formState.callback.redirectTo);
  };
  if (!isCallbackEnabled) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "text-center"
    }, /*#__PURE__*/external_react_default().createElement(Button, {
      className: "btn-lg my-0 mx-0",
      style: {
        backgroundColor: color,
        outlineColor: color,
        borderColor: color,
        textTransform: 'none'
      },
      onClick: () => {
        window.location = 'https://www.bounty.media/';
      }
    }, /*#__PURE__*/external_react_default().createElement(components_Translate, {
      langKey: "successMessage.ctaBackToProvider",
      language: language,
      context: {
        providerName
      }
    })));
  }
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", {
    className: "text-center"
  }, /*#__PURE__*/external_react_default().createElement(components_Translate, {
    langKey: "successMessage.campaignCallback.tapBelow",
    language: language,
    context: {
      providerName: formState.provider.name
    },
    htmlSupport: true
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/external_react_default().createElement(Button, {
    className: "btn-lg my-0 mx-0",
    style: {
      backgroundColor: color,
      outlineColor: color,
      borderColor: color
    },
    onClick: openCallbackUrl
  }, /*#__PURE__*/external_react_default().createElement(components_Translate, {
    langKey: "successMessage.campaignCallback.cta",
    language: language
  }))));
};
/* harmony default export */ const VidioElements_VidioFormBody = (VidioFormBody);
;// CONCATENATED MODULE: ./src/components/VidioSection/VidioModal/VidioModal.js





var VidioModal = _ref => {
  var {
    accentColor,
    children,
    formState,
    additionalResponse,
    onHideModal,
    brandName,
    brandLogoUrl,
    baseImageUrl = '',
    successType,
    videoProvider,
    serviceAvailability,
    termsAndConditionsUrl,
    campaignUrl,
    videoProviderUrl,
    language,
    isPhoneRequired,
    onCategorySelect,
    previewMode = false,
    paywallBannerUrl,
    userInfo,
    PhaseHeader
  } = _ref;
  var classes = VidioModal_VidioModal_module.locals || {};
  (0,external_react_.useEffect)(() => {
    VidioModal_VidioModal_module.use();
  }, []);
  var backdropState = previewMode ? true : 'static';
  return /*#__PURE__*/external_react_default().createElement((Modal_default()), {
    show: true,
    centered: true,
    backdrop: backdropState,
    keyboard: false,
    className: classes.defaultVidioModal,
    onHide: onHideModal
  }, /*#__PURE__*/external_react_default().createElement((Modal_default()).Header, {
    style: {
      backgroundColor: accentColor
    },
    closeButton: true
  }, /*#__PURE__*/external_react_default().createElement((Modal_default()).Title, null, /*#__PURE__*/external_react_default().createElement(VidioElements_VidioFormHeader, {
    formState: formState,
    brandName: brandName,
    brandLogoUrl: brandLogoUrl,
    language: language,
    isPhoneRequired: isPhoneRequired,
    paywallBannerUrl: paywallBannerUrl
  }))), /*#__PURE__*/external_react_default().createElement((Modal_default()).Body, null, /*#__PURE__*/external_react_default().createElement(VidioElements_VidioFormBody, {
    formState: formState,
    termsAndConditionsUrl: termsAndConditionsUrl,
    serviceAvailability: serviceAvailability,
    videoProvider: videoProvider,
    additionalResponse: additionalResponse,
    videoProviderUrl: videoProviderUrl,
    campaignUrl: campaignUrl,
    brandName: brandName,
    successType: successType,
    onHideModal: onHideModal,
    language: language,
    accentColor: accentColor,
    color: accentColor,
    isPhoneRequired: isPhoneRequired,
    onCategorySelect: onCategorySelect,
    baseImageUrl: baseImageUrl,
    isModal: true,
    userInfo: userInfo,
    PhaseHeader: PhaseHeader
  }, children)));
};
/* harmony default export */ const VidioModal_VidioModal = (VidioModal);
;// CONCATENATED MODULE: external "react-bootstrap/Form"
const Form_namespaceObject = require("react-bootstrap/Form");
var Form_default = /*#__PURE__*/__webpack_require__.n(Form_namespaceObject);
;// CONCATENATED MODULE: external "react-bootstrap/Alert"
const Alert_namespaceObject = require("react-bootstrap/Alert");
var Alert_default = /*#__PURE__*/__webpack_require__.n(Alert_namespaceObject);
;// CONCATENATED MODULE: external "react-phone-input-2"
const external_react_phone_input_2_namespaceObject = require("react-phone-input-2");
var external_react_phone_input_2_default = /*#__PURE__*/__webpack_require__.n(external_react_phone_input_2_namespaceObject);
;// CONCATENATED MODULE: external "formik"
const external_formik_namespaceObject = require("formik");
;// CONCATENATED MODULE: external "yup"
const external_yup_namespaceObject = require("yup");
;// CONCATENATED MODULE: ./src/components/Form/Form.hooks.js
function Form_hooks_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Form_hooks_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Form_hooks_ownKeys(Object(source), !0).forEach(function (key) { Form_hooks_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Form_hooks_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Form_hooks_defineProperty(obj, key, value) { key = Form_hooks_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function Form_hooks_toPropertyKey(arg) { var key = Form_hooks_toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function Form_hooks_toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }


var axiosDefaults = {
  method: 'post',
  language: 'en'
};
var useAxiosRequest = function useAxiosRequest(url) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!url) {
    // Not thrown due to Dashboard-UI preview mode not providing URL
    // console.warn('(useAxiosRequest) url is required'); // Too chatty due to re-render
  }
  var [isFetching, setFetching] = (0,external_react_.useState)(false);
  var [isSuccess, setSuccess] = (0,external_react_.useState)(false);
  var [isError, setError] = (0,external_react_.useState)(false);
  var [data, setData] = (0,external_react_.useState)(null);
  var config = Form_hooks_objectSpread(Form_hooks_objectSpread({}, axiosDefaults), opts);
  var createRequest = payload => {
    setFetching(true);
    return (external_axios_default())[config.method](url, payload, {
      headers: {
        'x-language': config.language
      }
    }).then(response => {
      setData(response.data);
      setSuccess(true);
      setError(false);
      return response.data;
    }).catch(error => {
      setSuccess(false);
      setError(true);
      // eslint-disable-next-line no-console
      console.error(error);
    }).finally(() => {
      setFetching(false);
    });
  };
  return [createRequest, {
    isFetching,
    isSuccess,
    isError,
    data
  }];
};
/* harmony default export */ const Form_hooks = (useAxiosRequest);
;// CONCATENATED MODULE: external "react-select"
const external_react_select_namespaceObject = require("react-select");
var external_react_select_default = /*#__PURE__*/__webpack_require__.n(external_react_select_namespaceObject);
;// CONCATENATED MODULE: ./src/shared/reactSelect.style.js
function reactSelect_style_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function reactSelect_style_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? reactSelect_style_ownKeys(Object(source), !0).forEach(function (key) { reactSelect_style_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : reactSelect_style_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function reactSelect_style_defineProperty(obj, key, value) { key = reactSelect_style_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function reactSelect_style_toPropertyKey(arg) { var key = reactSelect_style_toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function reactSelect_style_toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var reactSelectStyle = {
  control: baseStyles => reactSelect_style_objectSpread(reactSelect_style_objectSpread({}, baseStyles), {}, {
    borderRadius: 10
  }),
  valueContainer: baseStyles => reactSelect_style_objectSpread(reactSelect_style_objectSpread({}, baseStyles), {}, {
    paddingTop: 8,
    paddingBottom: 8,
    paddingRight: 16,
    paddingLeft: 16
  })
};
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/Form/FormInput/FormInput.module.scss
var FormInput_module = __webpack_require__(904);
;// CONCATENATED MODULE: ./src/components/Form/FormInput/FormInput.module.scss

      var FormInput_module_exported = {};

      
      
      
      
      
      
      
      
      if (FormInput_module/* default */.Z && FormInput_module/* default.locals */.Z.locals) {
              FormInput_module_exported.locals = FormInput_module/* default.locals */.Z.locals;
            }
            

var FormInput_module_refs = 0;
var FormInput_module_update;
var FormInput_module_options = {};

FormInput_module_options.styleTagTransform = (styleTagTransform_default());
FormInput_module_options.setAttributes = (setAttributesWithoutAttributes_default());

      FormInput_module_options.insert = insertBySelector_default().bind(null, "head");
    
FormInput_module_options.domAPI = (styleDomAPI_default());
FormInput_module_options.insertStyleElement = (insertStyleElement_default());

FormInput_module_exported.use = function(insertOptions) {
  FormInput_module_options.options = insertOptions || {};

  if (!(FormInput_module_refs++)) {
    FormInput_module_update = injectStylesIntoStyleTag_default()(FormInput_module/* default */.Z, FormInput_module_options);
  }

  return FormInput_module_exported;
};
FormInput_module_exported.unuse = function() {
  if (FormInput_module_refs > 0 && !--FormInput_module_refs) {
    FormInput_module_update();
    FormInput_module_update = null;
  }
};




       /* harmony default export */ const FormInput_FormInput_module = (FormInput_module_exported);

;// CONCATENATED MODULE: ./src/components/Form/FormInput/FormInput.js
var _excluded = ["name", "label", "text", "required", "errors", "type", "placeholder", "answers", "onInputChangeHandler", "maxLength", "controlId", "color", "disabled", "isInvalid", "isMulti", "value", "hideLabel"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var FormInput = _ref => {
  var {
      name,
      label,
      text,
      required = false,
      errors,
      type = 'text',
      placeholder = '',
      answers = [],
      onInputChangeHandler,
      maxLength,
      controlId,
      color = '#000000',
      disabled,
      isInvalid,
      isMulti,
      value,
      hideLabel
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var classes = FormInput_FormInput_module.locals || {};
  (0,external_react_.useEffect)(() => {
    FormInput_FormInput_module.use();
  }, []);
  var inputElement = () => {
    if (answers && answers.length > 0) {
      var formattedAnswers = answers.map(answer => {
        return typeof answer === 'object' ? answer : {
          value: answer,
          label: answer
        };
      });
      var selectValue = () => {
        var returnvalue = typeof value === 'object' && !isMulti ? value : formattedAnswers.find(option => option.value === value);
        return returnvalue;
      };
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement((external_react_select_default()), _extends({
        inputId: controlId || "formCustom".concat(name),
        isMulti: isMulti,
        className: "custom-form-control ".concat(classes.formSelectText, " ").concat(isInvalid ? "".concat(classes.customSelectError, " is-invalid") : ''),
        onChange: onInputChangeHandler,
        options: formattedAnswers,
        isDisabled: disabled,
        name: name,
        "data-testid": name,
        value: selectValue(),
        placeholder: placeholder || "Please select ".concat(isMulti ? 'one or more answers' : 'an answer'),
        styles: reactSelectStyle
      }, otherProps)), /*#__PURE__*/external_react_default().createElement("div", {
        className: "invalid-feedback ".concat(isInvalid ? 'd-block' : ''),
        "data-testid": "form-error"
      }, errors || "".concat(label, " is required.")));
    }
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement((Form_default()).Control, _extends({
      required: required,
      name: name,
      "data-testid": name,
      type: type,
      placeholder: placeholder,
      onChange: onInputChangeHandler,
      maxLength: maxLength,
      disabled: disabled,
      isInvalid: isInvalid,
      value: value
    }, otherProps)), /*#__PURE__*/external_react_default().createElement((Form_default()).Control.Feedback, {
      type: "invalid",
      "data-testid": "form-error"
    }, errors || "".concat(label, " is required.")));
  };
  return /*#__PURE__*/external_react_default().createElement((Form_default()).Group, {
    controlId: controlId || "formCustom".concat(name),
    className: "mb-3"
  }, label && /*#__PURE__*/external_react_default().createElement((Form_default()).Label, {
    className: hideLabel ? classes.visuallyHidden : ''
  }, label), inputElement(), text && /*#__PURE__*/external_react_default().createElement((Form_default()).Text, {
    style: {
      color,
      opacity: '.6'
    }
  }, text));
};
/* harmony default export */ const FormInput_FormInput = (FormInput);
;// CONCATENATED MODULE: external "react-bootstrap"
const external_react_bootstrap_namespaceObject = require("react-bootstrap");
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/Form/FormCheckbox/FormCheckbox.module.scss
var FormCheckbox_module = __webpack_require__(459);
;// CONCATENATED MODULE: ./src/components/Form/FormCheckbox/FormCheckbox.module.scss

      var FormCheckbox_module_exported = {};

      
      
      
      
      
      
      
      
      if (FormCheckbox_module/* default */.Z && FormCheckbox_module/* default.locals */.Z.locals) {
              FormCheckbox_module_exported.locals = FormCheckbox_module/* default.locals */.Z.locals;
            }
            

var FormCheckbox_module_refs = 0;
var FormCheckbox_module_update;
var FormCheckbox_module_options = {};

FormCheckbox_module_options.styleTagTransform = (styleTagTransform_default());
FormCheckbox_module_options.setAttributes = (setAttributesWithoutAttributes_default());

      FormCheckbox_module_options.insert = insertBySelector_default().bind(null, "head");
    
FormCheckbox_module_options.domAPI = (styleDomAPI_default());
FormCheckbox_module_options.insertStyleElement = (insertStyleElement_default());

FormCheckbox_module_exported.use = function(insertOptions) {
  FormCheckbox_module_options.options = insertOptions || {};

  if (!(FormCheckbox_module_refs++)) {
    FormCheckbox_module_update = injectStylesIntoStyleTag_default()(FormCheckbox_module/* default */.Z, FormCheckbox_module_options);
  }

  return FormCheckbox_module_exported;
};
FormCheckbox_module_exported.unuse = function() {
  if (FormCheckbox_module_refs > 0 && !--FormCheckbox_module_refs) {
    FormCheckbox_module_update();
    FormCheckbox_module_update = null;
  }
};




       /* harmony default export */ const FormCheckbox_FormCheckbox_module = (FormCheckbox_module_exported);

;// CONCATENATED MODULE: ./src/components/Form/FormCheckbox/FormCheckbox.js




var Checkbox = _ref => {
  var {
    name,
    label,
    required = false,
    errors,
    onInputChangeHandler,
    controlId,
    isInvalid,
    useHtmlLabel = false
  } = _ref;
  var classes = FormCheckbox_FormCheckbox_module.locals || {};
  (0,external_react_.useEffect)(() => {
    FormCheckbox_FormCheckbox_module.use();
  }, []);
  var parserConfig = useHtmlLabel ? {
    ADD_ATTR: ['target']
  } : null;
  var labelIsReactEl = /*#__PURE__*/external_react_default().isValidElement(label);
  return /*#__PURE__*/external_react_default().createElement(external_react_bootstrap_namespaceObject.Form.Group, {
    className: classes.checkbox
  }, /*#__PURE__*/external_react_default().createElement(external_react_bootstrap_namespaceObject.Form.Check, {
    type: "checkbox",
    id: controlId || "formCustom".concat(name),
    name: name
  }, /*#__PURE__*/external_react_default().createElement(external_react_bootstrap_namespaceObject.Form.Check.Input, {
    type: "checkbox",
    name: name,
    "data-testid": name,
    required: required,
    isInvalid: isInvalid,
    onChange: onInputChangeHandler
  }), /*#__PURE__*/external_react_default().createElement(external_react_bootstrap_namespaceObject.Form.Check.Label, null, /*#__PURE__*/external_react_default().createElement("p", {
    className: classes.label
  }, labelIsReactEl ? label : htmlParse(label, parserConfig))), /*#__PURE__*/external_react_default().createElement(external_react_bootstrap_namespaceObject.Form.Control.Feedback, {
    type: "invalid",
    "data-testid": "form-error"
  }, errors)));
};
/* harmony default export */ const FormCheckbox = (Checkbox);
;// CONCATENATED MODULE: external "react-select/async"
const async_namespaceObject = require("react-select/async");
var async_default = /*#__PURE__*/__webpack_require__.n(async_namespaceObject);
;// CONCATENATED MODULE: ./src/components/Form/FormSelectAsync/FormSelectAsync.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }







var formatOption = option => {
  if (typeof option === 'string') {
    return {
      value: option,
      label: option
    };
  }
  if (option.id) {
    return {
      value: option.id,
      label: option.label
    };
  }
  return option;
};
var createGetOptions = function createGetOptions(url, apiQueryKeys) {
  var apiDataKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var defaultLanguage = arguments.length > 3 ? arguments[3] : undefined;
  return /*#__PURE__*/function () {
    var _getOptions = _asyncToGenerator(function* (queryString) {
      var getList = response => {
        var _response$data$apiDat, _response$data;
        return apiDataKey ? (_response$data$apiDat = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data[apiDataKey]) !== null && _response$data$apiDat !== void 0 ? _response$data$apiDat : [] : response.data;
      };
      var formatOptions = arr => {
        return arr.map(e => formatOption(e));
      };
      var [query, language] = apiQueryKeys;
      var response = yield external_axios_default().get(url.replace(query, queryString).replace(language, defaultLanguage)).then(r => getList(r)).then(e => formatOptions(e));
      return response;
    });
    function getOptions(_x) {
      return _getOptions.apply(this, arguments);
    }
    return getOptions;
  }();
};
var FormSelectAsync = _ref => {
  var {
    label,
    hint,
    errors,
    placeholder = '',
    onInputChangeHandler,
    controlId,
    color = '#000000',
    disabled,
    isInvalid,
    isMulti,
    defaultValue = null,
    language = 'en',
    optionsApiUrl,
    apiQueryKey = ':query,:language',
    apiDataKey = null,
    value,
    // Should always be an object: { value: option, label: option }, null or an empty string ""
    dataTestId,
    hideLabel
  } = _ref;
  var getOptions = (0,external_react_.useMemo)(() => {
    return createGetOptions(optionsApiUrl, apiQueryKey.split(','), apiDataKey, language);
  }, [optionsApiUrl, apiQueryKey, apiDataKey, language]);
  var classes = FormInput_FormInput_module.locals || {};
  (0,external_react_.useEffect)(() => {
    FormInput_FormInput_module.use();
  }, []);

  // because value is an object errors may also be an object
  var error = typeof errors === 'object' ? (errors === null || errors === void 0 ? void 0 : errors.value) || null : errors || "".concat(label, " is required.");
  return /*#__PURE__*/external_react_default().createElement((Form_default()).Group, {
    controlId: controlId,
    className: "mb-3"
  }, label && /*#__PURE__*/external_react_default().createElement((Form_default()).Label, {
    className: hideLabel ? classes.visuallyHidden : ''
  }, label), /*#__PURE__*/external_react_default().createElement((async_default()), {
    inputId: controlId,
    isMulti: isMulti,
    classNamePrefix: "react-select",
    className: "custom-form-control ".concat(classes.formSelectText, " ").concat(isInvalid ? "".concat(classes.customSelectError, " is-invalid") : ''),
    "data-testid": dataTestId,
    defaultValue: defaultValue && formatOption(defaultValue),
    value: typeof value === 'object' ? value : '',
    noOptionsMessage: () => defaultTransFunction('selectNoOptionMessage', language),
    onChange: onInputChangeHandler,
    loadOptions: getOptions,
    isDisabled: disabled,
    placeholder: placeholder || defaultTransFunction('selectPlaceholder', language),
    styles: reactSelectStyle
  }), isInvalid && /*#__PURE__*/external_react_default().createElement("div", {
    className: "invalid-feedback",
    "data-testid": "form-error"
  }, error), hint && /*#__PURE__*/external_react_default().createElement((Form_default()).Text, {
    style: {
      color,
      opacity: '.6'
    }
  }, hint));
};
/* harmony default export */ const FormSelectAsync_FormSelectAsync = (FormSelectAsync);
;// CONCATENATED MODULE: ./src/components/Form/icons/SvgWhatsApp.js

function SvgWhatsApp(_ref) {
  var {
    width = 20,
    height = 20,
    className = ''
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement("svg", {
    className: className,
    width: width,
    height: height,
    viewBox: "0 0 485 488",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/external_react_default().createElement("g", {
    filter: "url(#filter0_f_534_20)"
  }, /*#__PURE__*/external_react_default().createElement("path", {
    d: "M5.99444 241.795C5.97908 283.758 16.9141 324.72 37.6993 360.827L4 484.199L129.922 451.093C164.615 470.065 203.678 480.062 243.429 480.077H243.532C374.444 480.077 481.011 373.257 481.067 241.988C481.088 178.366 456.403 118.546 411.558 73.5437C366.707 28.5424 307.07 3.74691 243.532 3.71875C112.599 3.71875 6.0465 110.522 5.99444 241.795V241.795Z",
    fill: "black",
    fillOpacity: "0.15"
  })), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M14.5181 239.316C14.5062 279.674 25.0511 319.082 45.1042 353.817L12.5996 472.501L134.054 440.655C167.517 458.893 205.191 468.517 243.534 468.53H243.636C369.901 468.53 472.685 365.781 472.737 239.494C472.762 178.297 448.952 120.755 405.692 77.4637C362.441 34.1727 304.916 10.3194 243.628 10.2921C117.348 10.2921 14.5693 113.033 14.5181 239.317",
    fill: "url(#paint0_linear_534_20)"
  }), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M6.33846 239.236C6.3231 281.051 17.2487 321.869 38.0152 357.848L4.3457 480.785L130.157 447.796C164.82 466.7 203.848 476.663 243.565 476.677H243.668C374.464 476.677 480.938 370.234 480.993 239.429C481.016 176.031 456.352 116.423 411.547 71.5783C366.736 26.7357 307.15 2.02898 243.668 1.99996C112.85 1.99996 6.39052 108.426 6.33761 239.236H6.33846ZM81.2601 351.653L76.5637 344.194C56.8171 312.797 46.3924 276.511 46.4095 239.252C46.4513 130.526 134.936 42.0727 243.743 42.0727C296.433 42.0941 345.954 62.6318 383.201 99.9036C420.444 137.173 440.938 186.72 440.922 239.413C440.876 348.142 352.389 436.609 243.669 436.609H243.592C208.19 436.59 173.472 427.085 143.193 409.116L135.986 404.846L61.3274 424.419L81.2601 351.653Z",
    fill: "url(#paint1_linear_534_20)"
  }), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.351 140.059C179.909 130.185 175.233 129.986 171.007 129.813C167.551 129.665 163.593 129.674 159.643 129.674C155.69 129.674 149.264 131.159 143.831 137.093C138.395 143.027 123.074 157.372 123.074 186.547C123.074 215.726 144.325 243.916 147.288 247.876C150.253 251.831 188.312 313.614 248.585 337.384C298.677 357.137 308.871 353.208 319.743 352.22C330.616 351.231 354.828 337.878 359.769 324.031C364.712 310.186 364.712 298.319 363.229 295.838C361.746 293.366 357.793 291.884 351.862 288.918C345.931 285.953 316.778 271.605 311.341 269.628C305.905 267.652 301.951 266.663 297.998 272.6C294.044 278.531 282.688 291.884 279.226 295.839C275.767 299.801 272.308 300.295 266.377 297.33C260.446 294.355 241.348 288.1 218.691 267.899C201.062 252.182 189.162 232.772 185.701 226.836C182.242 220.904 185.331 217.692 188.305 214.736C190.968 212.079 194.237 207.814 197.201 204.351C200.16 200.889 201.149 198.417 203.126 194.463C205.102 190.503 204.114 187.04 202.632 184.075C201.149 181.11 189.625 151.783 184.351 140.059",
    fill: "white"
  }), /*#__PURE__*/external_react_default().createElement("defs", null, /*#__PURE__*/external_react_default().createElement("filter", {
    id: "filter0_f_534_20",
    x: "0.586284",
    y: "0.305034",
    width: "483.894",
    height: "487.308",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/external_react_default().createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/external_react_default().createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/external_react_default().createElement("feGaussianBlur", {
    stdDeviation: "1.70686",
    result: "effect1_foregroundBlur_534_20"
  })), /*#__PURE__*/external_react_default().createElement("linearGradient", {
    id: "paint0_linear_534_20",
    x1: "242.667",
    y1: "472.502",
    x2: "242.667",
    y2: "10.2916",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/external_react_default().createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/external_react_default().createElement("stop", {
    offset: "1",
    stopColor: "#60D66A"
  })), /*#__PURE__*/external_react_default().createElement("linearGradient", {
    id: "paint1_linear_534_20",
    x1: "242.671",
    y1: "480.786",
    x2: "242.671",
    y2: "2.00024",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/external_react_default().createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/external_react_default().createElement("stop", {
    offset: "1",
    stopColor: "white"
  }))));
}
/* harmony default export */ const icons_SvgWhatsApp = (SvgWhatsApp);
;// CONCATENATED MODULE: ./src/components/Form/icons/SvgSms.js

function SvgSms(_ref) {
  var {
    width = 20,
    height = 20,
    className = ''
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement("svg", {
    className: className,
    width: width,
    height: height,
    viewBox: "0 0 100 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/external_react_default().createElement("path", {
    d: "M100 45.0786C100 59.0914 91.9537 73.4614 81.4111 84.9194C76.5896 90.1595 69.164 96 63.4111 100C59.5576 102.679 56.5448 104.567 52.9111 106.5C51.3399 107.336 50 108.079 50 108.079C50 108.079 49.9427 90.0786 49.9141 90.0785C22.3393 90.0368 0 69.9056 0 45.0786C0 20.2258 22.3858 0.0786133 50 0.0786133C77.6142 0.0786133 100 20.2258 100 45.0786Z",
    fill: "white"
  }));
}
/* harmony default export */ const icons_SvgSms = (SvgSms);
;// CONCATENATED MODULE: ./src/components/Form/Form.js
function Form_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Form_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Form_ownKeys(Object(source), !0).forEach(function (key) { Form_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Form_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Form_defineProperty(obj, key, value) { key = Form_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function Form_toPropertyKey(arg) { var key = Form_toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function Form_toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }









/**
 * IMPORTANT
 *
 * for development purposes and displaying PhoneInput correctly in
 * storybook please import it's styles from 'react-phone-input-2/lib/bootstrap.css'
 * please refer to README "Important" section for more details
 */













var getInitialValues = _ref => {
  var {
    selectInputs,
    textFields,
    isPhoneRequired,
    prefillUserInfo,
    checkIfExcluded,
    hasCountryInputSupport,
    formattedTerms,
    countryData
  } = _ref;
  var {
    countryCode,
    countryName
  } = countryData || {};
  var {
    firstName = '',
    lastName = '',
    email = '',
    phoneNumber = '',
    dateOfBirth = '',
    gender = '',
    country = countryCode && countryName ? {
      value: countryCode,
      label: countryName
    } : '',
    city = ''
  } = prefillUserInfo || {};
  var values = Form_objectSpread(Form_objectSpread(Form_objectSpread(Form_objectSpread(Form_objectSpread(Form_objectSpread(Form_objectSpread(Form_objectSpread({}, !checkIfExcluded('firstName') && {
    firstName
  }), !checkIfExcluded('lastName') && {
    lastName
  }), !checkIfExcluded('email') && {
    email
  }), !checkIfExcluded('phoneNumber') && {
    phoneNumber
  }), !checkIfExcluded('dateOfBirth') && {
    dateOfBirth
  }), !checkIfExcluded('gender') && {
    gender
  }), hasCountryInputSupport ? !checkIfExcluded('country') && {
    city,
    country
  } : !checkIfExcluded('city') && {
    city
  }), {}, {
    defaultTerm: false
  });
  if (isPhoneRequired) {
    values.smsSent = false;
    values.smsVerified = false;
    values.code = '';
  }
  var customFields = [...textFields, ...selectInputs];
  customFields.forEach(input => {
    var value = input.isMulti ? [] : '';
    values[input.name] = value;
  });
  if (formattedTerms) {
    formattedTerms.forEach(term => {
      values[term.name] = false;
    });
  }
  return values;
};
var getValidationSchema = _ref2 => {
  var {
    isPhoneRequired,
    selectInputs,
    textFields,
    checkIfExcluded,
    hasCountryInputSupport,
    formattedTerms,
    language
  } = _ref2;
  var stringRequired = name => external_yup_namespaceObject.string().required(defaultTransFunction("input.".concat(name, ".required"), language));
  var emailValidation = {
    email: external_yup_namespaceObject.string().email(defaultTransFunction('input.email.invalid', language)).required(defaultTransFunction('input.email.required', language))
  };
  var phoneValidation = {
    phoneNumber: external_yup_namespaceObject.string().required(defaultTransFunction('input.phoneNumber.required', language)).min(7, defaultTransFunction('input.phoneNumber.toShort', language)),
    code: external_yup_namespaceObject.string().when('smsSent', {
      is: true,
      then: external_yup_namespaceObject.string().required(defaultTransFunction('input.phoneVerification.required', language)).min(4, defaultTransFunction('input.phoneVerification.toShort', language)).max(4, defaultTransFunction('input.phoneVerification.toLong', language))
    })
  };
  var schema = external_yup_namespaceObject.object().shape(Form_objectSpread(Form_objectSpread(Form_objectSpread(Form_objectSpread(Form_objectSpread(Form_objectSpread(Form_objectSpread(Form_objectSpread({}, !checkIfExcluded('firstName') && {
    firstName: stringRequired('firstName')
  }), !checkIfExcluded('lastName') && {
    lastName: stringRequired('lastName')
  }), !checkIfExcluded('email') && emailValidation), isPhoneRequired && phoneValidation), !checkIfExcluded('dateOfBirth') && {
    dateOfBirth: external_yup_namespaceObject.date().required(defaultTransFunction('input.dateOfBirth.required', language))
  }), !checkIfExcluded('gender') && {
    gender: stringRequired('gender')
  }), hasCountryInputSupport ? !checkIfExcluded('country') && {
    country: external_yup_namespaceObject.object({
      value: external_yup_namespaceObject.string().required(defaultTransFunction("input.country.required", language))
    }),
    city: external_yup_namespaceObject.object({
      value: external_yup_namespaceObject.string().required(defaultTransFunction("input.city.required", language))
    })
  } : !checkIfExcluded('city') && {
    city: stringRequired('city')
  }), {}, {
    defaultTerm: external_yup_namespaceObject.boolean().oneOf([true], defaultTransFunction('input.term.defaultTermError', language))
  }));
  var questionFields = [...selectInputs, ...textFields];
  var requiredFields = questionFields.filter(input => input.required);
  requiredFields.forEach(input => {
    if (input.answers) {
      schema.fields[input.name] = input.isMulti ? external_yup_namespaceObject.array().min(1, defaultTransFunction('input.select.placeholderMulti', language)) : external_yup_namespaceObject.string().required(defaultTransFunction('input.select.placeholderSingle', language));
    } else {
      schema.fields[input.name] = external_yup_namespaceObject.string().required("".concat(input.name, " ").concat(defaultTransFunction('form.required', language)));
    }
    schema._nodes.push(input.name);
  });
  if (formattedTerms) {
    formattedTerms.forEach(term => {
      schema.fields[term.name] = external_yup_namespaceObject.boolean().oneOf([true], defaultTransFunction('input.term.additionalTermError', language));
      schema._nodes.push(term.name);
    });
  }
  return schema;
};

/** TODO: 'serviceAvailability' prop is hardcoded due to limited time. Needs to be fix. */

var Form = _ref3 => {
  var _countryData$countryC;
  var {
    formState = {
      submitDisable: false
    },
    accentColor = '#000000',
    color = '#000000',
    selectInputs = [],
    countries,
    // DEPRECATED
    introMessage,
    terms,
    onSubmit,
    onEmailBlur = () => {},
    submitText = 'form.submitData',
    emailDescription = '',
    phoneDescription = '',
    PhaseHeader,
    language,
    brandName,
    termsAndConditionsUrl,
    serviceAvailability,
    videoProvider,
    videoProviderUrl,
    maxLength = {
      defaultField: 100,
      customField: 1000
    },
    formId = '',
    inputFontSize,
    isPhoneRequired = false,
    isWhatsAppDefault = false,
    textFields = [],
    errors: formErrors = {},
    resetFormError,
    codeRequestUrl,
    codeVerifyUrl,
    countryApi,
    cityApi,
    userInfo: prefillUserInfo = {},
    excludedFields = [],
    countryData,
    emailToken
  } = _ref3;
  var formRef = (0,external_react_.useRef)(null);
  var checkIfExcluded = field => {
    // check if single field is excluded
    if (typeof field === 'string') {
      return excludedFields.includes(field);
    }
    // check if 2 or more fields are excluded
    return field.every(f => excludedFields.includes(f));
  };
  var resetErrorKey = key => {
    // eslint-disable-next-line no-unused-expressions
    resetFormError && resetFormError(key);
  };
  var formikHandleInputChange = (handleChange, key, ev) => {
    if (key === 'email') {
      var isAutoComplete = document.activeElement !== ev.target && ev.target.value;
      if (isAutoComplete) {
        onEmailBlur(ev.target.value);
      }
    }
    resetErrorKey(key);
    handleChange(ev);
  };

  /**
   * Only require (and validate) phone if not pre-filled or excluded
   *  Pre-filled values are ignored on submission and handled server-side
   */
  var _isPhoneRequired = isPhoneRequired && !(prefillUserInfo !== null && prefillUserInfo !== void 0 && prefillUserInfo.phoneNumber) && !checkIfExcluded('phoneNumber');
  var defaultFields = ['firstName', 'lastName', 'email', 'phoneNumber', 'dateOfBirth', 'gender', 'country'];

  // All default inputs have been excluded and no custom questions exist
  var noInputs = checkIfExcluded(defaultFields) && !textFields.length && !selectInputs.length;
  var getCountryCityApi = countryCode => {
    return cityApi.replace(':countryCode', countryCode);
  };

  /**
   * Country support boolean is for backwards compatability
   *  between sprint releases
   */
  var hasCountryInputSupport = (0,external_react_.useMemo)(() => {
    return !!countryApi && !!cityApi;
  }, [countryApi, cityApi]);
  var classes = Form_Form_module.locals || {};
  var initialPhoneInputCountry = (countryData === null || countryData === void 0 ? void 0 : (_countryData$countryC = countryData.countryCode) === null || _countryData$countryC === void 0 ? void 0 : _countryData$countryC.toLowerCase()) || 'id';
  (0,external_react_.useEffect)(() => {
    Form_Form_module.use();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (videoProviderUrl) console.warn("The use of videoProviderUrl is deprecated. Please use videoProvider object instead");
  var inputStyle = {
    fontSize: inputFontSize
  };
  var [subscriptionParagraph, setSubscriptionParagraph] = (0,external_react_.useState)({
    text: '',
    key: 0
  });
  (0,external_react_.useEffect)(() => {
    setSubscriptionParagraph(state => {
      var _videoProvider$transl, _ref4, _providerTranslations, _ref5, _providerTranslations2;
      var providerTranslations = videoProvider === null || videoProvider === void 0 ? void 0 : (_videoProvider$transl = videoProvider.translations) === null || _videoProvider$transl === void 0 ? void 0 : _videoProvider$transl[language];
      return {
        key: state.key ? state.key + 1 : 1,
        text: defaultTransFunction('form.subscriptionInfo', language, {
          brandName: external_isomorphic_dompurify_default().sanitize(brandName !== null && brandName !== void 0 ? brandName : '_______'),
          termsAndConditionsUrl: external_isomorphic_dompurify_default().sanitize(termsAndConditionsUrl),
          serviceAvailability,
          productName: external_isomorphic_dompurify_default().sanitize((_ref4 = (_providerTranslations = providerTranslations === null || providerTranslations === void 0 ? void 0 : providerTranslations.productName) !== null && _providerTranslations !== void 0 ? _providerTranslations : videoProvider === null || videoProvider === void 0 ? void 0 : videoProvider.productName) !== null && _ref4 !== void 0 ? _ref4 : '_______'),
          videoProviderName: external_isomorphic_dompurify_default().sanitize((_ref5 = (_providerTranslations2 = providerTranslations === null || providerTranslations === void 0 ? void 0 : providerTranslations.name) !== null && _providerTranslations2 !== void 0 ? _providerTranslations2 : videoProvider === null || videoProvider === void 0 ? void 0 : videoProvider.name) !== null && _ref5 !== void 0 ? _ref5 : '_______'),
          videoProviderUrl: external_isomorphic_dompurify_default().sanitize((videoProvider === null || videoProvider === void 0 ? void 0 : videoProvider.url) || videoProviderUrl),
          accentColor: color
        })
      };
    });
  }, [language, brandName, termsAndConditionsUrl, serviceAvailability, videoProvider, videoProviderUrl, color]);
  var [isPhoneVerificationSent, setIsPhoneVerificationSent] = (0,external_react_.useState)(false);
  var renderFormInputs = (setFieldValue, values, errors, touched) => {
    var questionFields = [];
    selectInputs.forEach(el => {
      questionFields.push( /*#__PURE__*/external_react_default().createElement(FormInput_FormInput, {
        key: el.name,
        required: el.required || false,
        name: el.name,
        label: el.label,
        type: el.type || 'text',
        placeholder: el.placeholder || '',
        answers: el.answers || '',
        errors: getError(el.name, errors, touched),
        controlId: "formCustom".concat(el.name, "_").concat(formId),
        text: el.text,
        style: inputStyle,
        onInputChangeHandler: event => {
          var _ref6, _event$value;
          var value = el.isMulti && Array.isArray(event) ? event.map(o => o.value) : (_ref6 = (_event$value = event === null || event === void 0 ? void 0 : event.value) !== null && _event$value !== void 0 ? _event$value : event) !== null && _ref6 !== void 0 ? _ref6 : [];
          setFieldValue([el.name], value);
        },
        getOptionValue: option => option.value,
        value: values[el.name],
        isInvalid: errors[el.name] && touched[el.name],
        isMulti: el.isMulti
      }));
    });
    textFields.forEach(el => {
      questionFields.push( /*#__PURE__*/external_react_default().createElement(FormInput_FormInput, {
        key: el.name,
        required: el.required || false,
        name: el.name,
        label: el.label || '',
        placeholder: el.label || '',
        errors: getError(el.name, errors, touched),
        controlId: "formCustom".concat(el.name, "_").concat(formId),
        style: inputStyle,
        text: el.text,
        onInputChangeHandler: _ref7 => {
          var {
            target
          } = _ref7;
          return setFieldValue([el.name], target.value);
        },
        value: values[el.name],
        isInvalid: errors[el.name] && touched[el.name]
      }));
    });
    return questionFields;
  };
  var [requestPhoneCodeMessage, {
    isFetching: phoneCodeFetching
  }] = Form_hooks(codeRequestUrl);
  var [requestPhoneCodeVerify, {
    isFetching: phoneVerifyFetching
  }] = Form_hooks(codeVerifyUrl);
  var requestVerificationCode = function requestVerificationCode(phoneNumber, setFieldValue, setFieldTouched, setFieldError) {
    var verificationMethod = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'sms';
    setFieldTouched('phoneNumber', true);
    if (phoneNumber.length < 7) return;
    requestPhoneCodeMessage({
      phone: "+".concat(phoneNumber),
      channel: verificationMethod
    }).then(r => {
      if ((r === null || r === void 0 ? void 0 : r.verification) === 'pending') {
        setIsPhoneVerificationSent(true);
        setFieldValue('smsSent', true);
        setFieldError('phoneNumber', false);
      } else {
        setFieldError('phoneNumber', defaultTransFunction('input.phoneVerification.failedToSend', language));
      }
    }).catch(() => {
      setFieldError('phoneNumber', defaultTransFunction('input.phoneVerification.failedToSend', language));
    });
  };
  var sendVerificationCode = (phoneNumber, code, setFieldTouched, setFieldValue, setFieldError) => {
    setFieldTouched('code', true);
    if (code.length < 4) {
      setFieldError('code', defaultTransFunction('input.phoneVerification.invalid', language));
      return;
    }
    requestPhoneCodeVerify({
      phone: "+".concat(phoneNumber),
      code
    }).then(r => {
      if ((r === null || r === void 0 ? void 0 : r.verifyStatus) === 'approved') {
        setFieldValue('smsVerified', true);
      } else {
        setFieldError('code', defaultTransFunction('input.phoneVerification.invalid', language));
      }
    }).catch(() => {
      setFieldError('code', defaultTransFunction('input.phoneVerification.failedToVerify', language));
    });
  };
  var [formattedTerms] = (0,external_react_.useState)(terms ? terms.map((term, idx) => ({
    label: term,
    name: "term-".concat(idx)
  })) : null);
  var beforeSubmitHandler = (values, formik) => {
    if (_isPhoneRequired && !values.smsVerified) {
      formik.setFieldError('phoneNumber', defaultTransFunction('input.phoneVerification.required', language));
      return false;
    }
    var formValues = Form_objectSpread(Form_objectSpread({}, values), {}, {
      emailToken
    });

    // convert all array values to comma-delimited strings
    for (var [key, value] of Object.entries(formValues)) {
      if (Array.isArray(value)) {
        formValues[key] = value.join(',');
      }
    }
    delete formValues.smsSent;
    delete formValues.smsVerified;
    delete formValues.code;
    delete formValues.defaultTerm;
    if (formattedTerms) {
      formattedTerms.forEach(term => {
        delete formValues[term.name];
      });
    }
    if (formValues.country) {
      var _formValues$country;
      formValues.country = ((_formValues$country = formValues.country) === null || _formValues$country === void 0 ? void 0 : _formValues$country.value) || formValues.country;
    }
    if (formValues.city) {
      var _formValues$city;
      formValues.city = ((_formValues$city = formValues.city) === null || _formValues$city === void 0 ? void 0 : _formValues$city.value) || formValues.city;
    }
    onSubmit(formValues, formik);
  };
  var initialValues = getInitialValues({
    selectInputs,
    textFields,
    isPhoneRequired: _isPhoneRequired,
    prefillUserInfo,
    checkIfExcluded,
    hasCountryInputSupport,
    formattedTerms,
    countryData
  });
  var validationSchema = getValidationSchema({
    _isPhoneRequired,
    selectInputs,
    textFields,
    checkIfExcluded,
    hasCountryInputSupport,
    formattedTerms,
    language
  });
  return /*#__PURE__*/external_react_default().createElement(external_formik_namespaceObject.Formik, {
    onSubmit: beforeSubmitHandler,
    initialValues: initialValues,
    validationSchema: validationSchema
  }, _ref8 => {
    var _prefillUserInfo$coun, _prefillUserInfo$city, _values$country, _values$country2;
    var {
      handleSubmit,
      handleChange,
      values,
      errors,
      // status,
      setFieldValue,
      setFieldError,
      setFieldTouched,
      setErrors,
      touched
    } = _ref8;
    return /*#__PURE__*/external_react_default().createElement((Form_default()), {
      noValidate: true,
      ref: formRef,
      onSubmit: handleSubmit,
      style: {
        color
      },
      "data-testid": "form"
    }, PhaseHeader ? /*#__PURE__*/external_react_default().createElement(PhaseHeader, null) : null, /*#__PURE__*/external_react_default().createElement(SyncFormikErrors, {
      formErrors: formErrors,
      setErrors: setErrors,
      setFieldTouched: setFieldTouched
    }), introMessage ? /*#__PURE__*/external_react_default().createElement("p", null, introMessage) : null, noInputs && /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("strong", null, defaultTransFunction('noinputs.message', language))), checkIfExcluded(['firstName', 'lastName']) ? null : /*#__PURE__*/external_react_default().createElement((Row_default()), null, checkIfExcluded('firstName') ? null : /*#__PURE__*/external_react_default().createElement((Col_default()), {
      sm: 12,
      md: checkIfExcluded('lastName') ? 12 : 6
    }, /*#__PURE__*/external_react_default().createElement(FormInput_FormInput, {
      key: "firstName",
      controlId: "formCustomFirstName_".concat(formId),
      required: true,
      name: "firstName",
      type: "text",
      placeholder: defaultTransFunction('input.firstName.placeholder', language),
      errors: getError('firstName', errors, touched),
      maxLength: maxLength.defaultField,
      style: inputStyle,
      onInputChangeHandler: e => formikHandleInputChange(handleChange, 'firstName', e),
      value: values.firstName,
      disabled: !!(prefillUserInfo !== null && prefillUserInfo !== void 0 && prefillUserInfo.firstName),
      isInvalid: errors.firstName && touched.firstName
    })), checkIfExcluded('lastName') ? null : /*#__PURE__*/external_react_default().createElement((Col_default()), {
      sm: 12,
      md: checkIfExcluded('firstName') ? 12 : 6
    }, /*#__PURE__*/external_react_default().createElement(FormInput_FormInput, {
      key: "lastName",
      controlId: "formCustomLastName_".concat(formId),
      required: true,
      name: "lastName",
      type: "text",
      placeholder: defaultTransFunction('input.lastName.placeholder', language),
      errors: getError('lastName', errors, touched),
      maxLength: maxLength.defaultField,
      style: inputStyle,
      onInputChangeHandler: e => formikHandleInputChange(handleChange, 'lastName', e),
      value: values.lastName,
      disabled: !!(prefillUserInfo !== null && prefillUserInfo !== void 0 && prefillUserInfo.lastName),
      isInvalid: errors.lastName && touched.lastName
    }))), checkIfExcluded('email') ? null : /*#__PURE__*/external_react_default().createElement(FormInput_FormInput, {
      key: "email",
      controlId: "formCustomEmail_".concat(formId),
      required: true,
      name: "email",
      type: "email",
      text: emailDescription ? defaultTransFunction(emailDescription, language) : '',
      placeholder: defaultTransFunction('input.email.placeholder', language),
      errors: getError('email', errors, touched),
      maxLength: maxLength.defaultField,
      color: color,
      style: inputStyle,
      onInputChangeHandler: e => formikHandleInputChange(handleChange, 'email', e),
      onBlur: ev => onEmailBlur(ev.target.value),
      value: values.email,
      disabled: !!(prefillUserInfo !== null && prefillUserInfo !== void 0 && prefillUserInfo.email),
      isInvalid: errors.email && touched.email
    }), checkIfExcluded('phoneNumber') ? null : /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement((Row_default()), null, /*#__PURE__*/external_react_default().createElement((Col_default()), {
      sm: 12
    }, /*#__PURE__*/external_react_default().createElement((Form_default()).Group, {
      className: "mb-3"
    }, /*#__PURE__*/external_react_default().createElement((Row_default()), null, /*#__PURE__*/external_react_default().createElement((Col_default()), {
      xs: !values.smsVerified && _isPhoneRequired && !isWhatsAppDefault ? 8 : 12
    }, /*#__PURE__*/external_react_default().createElement((external_react_phone_input_2_default()), {
      id: "phoneNumber",
      key: "phoneNumber",
      name: "phoneNumber",
      "data-testid": "phoneNumber",
      specialLabel: "",
      value: values.phoneNumber,
      onChange: value => {
        resetErrorKey('phoneNumber');
        setFieldValue('phoneNumber', value);
      },
      inputStyle: Form_objectSpread({
        width: !values.smsVerified && _isPhoneRequired && !isWhatsAppDefault ? '' : '100%',
        maxWidth: '100%'
      }, !!errors.phoneNumber && {
        borderColor: '#dc3545'
      }),
      disabled: !!values.smsVerified || (prefillUserInfo === null || prefillUserInfo === void 0 ? void 0 : prefillUserInfo.phoneNumber),
      required: _isPhoneRequired,
      enableSearch: true,
      country: initialPhoneInputCountry,
      inputClass: classes.phoneInput,
      dropdownClass: classes.phoneDropdown
    }), phoneDescription ? /*#__PURE__*/external_react_default().createElement("small", {
      style: {
        color: 'black',
        opacity: '0.6'
      },
      className: "form-text"
    }, defaultTransFunction(phoneDescription, language)) : null), !values.smsVerified && _isPhoneRequired && !isWhatsAppDefault ? /*#__PURE__*/external_react_default().createElement((Col_default()), {
      xs: 4,
      className: "d-flex flex-column align-items-stretch"
    }, /*#__PURE__*/external_react_default().createElement(Button, {
      className: "btn-sm my-0 mx-0",
      isLoading: phoneCodeFetching,
      disabled: phoneCodeFetching,
      style: {
        backgroundColor: accentColor,
        outlineColor: accentColor,
        borderColor: accentColor
      },
      onClick: () => requestVerificationCode(values.phoneNumber, setFieldValue, setFieldTouched, setFieldError)
    }, defaultTransFunction('input.phoneVerification.requestCode', language))) : null), /*#__PURE__*/external_react_default().createElement("span", {
      style: {
        color: '#dc3545',
        fontSize: '80%'
      }
    }, getError('phoneNumber', errors, touched))))), !values.smsVerified && _isPhoneRequired && isWhatsAppDefault && /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement((Row_default()), null, /*#__PURE__*/external_react_default().createElement((Col_default()), null, /*#__PURE__*/external_react_default().createElement("p", null, defaultTransFunction('input.phoneVerification.requestCodeVia', language), ":"))), /*#__PURE__*/external_react_default().createElement((Row_default()), {
      className: "mb-3"
    }, /*#__PURE__*/external_react_default().createElement((Col_default()), {
      xs: 6
    }, /*#__PURE__*/external_react_default().createElement(Button, {
      className: "d-flex align-items-center justify-content-center",
      style: {
        width: '100%',
        border: 0,
        background: '#24ac39',
        borderRadius: '4px',
        color: '#fff'
      },
      onClick: () => {
        requestVerificationCode(values.phoneNumber, setFieldValue, setFieldTouched, setFieldError, 'whatsapp');
      }
    }, /*#__PURE__*/external_react_default().createElement(icons_SvgWhatsApp, {
      className: "me-1"
    }), defaultTransFunction('input.phoneVerification.whatsApp', language))), /*#__PURE__*/external_react_default().createElement((Col_default()), {
      xs: 6
    }, /*#__PURE__*/external_react_default().createElement(Button, {
      className: "d-flex align-items-center justify-content-center",
      style: {
        width: '100%',
        border: '1px',
        background: '#000000',
        borderRadius: '4px',
        borderColor: '#ffffff',
        color: '#fffff'
      },
      onClick: () => {
        requestVerificationCode(values.phoneNumber, setFieldValue, setFieldTouched, setFieldError, 'sms');
      }
    }, /*#__PURE__*/external_react_default().createElement(icons_SvgSms, {
      className: "me-1"
    }), defaultTransFunction('input.phoneVerification.sms', language))))), !values.smsVerified && isPhoneVerificationSent ? /*#__PURE__*/external_react_default().createElement((Row_default()), null, /*#__PURE__*/external_react_default().createElement((Col_default()), {
      xs: !values.smsVerified && _isPhoneRequired ? 8 : 12
    }, /*#__PURE__*/external_react_default().createElement((Form_default()).Group, {
      className: "mb-3"
    }, /*#__PURE__*/external_react_default().createElement(FormInput_FormInput, {
      key: "code",
      controlId: "code",
      required: true,
      name: "code",
      type: "code",
      placeholder: defaultTransFunction('input.phoneVerification.info', language),
      errors: getError('code', errors, touched),
      maxLength: 4,
      pattern: "[0\u20139]*",
      color: color,
      style: inputStyle,
      onInputChangeHandler: e => formikHandleInputChange(handleChange, 'code', e),
      value: values.code,
      isInvalid: errors.code && touched.code
    }))), /*#__PURE__*/external_react_default().createElement((Col_default()), {
      xs: 4,
      className: "d-flex flex-column align-items-stretch justify-content-start"
    }, /*#__PURE__*/external_react_default().createElement(Button, {
      className: "btn-sm my-0 mx-0",
      isLoading: phoneVerifyFetching,
      disabled: phoneVerifyFetching,
      style: {
        backgroundColor: accentColor,
        outlineColor: accentColor,
        borderColor: accentColor
      },
      onClick: () => sendVerificationCode(values.phoneNumber, values.code, setFieldTouched, setFieldValue, setFieldError)
    }, defaultTransFunction('input.phoneVerification.verify', language)))) : null), checkIfExcluded(['dateOfBirth', 'gender']) ? null : /*#__PURE__*/external_react_default().createElement((Row_default()), null, checkIfExcluded('dateOfBirth') ? null : /*#__PURE__*/external_react_default().createElement((Col_default()), {
      sm: 12,
      md: 6
    }, /*#__PURE__*/external_react_default().createElement(FormInput_FormInput, {
      key: "dateOfBirth",
      controlId: "formCustomAge_".concat(formId),
      required: true,
      label: defaultTransFunction('input.dateOfBirth.label', language),
      name: "dateOfBirth",
      type: "date",
      placeholder: defaultTransFunction('input.dateOfBirth.placeholder', language),
      errors: getError('dateOfBirth', errors, touched),
      maxLength: "3",
      max: "150",
      min: "5",
      style: inputStyle,
      onInputChangeHandler: e => formikHandleInputChange(handleChange, 'dateOfBirth', e),
      value: values.dateOfBirth,
      disabled: !!(prefillUserInfo !== null && prefillUserInfo !== void 0 && prefillUserInfo.dateOfBirth),
      isInvalid: errors.dateOfBirth && touched.dateOfBirth
    })), checkIfExcluded('gender') ? null : /*#__PURE__*/external_react_default().createElement((Col_default()), {
      sm: 12,
      md: checkIfExcluded('dateOfBirth') ? 12 : 6
    }, /*#__PURE__*/external_react_default().createElement(FormInput_FormInput, {
      key: "gender",
      controlId: "formCustomGender_".concat(formId),
      required: true,
      label: defaultTransFunction('input.gender.placeholder', language),
      name: "gender",
      type: "select",
      placeholder: defaultTransFunction('input.gender.placeholder', language),
      errors: getError('gender', errors, touched),
      answers: [{
        value: 'Male',
        label: defaultTransFunction('input.gender.maleOption', language)
      }, {
        value: 'Female',
        label: defaultTransFunction('input.gender.femaleOption', language)
      }, {
        value: 'Other',
        label: defaultTransFunction('input.gender.otherOption', language)
      }],
      style: inputStyle,
      onInputChangeHandler: event => {
        resetErrorKey('gender');
        setFieldValue('gender', event.value);
      },
      value: values.gender,
      disabled: !!(prefillUserInfo !== null && prefillUserInfo !== void 0 && prefillUserInfo.gender),
      isInvalid: errors.gender && touched.gender
    }))), hasCountryInputSupport && !checkIfExcluded('country') && /*#__PURE__*/external_react_default().createElement((Row_default()), null, /*#__PURE__*/external_react_default().createElement((Col_default()), {
      sm: 12,
      md: 6
    }, /*#__PURE__*/external_react_default().createElement(FormSelectAsync_FormSelectAsync, {
      key: "country",
      dataTestId: "country",
      controlId: "formCustomCountry_".concat(formId),
      required: true,
      type: "string",
      label: defaultTransFunction('input.country.placeholder', language),
      placeholder: defaultTransFunction('input.country.placeholder', language),
      errors: getError('country', errors, touched),
      style: inputStyle,
      onInputChangeHandler: e => {
        resetErrorKey('country');
        setFieldValue('country', e);
        setFieldValue('city', '');
      },
      defaultValue: (_prefillUserInfo$coun = prefillUserInfo === null || prefillUserInfo === void 0 ? void 0 : prefillUserInfo.country) !== null && _prefillUserInfo$coun !== void 0 ? _prefillUserInfo$coun : null,
      disabled: !!(prefillUserInfo !== null && prefillUserInfo !== void 0 && prefillUserInfo.country),
      isInvalid: errors.country && touched.country,
      optionsApiUrl: countryApi,
      apiDataKey: "countries",
      value: values.country
    })), /*#__PURE__*/external_react_default().createElement((Col_default()), {
      sm: 12,
      md: 6
    }, /*#__PURE__*/external_react_default().createElement(FormSelectAsync_FormSelectAsync, {
      key: "city",
      dataTestId: "city",
      controlId: "formCustomCity_".concat(formId),
      required: true,
      type: "string",
      label: defaultTransFunction('input.city.placeholder', language),
      placeholder: defaultTransFunction('input.city.placeholder', language),
      errors: getError('city', errors, touched),
      maxLength: maxLength.defaultField,
      style: inputStyle,
      onInputChangeHandler: e => {
        resetErrorKey('city');
        setFieldValue('city', e);
      },
      defaultValue: (_prefillUserInfo$city = prefillUserInfo === null || prefillUserInfo === void 0 ? void 0 : prefillUserInfo.city) !== null && _prefillUserInfo$city !== void 0 ? _prefillUserInfo$city : null,
      disabled: !!(prefillUserInfo !== null && prefillUserInfo !== void 0 && prefillUserInfo.city) || !((_values$country = values.country) !== null && _values$country !== void 0 && _values$country.value),
      isInvalid: errors.city && touched.city,
      optionsApiUrl: getCountryCityApi(((_values$country2 = values.country) === null || _values$country2 === void 0 ? void 0 : _values$country2.value) || values.country),
      apiDataKey: "cities",
      value: values.city
    }))), !hasCountryInputSupport && !checkIfExcluded('city') && /*#__PURE__*/external_react_default().createElement(FormInput_FormInput, {
      key: "city",
      controlId: "formCustomCity_".concat(formId),
      required: true,
      name: "city",
      type: "string",
      placeholder: defaultTransFunction('input.city.placeholder', language),
      errors: getError('city', errors, touched),
      maxLength: maxLength.defaultField,
      style: inputStyle,
      onInputChangeHandler: e => formikHandleInputChange(handleChange, 'city', e),
      value: values.city,
      disabled: !!(prefillUserInfo !== null && prefillUserInfo !== void 0 && prefillUserInfo.city),
      isInvalid: errors.city && touched.city
    }), renderFormInputs(setFieldValue, values, errors, touched), /*#__PURE__*/external_react_default().createElement(FormCheckbox, {
      name: "defaultTerm",
      isInvalid: errors.defaultTerm && touched.defaultTerm,
      errors: errors.defaultTerm,
      onInputChangeHandler: e => formikHandleInputChange(handleChange, 'defaultTerm', e),
      required: true,
      label: /*#__PURE__*/external_react_default().createElement("span", null, external_html_react_parser_default()(subscriptionParagraph.text))
    }), formattedTerms && formattedTerms.map(term => /*#__PURE__*/external_react_default().createElement(FormCheckbox, {
      key: term.label,
      name: term.name,
      isInvalid: errors[term.name] && touched[term.name],
      errors: errors[term.name],
      onInputChangeHandler: e => formikHandleInputChange(handleChange, term.name, e),
      required: true,
      useHtmlLabel: true,
      label: term.label
    })), errors && errors.formData && /*#__PURE__*/external_react_default().createElement((Alert_default()), {
      variant: "danger"
    }, errors.formData), formState && (formState === null || formState === void 0 ? void 0 : formState.submitDisable) && 'Submitting...', /*#__PURE__*/external_react_default().createElement("div", {
      className: "d-flex justify-content-center mt-4"
    }, /*#__PURE__*/external_react_default().createElement(Button, {
      disabled: formState && (formState === null || formState === void 0 ? void 0 : formState.submitDisable),
      variant: "primary",
      type: "submit",
      onClick: ev => handleSubmit(ev),
      style: {
        backgroundColor: '#000000',
        outlineColor: '#000000',
        borderColor: '#000000'
      }
    }, /*#__PURE__*/external_react_default().createElement(components_Translate, {
      langKey: submitText,
      language: language
    }))));
  });
};
function getError(fieldName, errors, touched) {
  return errors[fieldName] && touched[fieldName] ? errors[fieldName] : null;
}
var errorStyles = {
  phoneNumber(_ref9) {
    var {
      isError
    } = _ref9;
    return {
      paddingLeft: '50px',
      paddingTop: '.375rem',
      paddingRight: '.75rem',
      paddingBottom: '.375rem',
      width: '100%',
      borderColor: isError ? '#dc3545' : ''
    };
  }
};

/**
 * Quick fix to re-introduce formErrors object
 *  from parent and display/sync with Formik fields
 */
var SyncFormikErrors = _ref10 => {
  var {
    formErrors,
    setErrors,
    setFieldTouched
  } = _ref10;
  (0,external_react_.useEffect)(() => {
    var formErrorKeys = Object.keys(formErrors);
    if (formErrorKeys !== null && formErrorKeys !== void 0 && formErrorKeys.length) {
      setErrors(formErrors);
      for (var fieldKey of formErrorKeys) {
        setFieldTouched(fieldKey, true, false);
      }
    }
  }, [formErrors, setErrors, setFieldTouched]);
  return null;
};
/* harmony default export */ const Form_Form = (Form);
;// CONCATENATED MODULE: ./src/shared/errors.js
/* eslint-disable import/prefer-default-export */
var vidioErrors = {
  VALIDATION: 'validation',
  ERROR_USER_RECOGNISED: 'error_user_recognised',
  ERROR_CAMPAIGN_NOT_ACTIVE: 'error_campaign_not_active',
  SERVER_ERROR: 'server_error',
  INDOSAT_INVALID_PHONE_NUMBER: 'Phone Number Is Invalid',
  INDOSAT_PHONE_EXPIRED: 'Phone Number Is Expired',
  INDOSAT_REWARD_QUOTA_EXCEEDED: 'Reward Quota Exceeded',
  INDOSAT_ACCESS_FAILED: 'Indosat Access Invalid' || 0,
  INVALID_PACKAGE: 'Invalid Package',
  SUBMITTED_FORM: 'error_form_already_submitted'
};
;// CONCATENATED MODULE: ./src/shared/transformMessage.js
function transformMessage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function transformMessage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? transformMessage_ownKeys(Object(source), !0).forEach(function (key) { transformMessage_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : transformMessage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function transformMessage_defineProperty(obj, key, value) { key = transformMessage_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function transformMessage_toPropertyKey(arg) { var key = transformMessage_toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function transformMessage_toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable import/prefer-default-export */


var transformVidioMessages = (messageKey, language, context, defaultMessage) => {
  var _context = context !== null && context !== void 0 ? context : {};
  switch (messageKey) {
    case vidioErrors.VALIDATION:
      return defaultTransFunction('vidio.validationError', language);
    case vidioErrors.SERVER_ERROR:
      return defaultTransFunction('vidio.serverError', language);
    case vidioErrors.ERROR_USER_RECOGNISED:
      return defaultTransFunction('vidio.recognisedError', language);
    case vidioErrors.ERROR_CAMPAIGN_NOT_ACTIVE:
      return defaultTransFunction('vidio.campaignNotActiveError', language);
    case vidioErrors.INDOSAT_INVALID_PHONE_NUMBER:
      return defaultTransFunction('indosatMessage.invalidPhoneNumber', language, _context);
    case vidioErrors.INDOSAT_PHONE_EXPIRED:
      return defaultTransFunction('indosatMessage.expiredPhoneNumber', language, _context);
    case vidioErrors.INDOSAT_REWARD_QUOTA_EXCEEDED:
      return defaultTransFunction('indosatMessage.rewardQuotaExceeded', language, _context);
    case vidioErrors.INDOSAT_ACCESS_FAILED:
    case vidioErrors.INVALID_PACKAGE:
      return defaultTransFunction('indosatMessage.bountyError', language, transformMessage_objectSpread(transformMessage_objectSpread({}, _context), {}, {
        campaignUrl: window.location.href
      }));
    case vidioErrors.SUBMITTED_FORM:
      return defaultTransFunction('vidio.formAlreadySubmitted', language, _context);
    default:
      if (defaultMessage) {
        return defaultMessage;
      }
      return defaultTransFunction('vidio.serverError', language);
  }
};
;// CONCATENATED MODULE: ./src/shared/validateForm.js
/* eslint-disable import/prefer-default-export */
var baseFormFields = ['firstName', 'lastName', 'email', 'dateOfBirth', 'city', 'gender'];
var isToLong = (str, baseField, baseLength, customLength) => {
  if (baseFormFields.includes(baseField)) {
    return str.length > baseLength;
  }
  return str.length > customLength;
};
var isString = value => typeof value === 'string' || value instanceof String;
var isValidJson = (animationJson, errorMessage) => {
  try {
    if (animationJson.length < 1) {
      console.error(errorMessage);
      return false;
    }
    var jsonString = animationJson;
    if (typeof animationJson !== 'string') {
      jsonString = JSON.stringify(animationJson);
    }
    JSON.parse(jsonString);
    return true;
  } catch (err) {
    console.error(errorMessage);
    return false; //  JSON.parse throw error if string is invalid.
  }
};
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/VidioSection/VidioSection.module.scss
var VidioSection_module = __webpack_require__(350);
;// CONCATENATED MODULE: ./src/components/VidioSection/VidioSection.module.scss

      var VidioSection_module_exported = {};

      
      
      
      
      
      
      
      
      if (VidioSection_module/* default */.Z && VidioSection_module/* default.locals */.Z.locals) {
              VidioSection_module_exported.locals = VidioSection_module/* default.locals */.Z.locals;
            }
            

var VidioSection_module_refs = 0;
var VidioSection_module_update;
var VidioSection_module_options = {};

VidioSection_module_options.styleTagTransform = (styleTagTransform_default());
VidioSection_module_options.setAttributes = (setAttributesWithoutAttributes_default());

      VidioSection_module_options.insert = insertBySelector_default().bind(null, "head");
    
VidioSection_module_options.domAPI = (styleDomAPI_default());
VidioSection_module_options.insertStyleElement = (insertStyleElement_default());

VidioSection_module_exported.use = function(insertOptions) {
  VidioSection_module_options.options = insertOptions || {};

  if (!(VidioSection_module_refs++)) {
    VidioSection_module_update = injectStylesIntoStyleTag_default()(VidioSection_module/* default */.Z, VidioSection_module_options);
  }

  return VidioSection_module_exported;
};
VidioSection_module_exported.unuse = function() {
  if (VidioSection_module_refs > 0 && !--VidioSection_module_refs) {
    VidioSection_module_update();
    VidioSection_module_update = null;
  }
};




       /* harmony default export */ const VidioSection_VidioSection_module = (VidioSection_module_exported);

// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/LanguageSelect/LanguageSelect.module.scss
var LanguageSelect_module = __webpack_require__(198);
;// CONCATENATED MODULE: ./src/components/LanguageSelect/LanguageSelect.module.scss

      var LanguageSelect_module_exported = {};

      
      
      
      
      
      
      
      
      if (LanguageSelect_module/* default */.Z && LanguageSelect_module/* default.locals */.Z.locals) {
              LanguageSelect_module_exported.locals = LanguageSelect_module/* default.locals */.Z.locals;
            }
            

var LanguageSelect_module_refs = 0;
var LanguageSelect_module_update;
var LanguageSelect_module_options = {};

LanguageSelect_module_options.styleTagTransform = (styleTagTransform_default());
LanguageSelect_module_options.setAttributes = (setAttributesWithoutAttributes_default());

      LanguageSelect_module_options.insert = insertBySelector_default().bind(null, "head");
    
LanguageSelect_module_options.domAPI = (styleDomAPI_default());
LanguageSelect_module_options.insertStyleElement = (insertStyleElement_default());

LanguageSelect_module_exported.use = function(insertOptions) {
  LanguageSelect_module_options.options = insertOptions || {};

  if (!(LanguageSelect_module_refs++)) {
    LanguageSelect_module_update = injectStylesIntoStyleTag_default()(LanguageSelect_module/* default */.Z, LanguageSelect_module_options);
  }

  return LanguageSelect_module_exported;
};
LanguageSelect_module_exported.unuse = function() {
  if (LanguageSelect_module_refs > 0 && !--LanguageSelect_module_refs) {
    LanguageSelect_module_update();
    LanguageSelect_module_update = null;
  }
};




       /* harmony default export */ const LanguageSelect_LanguageSelect_module = (LanguageSelect_module_exported);

;// CONCATENATED MODULE: external "react-flag-kit"
const external_react_flag_kit_namespaceObject = require("react-flag-kit");
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/Form/FormInputLanguage/FormInputLanguage.module.scss
var FormInputLanguage_module = __webpack_require__(509);
;// CONCATENATED MODULE: ./src/components/Form/FormInputLanguage/FormInputLanguage.module.scss

      var FormInputLanguage_module_exported = {};

      
      
      
      
      
      
      
      
      if (FormInputLanguage_module/* default */.Z && FormInputLanguage_module/* default.locals */.Z.locals) {
              FormInputLanguage_module_exported.locals = FormInputLanguage_module/* default.locals */.Z.locals;
            }
            

var FormInputLanguage_module_refs = 0;
var FormInputLanguage_module_update;
var FormInputLanguage_module_options = {};

FormInputLanguage_module_options.styleTagTransform = (styleTagTransform_default());
FormInputLanguage_module_options.setAttributes = (setAttributesWithoutAttributes_default());

      FormInputLanguage_module_options.insert = insertBySelector_default().bind(null, "head");
    
FormInputLanguage_module_options.domAPI = (styleDomAPI_default());
FormInputLanguage_module_options.insertStyleElement = (insertStyleElement_default());

FormInputLanguage_module_exported.use = function(insertOptions) {
  FormInputLanguage_module_options.options = insertOptions || {};

  if (!(FormInputLanguage_module_refs++)) {
    FormInputLanguage_module_update = injectStylesIntoStyleTag_default()(FormInputLanguage_module/* default */.Z, FormInputLanguage_module_options);
  }

  return FormInputLanguage_module_exported;
};
FormInputLanguage_module_exported.unuse = function() {
  if (FormInputLanguage_module_refs > 0 && !--FormInputLanguage_module_refs) {
    FormInputLanguage_module_update();
    FormInputLanguage_module_update = null;
  }
};




       /* harmony default export */ const FormInputLanguage_FormInputLanguage_module = (FormInputLanguage_module_exported);

;// CONCATENATED MODULE: ./src/components/Form/FormInputLanguage/languageMap.js
var languageMap = (langKey, label) => {
  var _countryIconKeyMap$la;
  var countryKeys = (_countryIconKeyMap$la = countryIconKeyMap[langKey]) !== null && _countryIconKeyMap$la !== void 0 ? _countryIconKeyMap$la : [langKey.toUpperCase()];
  return {
    countryKeys,
    mappedLabel: langKey === label ? labelKeyMap[langKey] : label
  };
};
var labelKeyMap = {
  en: 'English',
  id: 'Bahasa Indonesia',
  th: 'ภาษาไทย',
  my: 'Bahasa Malaysia'
};
var countryIconKeyMap = {
  en: ['GB', 'US']
};
;// CONCATENATED MODULE: ./src/components/Form/FormInputLanguage/FormInputLanguage.js
function FormInputLanguage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function FormInputLanguage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FormInputLanguage_ownKeys(Object(source), !0).forEach(function (key) { FormInputLanguage_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FormInputLanguage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function FormInputLanguage_defineProperty(obj, key, value) { key = FormInputLanguage_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function FormInputLanguage_toPropertyKey(arg) { var key = FormInputLanguage_toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function FormInputLanguage_toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }







var FormatOptionLabel = _ref => {
  var {
    value,
    selected,
    classes,
    label
  } = _ref;
  var {
    countryKeys,
    mappedLabel
  } = languageMap(value, label);
  var [firstCountryKey] = countryKeys;
  return /*#__PURE__*/external_react_default().createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, !selected && /*#__PURE__*/external_react_default().createElement("div", {
    className: "language-label ms-1 me-auto",
    style: {
      maxWidth: 150,
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }
  }, mappedLabel), /*#__PURE__*/external_react_default().createElement("div", {
    className: classes === null || classes === void 0 ? void 0 : classes.flag
  }, /*#__PURE__*/external_react_default().createElement(external_react_flag_kit_namespaceObject.FlagIcon, {
    code: firstCountryKey,
    size: "auto",
    style: {
      borderRadius: 4,
      overflow: 'hidden'
    }
  })));
};
var SingleValue = _ref2 => {
  var {
    getValue
  } = _ref2;
  var classes = FormInputLanguage_FormInputLanguage_module.locals || {};
  (0,external_react_.useEffect)(() => {
    FormInputLanguage_FormInputLanguage_module.use();
  }, []);
  var [{
    value
  }] = getValue();
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: classes.selectedOption
  }, /*#__PURE__*/external_react_default().createElement(FormatOptionLabel, {
    value: value,
    classes: classes,
    selected: true
  }));
};
var FormInputLanguage = _ref3 => {
  var {
    answers = [],
    onInputChangeHandler,
    isInvalid,
    value
  } = _ref3;
  var classes = FormInput_FormInput_module.locals || {};
  (0,external_react_.useEffect)(() => {
    FormInput_FormInput_module.use();
  }, []);
  var formattedAnswers = answers.map(answer => {
    return typeof answer === 'object' ? answer : {
      value: answer,
      label: answer
    };
  });
  var selectValue = () => {
    return formattedAnswers.find(option => option.value === value);
  };
  return /*#__PURE__*/external_react_default().createElement((Form_default()).Group, {
    controlId: "select_language"
  }, /*#__PURE__*/external_react_default().createElement((external_react_select_default()), {
    id: "select_language",
    name: "select_language",
    "data-testid": "select_language",
    className: "custom-form-control ".concat(classes.formSelectText, " ").concat(isInvalid ? "".concat(classes.customSelectError, " is-invalid") : ''),
    onChange: onInputChangeHandler,
    options: formattedAnswers,
    value: selectValue(),
    isSearchable: false,
    components: {
      SingleValue
    },
    formatOptionLabel: FormatOptionLabel
    // https://react-select.com/styles
    ,
    styles: {
      control: baseStyles => FormInputLanguage_objectSpread(FormInputLanguage_objectSpread({}, baseStyles), {}, {
        // width: 44,
        minHeight: 34,
        position: 'relative',
        borderRadius: 8,
        border: 0
      }),
      menuList: baseStyles => FormInputLanguage_objectSpread(FormInputLanguage_objectSpread({}, baseStyles), {}, {
        position: 'absolute',
        left: 'auto',
        right: 0,
        width: 230,
        backgroundColor: 'white',
        borderWidth: 1,
        borderColor: '#dfdfdf',
        borderStyle: 'solid',
        borderRadius: 10
      }),
      valueContainer: baseStyles => FormInputLanguage_objectSpread(FormInputLanguage_objectSpread({}, baseStyles), {}, {
        padding: 8
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),
      indicatorsContainer: () => ({
        position: 'absolute',
        left: 'auto',
        right: 0,
        width: '100%',
        height: '100%'
      }),
      /**
       * Resolves a bug when select component is located
       *  within a draggable container (ie. Dash preview mode)
       *  whereby the click (ie. open dropdown) event is not
       *  registered
       */
      dropdownIndicator: () => ({
        position: 'absolute',
        left: 'auto',
        right: 0,
        width: '100%',
        height: '100%',
        color: 'transparent'
      })
    }
  }));
};
/* harmony default export */ const FormInputLanguage_FormInputLanguage = (FormInputLanguage);
;// CONCATENATED MODULE: ./src/components/LanguageSelect/LanguageSelect.js





var LanguageSelect = _ref => {
  var {
    className,
    currentLanguage,
    availableLanguages = [],
    onLanguageChange,
    showLabel,
    noBottomSpacer,
    color
  } = _ref;
  var classes = LanguageSelect_LanguageSelect_module.locals || {};
  (0,external_react_.useEffect)(() => {
    LanguageSelect_LanguageSelect_module.use();
  }, []);
  var hasMoreThanOneOption = availableLanguages.length > 1;
  return hasMoreThanOneOption ? /*#__PURE__*/external_react_default().createElement((Form_default()), {
    className: "".concat(className !== null && className !== void 0 ? className : '', " ").concat(classes.languageSelect, " ").concat(!noBottomSpacer ? classes.mbSpace : '')
  }, showLabel && /*#__PURE__*/external_react_default().createElement((Form_default()).Label, {
    htmlFor: "select_language",
    style: {
      color
    }
  }, defaultTransFunction('form.selectLanguage', currentLanguage)), /*#__PURE__*/external_react_default().createElement(FormInputLanguage_FormInputLanguage, {
    name: "select_language",
    type: "select",
    answers: availableLanguages,
    value: currentLanguage,
    size: "sm",
    onInputChangeHandler: e => onLanguageChange(e.value)
  })) : null;
};
/* harmony default export */ const LanguageSelect_LanguageSelect = (LanguageSelect);
;// CONCATENATED MODULE: external "lottie-react"
const external_lottie_react_namespaceObject = require("lottie-react");
var external_lottie_react_default = /*#__PURE__*/__webpack_require__.n(external_lottie_react_namespaceObject);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/VidioSection/VidioForm/InlineHeader/InlineHeader.module.scss
var InlineHeader_module = __webpack_require__(629);
;// CONCATENATED MODULE: ./src/components/VidioSection/VidioForm/InlineHeader/InlineHeader.module.scss

      var InlineHeader_module_exported = {};

      
      
      
      
      
      
      
      
      if (InlineHeader_module/* default */.Z && InlineHeader_module/* default.locals */.Z.locals) {
              InlineHeader_module_exported.locals = InlineHeader_module/* default.locals */.Z.locals;
            }
            

var InlineHeader_module_refs = 0;
var InlineHeader_module_update;
var InlineHeader_module_options = {};

InlineHeader_module_options.styleTagTransform = (styleTagTransform_default());
InlineHeader_module_options.setAttributes = (setAttributesWithoutAttributes_default());

      InlineHeader_module_options.insert = insertBySelector_default().bind(null, "head");
    
InlineHeader_module_options.domAPI = (styleDomAPI_default());
InlineHeader_module_options.insertStyleElement = (insertStyleElement_default());

InlineHeader_module_exported.use = function(insertOptions) {
  InlineHeader_module_options.options = insertOptions || {};

  if (!(InlineHeader_module_refs++)) {
    InlineHeader_module_update = injectStylesIntoStyleTag_default()(InlineHeader_module/* default */.Z, InlineHeader_module_options);
  }

  return InlineHeader_module_exported;
};
InlineHeader_module_exported.unuse = function() {
  if (InlineHeader_module_refs > 0 && !--InlineHeader_module_refs) {
    InlineHeader_module_update();
    InlineHeader_module_update = null;
  }
};




       /* harmony default export */ const InlineHeader_InlineHeader_module = (InlineHeader_module_exported);

;// CONCATENATED MODULE: ./src/components/VidioSection/VidioForm/InlineHeader/InlineHeader.js



var InlineHeader = _ref => {
  var {
    formState,
    brandName,
    brandLogoUrl,
    language,
    isPhoneRequired,
    paywallBannerUrl
  } = _ref;
  var classes = InlineHeader_InlineHeader_module.locals || {};
  (0,external_react_.useEffect)(() => {
    InlineHeader_InlineHeader_module.use();
  }, []);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "content"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: classes.inlineHeader
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "title h4 ".concat(classes.inlineHeaderTitle)
  }, /*#__PURE__*/external_react_default().createElement(VidioElements_VidioFormHeader, {
    formState: formState,
    brandName: brandName,
    brandLogoUrl: brandLogoUrl,
    language: language,
    rounded: false,
    fullWidth: true,
    isPhoneRequired: isPhoneRequired,
    paywallBannerUrl: paywallBannerUrl
  }))));
};
/* harmony default export */ const InlineHeader_InlineHeader = (InlineHeader);
;// CONCATENATED MODULE: ./src/components/VidioSection/VidioElements/VidioBanner.js






var BrandLogoOrPaywallBanner = _ref => {
  var {
    brandLogoUrl,
    paywallBannerUrl,
    colProps,
    inlineHeaderProps
  } = _ref;
  return brandLogoUrl || paywallBannerUrl ? /*#__PURE__*/external_react_default().createElement((Col_default()), {
    lg: colProps.imageBoxWidth,
    className: "".concat(colProps.vidioFormBrandCol, " ").concat(colProps.imageAlignClass),
    style: {
      backgroundColor: colProps.backgroundColor
    }
  }, /*#__PURE__*/external_react_default().createElement(InlineHeader_InlineHeader, inlineHeaderProps)) : null;
};
var VidioBanner = _ref2 => {
  var {
    animationUrl,
    brandLogoUrl,
    paywallBannerUrl,
    inlineHeaderProps,
    colProps
  } = _ref2;
  var [animationData, setAnimationData] = (0,external_react_.useState)(null);
  (0,external_react_.useEffect)(() => {
    var isValidUrlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
    if (isValidUrlRegex.test(animationUrl)) {
      external_axios_default().get(animationUrl).then(_ref3 => {
        var {
          data
        } = _ref3;
        setAnimationData(data);
      });
    }
  }, [animationUrl]);
  var isAnimation = animationData && isValidJson(animationData, 'invalid lottie animation json file');
  return isAnimation ? /*#__PURE__*/external_react_default().createElement((Col_default()), {
    lg: colProps.imageBoxWidth,
    className: "".concat(colProps.vidioFormBrandCol, " ").concat(colProps.imageAlignClass),
    style: {
      backgroundColor: 'white',
      boxShadow: '0 3px 8px 0 rgba(0,0,0,.06)'
    }
  }, /*#__PURE__*/external_react_default().createElement((external_lottie_react_default()), {
    animationData: animationData,
    style: {
      width: '100vw'
    }
  })) : /*#__PURE__*/external_react_default().createElement(BrandLogoOrPaywallBanner, {
    brandLogoUrl: brandLogoUrl,
    paywallBannerUrl: paywallBannerUrl,
    colProps: colProps,
    inlineHeaderProps: inlineHeaderProps
  });
};
/* harmony default export */ const VidioElements_VidioBanner = (VidioBanner);
;// CONCATENATED MODULE: ./src/shared/handleCpdcSubmit.js
function handleCpdcSubmit_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function handleCpdcSubmit_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? handleCpdcSubmit_ownKeys(Object(source), !0).forEach(function (key) { handleCpdcSubmit_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : handleCpdcSubmit_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function handleCpdcSubmit_defineProperty(obj, key, value) { key = handleCpdcSubmit_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function handleCpdcSubmit_toPropertyKey(arg) { var key = handleCpdcSubmit_toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function handleCpdcSubmit_toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable no-param-reassign */

function handleCpdcSubmit(setFormErrors, validateLength, apiUrl, id, bountyId, getDeviceId, campaignId, language, formState, setFormState, transformVidioMessages, vidioErrors, onSubmit, userInfo, callbackReferrer) {
  var campaignName = arguments.length > 15 && arguments[15] !== undefined ? arguments[15] : '';
  var environment = arguments.length > 16 && arguments[16] !== undefined ? arguments[16] : 'development';
  return formData => {
    setFormState(prevState => handleCpdcSubmit_objectSpread(handleCpdcSubmit_objectSpread({}, prevState), {}, {
      submitDisable: true
    }));
    if (!window.grecaptcha) {
      return setFormState(state => handleCpdcSubmit_objectSpread(handleCpdcSubmit_objectSpread({}, state), {}, {
        success: false,
        submitDisable: false,
        message: 'Recaptcha not available, please try refreshing'
      }));
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute('6LefC3YjAAAAAIx8uX9004Xkkx6-l7Z-E19vwWkv', {
        action: 'submit'
      }).then(token => {
        var _window, _window$BountyMedia, _window$BountyMedia$g;
        formData.recaptchaToken = token;
        var length = validateLength(formData);
        if (!length) return;
        var payload = handleCpdcSubmit_objectSpread(handleCpdcSubmit_objectSpread({}, formData), formData.phoneNumber && {
          phoneNumber: "+".concat(formData.phoneNumber)
        });
        var emailToken = formData === null || formData === void 0 ? void 0 : formData.emailToken;
        delete payload.emailToken;
        external_axios_default().post("".concat(apiUrl), handleCpdcSubmit_objectSpread({
          formId: id,
          bountyId: bountyId !== null && bountyId !== void 0 ? bountyId : (_window = window) === null || _window === void 0 ? void 0 : (_window$BountyMedia = _window.BountyMedia) === null || _window$BountyMedia === void 0 ? void 0 : (_window$BountyMedia$g = _window$BountyMedia.getBountyId) === null || _window$BountyMedia$g === void 0 ? void 0 : _window$BountyMedia$g.call(_window$BountyMedia),
          deviceId: getDeviceId(),
          referrer: document.referrer,
          campaignId,
          formData: payload,
          callbackReferrer
        }, emailToken && {
          emailToken
        }), {
          headers: language ? {
            'x-language': language
          } : undefined
        }).then(response => {
          var _response$data, _response$data2, _response$data$catego, _response$data$compan, _response$data$compan2, _response$data$introH, _response$data3, _response$data$introM, _response$data4;
          console.log('log check GTM submission environment:', environment);
          if (environment === 'production') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'connection_completed',
              providerName: response.data.provider.name,
              campaignName,
              campaignId
            });
            console.log('check dataLayer');
            console.log(window.dataLayer);
          }
          setFormState(handleCpdcSubmit_objectSpread({
            success: true,
            message: 'success',
            provider: {
              name: response.data.provider.name,
              productType: response.data.provider.productType,
              productName: response.data.provider.productName
            },
            subscriber: handleCpdcSubmit_objectSpread({
              firstName: formData.firstName,
              lastName: formData.lastName,
              email: formData.email
            }, formData.phoneNumber && {
              phoneNumber: formData.phoneNumber
            }),
            callback: (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.callback
          }, ((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.showPostQuestions) && {
            postQuestions: {
              cpdcId: response.data.cpdcId,
              categories: (_response$data$catego = response.data.categories) !== null && _response$data$catego !== void 0 ? _response$data$catego : [],
              companyImageUrl: (_response$data$compan = response.data.companyImageUrl) !== null && _response$data$compan !== void 0 ? _response$data$compan : '',
              companyName: (_response$data$compan2 = response.data.companyName) !== null && _response$data$compan2 !== void 0 ? _response$data$compan2 : '',
              introHeading: (_response$data$introH = (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.introHeading) !== null && _response$data$introH !== void 0 ? _response$data$introH : {},
              introMessage: (_response$data$introM = (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.introMessage) !== null && _response$data$introM !== void 0 ? _response$data$introM : {}
            }
          }));
        }).catch(error => {
          var _error$response;
          var errorMessage;
          var languageKey = null;
          var errorStatus = error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status;
          var subscriberFirstName = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.firstName) || formData.firstName;
          if (errorStatus === 400) {
            var _error$response$data, _error$response$data2, _error$response2, _error$response2$data, _error$response$data4;
            // check for IndoSat Error messages
            var phoneErrorMessages = [vidioErrors.INDOSAT_INVALID_PHONE_NUMBER, vidioErrors.INDOSAT_PHONE_EXPIRED];
            var errorMessages = [vidioErrors.INVALID_PACKAGE, vidioErrors.INDOSAT_REWARD_QUOTA_EXCEEDED];
            if (phoneErrorMessages.includes((_error$response$data = error.response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message)) {
              var subscriberEmail = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) || formData.email;
              var subscriberPhone = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.phoneNumber) || formData.phoneNumber;
              var {
                productName
              } = error.response.data.provider;
              errorMessage = transformVidioMessages(error.response.data.message, language, {
                subscriberFirstName,
                subscriberEmail,
                subscriberPhone,
                productName: productName.split(/^\D*/gi)[1],
                campaignUrl: window.location.href
              });
            } else if (errorMessages.includes((_error$response$data2 = error.response.data) === null || _error$response$data2 === void 0 ? void 0 : _error$response$data2.message)) {
              var _error$response$data3;
              errorMessage = transformVidioMessages((_error$response$data3 = error.response.data) === null || _error$response$data3 === void 0 ? void 0 : _error$response$data3.message, language, {
                subscriberFirstName
              });
            } else {
              // show default Validation error
              errorMessage = transformVidioMessages(vidioErrors.VALIDATION, language);
            }
            var formFieldErrors = error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data._errors;
            if (formFieldErrors) {
              setFormErrors(formFieldErrors);
            }
            setFormState({
              success: false,
              message: errorMessage,
              hideForm: errorMessages.includes((_error$response$data4 = error.response.data) === null || _error$response$data4 === void 0 ? void 0 : _error$response$data4.message),
              languageKey,
              subscriber: handleCpdcSubmit_objectSpread({
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email
              }, formData.phoneNumber && {
                phoneNumber: formData.phoneNumber
              })
            });
          } else if (errorStatus === 403) {
            errorMessage = transformVidioMessages(error.response.data.reason, language, null, error.response.data.message);
            setFormState({
              success: false,
              message: errorMessage
            });
          } else {
            var _error$response3;
            // this is for error 500

            //for handling indosat response
            if (error !== null && error !== void 0 && (_error$response3 = error.response) !== null && _error$response3 !== void 0 && _error$response3.data.message) {
              errorMessage = transformVidioMessages(error.response.data.message, language, {
                subscriberFirstName,
                campaignUrl: window.location.href
              });
              return setFormState({
                success: false,
                message: errorMessage,
                hideForm: true,
                languageKey
              });
            }

            //for general error
            errorMessage = transformVidioMessages(vidioErrors.SERVER_ERROR, language);
            setFormState({
              success: false,
              message: errorMessage
            });
          }
        }).finally(() => {
          setFormState(prevState => handleCpdcSubmit_objectSpread(handleCpdcSubmit_objectSpread({}, prevState), {}, {
            submitDisable: false
          }));
          onSubmit(formData);
        });
      }).catch(err => {
        setFormState(state => handleCpdcSubmit_objectSpread(handleCpdcSubmit_objectSpread({}, state), {}, {
          success: false,
          message: err.message
        }));
      });
    });
  };
}
/* harmony default export */ const shared_handleCpdcSubmit = (handleCpdcSubmit);
;// CONCATENATED MODULE: ./src/shared/handleVerifyEmail.js
function handleVerifyEmail_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function handleVerifyEmail_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { handleVerifyEmail_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { handleVerifyEmail_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



var emailSchema = external_yup_namespaceObject.string().email();

/**
 * Executes immediately on input blur
 * The same check will be initiated on submission server-side
 *  if a token was not generated here for submission with
 *  the form
 */
function handleVerifyEmail(_x) {
  return _handleVerifyEmail.apply(this, arguments);
}
function _handleVerifyEmail() {
  _handleVerifyEmail = handleVerifyEmail_asyncToGenerator(function* (_ref) {
    var {
      email,
      verifyEmailApi,
      language,
      setFormErrors,
      setEmailToken
    } = _ref;
    if (!window.grecaptcha) {
      return;
    }
    var trimEmail = email.trim();
    if (!verifyEmailApi || !trimEmail) {
      return;
    }
    try {
      emailSchema.validateSync(email);
    } catch (_unused) {
      setFormErrors({
        email: defaultTransFunction('input.email.invalid', language)
      });
      return;
    }
    window.grecaptcha.ready( /*#__PURE__*/handleVerifyEmail_asyncToGenerator(function* () {
      var _response$status;
      var recaptchaToken = yield window.grecaptcha.execute('6LefC3YjAAAAAIx8uX9004Xkkx6-l7Z-E19vwWkv', {
        action: 'verify_email'
      }).catch(() => null);
      if (!recaptchaToken) {
        return; // Early exit, do nothing
      }

      var headers = language ? {
        'x-language': language
      } : undefined;
      var response = yield external_axios_default().post(verifyEmailApi, {
        email,
        recaptchaToken
      }, {
        headers
      }).catch(r => r === null || r === void 0 ? void 0 : r.response);
      var status = (_response$status = response === null || response === void 0 ? void 0 : response.status) !== null && _response$status !== void 0 ? _response$status : 0;
      var dontShowAnErrorState = !status || status >= 200 && status < 300 || status >= 500;
      if (dontShowAnErrorState) {
        var _response$data;
        /**
         * If token is not supplied, the email will be
         *  checked again on submission.
         *
         * The token can be excluded if the api service
         *  failed for any reason (ie. do not report an error)
         */
        if ((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.token) {
          setEmailToken(response.data.token);
        }
        return;
      }
      setFormErrors({
        email: defaultTransFunction('input.email.invalid', language)
      });
    }));
  });
  return _handleVerifyEmail.apply(this, arguments);
}
/* harmony default export */ const shared_handleVerifyEmail = (handleVerifyEmail);
;// CONCATENATED MODULE: ./src/shared/createTranslationProvider.js
var createTranslationProvider_excluded = ["_translations"];
function createTranslationProvider_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = createTranslationProvider_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function createTranslationProvider_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var createTranslationProvider = Component => _ref => {
  var {
      _translations = {}
    } = _ref,
    props = createTranslationProvider_objectWithoutProperties(_ref, createTranslationProvider_excluded);
  return /*#__PURE__*/external_react_default().createElement(Translation_provider.Provider, {
    value: _translations
  }, /*#__PURE__*/external_react_default().createElement(Component, props));
};
;// CONCATENATED MODULE: ./src/components/VidioSection/VidioSection.js
function VidioSection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function VidioSection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? VidioSection_ownKeys(Object(source), !0).forEach(function (key) { VidioSection_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : VidioSection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function VidioSection_defineProperty(obj, key, value) { key = VidioSection_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function VidioSection_toPropertyKey(arg) { var key = VidioSection_toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function VidioSection_toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }





















var VidioSection = _ref => {
  var {
    id,
    apiUrl,
    verifyEmailApi,
    countryApi,
    cityApi,
    PhaseHeader,
    accentColor = '#000000',
    /**
     * example
     * globalSettings = {
     *     mainColor: '#ffffff',
     *     backgroundColor: '#803e3e',
     *     imageBoxColor: '#803e3e',
     *     paddingTop: '0',
     *     paddingBottom: '0',
     * }
     */
    globalSettings,
    campaignId,
    campaignName,
    environment = 'development',
    countries,
    getDeviceId,
    src,
    slides,
    /**
     * example
     * slides = [{
     *     id: '1234-5678-1234-5678',
     *     image: 'https://placehold.it/800x600',
     *     alt: 'Image alt'
     * }]
     */
    brandName = 'Brand name',
    brandLogoUrl = '',
    animationUrl = '',
    paywallBannerUrl = '',
    videoProvider = 'Video provider',
    serviceAvailability = 7,
    emailDescription = 'vidio.voucherLocation',
    phoneDescription = '',
    submitText = 'form.submitData',
    termsAndConditionsUrl,
    campaignUrl,
    /**
     * Modal format deprecated
     * Removed at Claes' request
     */
    inlineForm = true,
    videoProviderUrl,
    baseImageUrl = '',
    /**
     * example
     * terms = [
     *      'First external condition',
     *      'Second external condition',
     *  ],
     */
    terms,
    /**
     * example
     * inputs = [
     *      {
     *          label: 'First Name',
     *          name: 'firstName',
     *          type: 'text',
     *          placeholder: 'First Name',
     *          required: false,
     *      },
     *  ],
     */
    introMessage,
    inputs,
    language,
    hideLanguagePicker,
    availableLanguages,
    onLanguageChange,
    customStyle = {},
    bountyId,
    showOnLoad = false,
    showOnLoadTimout = 3,
    maxLength,
    onSubmit = () => {
      /* doSomeAction - send form */
    },
    onClick = () => {
      /* doSomeAction -tracking? */
    },
    layout,
    isPhoneRequired,
    isWhatsAppDefault,
    textFields,
    excludedFields,
    codeRequestUrl,
    codeVerifyUrl,
    openPostQuestionForm,
    defaultState = {
      formState: null,
      showModal: false,
      formErrors: {}
    },
    previewMode = false,
    userInfo = {},
    onPostConnectCategorySubmitted = () => {
      /* Track submitted categories */
    },
    submittedCategoryIds = [],
    countryData,
    callbackReferrer
  } = _ref;
  var classes = VidioSection_VidioSection_module.locals || {};
  var urlMap = [
  // '72d7729f-0bbb-463b-b4db-3b5e7262ef0b', // Unilever Panda Pro
  'fe15130a-3f26-499f-8d11-01abeebeabb4' // Unilever LINEMAN
  // '70538f14-a992-40db-bc84-4eae5c92e9b3', // Unilever Iqiyi
  ];

  var termAndConditionsUrlLang = urlMap.includes(campaignId) ? termsAndConditionsUrl : "".concat(termsAndConditionsUrl, "/").concat(language);
  var [showModal, setShowModal] = (0,external_react_.useState)(defaultState.showModal);
  var [formState, setFormState] = (0,external_react_.useState)(defaultState.formState);
  var [formErrors, setFormErrors] = (0,external_react_.useState)(defaultState.formErrors);
  var [emailToken, setEmailToken] = (0,external_react_.useState)('');
  var resetFormError = key => {
    setFormErrors(state => {
      var _state = state !== null && state !== void 0 ? state : {};
      delete _state[key];
      return _state;
    });
  };
  (0,external_react_.useEffect)(() => {
    if (!previewMode) {
      var script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?render=6LefC3YjAAAAAIx8uX9004Xkkx6-l7Z-E19vwWkv';
      document.body.appendChild(script);
    }
    VidioSection_VidioSection_module.use();
    if (showOnLoad) {
      setTimeout(() => {
        setShowModal(true);
      }, showOnLoadTimout * 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var onCategorySelect = (cpdcId, categoryId) => {
    if (!inlineForm) onHideModal();
    openPostQuestionForm({
      cpdcId,
      campaignId,
      categoryId,
      bountyId,
      getDeviceId,
      brandName,
      config: {
        accentColor,
        backgroundColor: globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.imageBoxColor,
        color: globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.mainColor,
        imageBoxColor: globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.imageBoxColor,
        inputFontSize: layout === null || layout === void 0 ? void 0 : layout.inputFontSize
      },
      onPostConnectCategorySubmitted,
      submittedCategoryIds
    });
  };
  var validateLength = data => {
    var error = {};
    var errMessage = defaultTransFunction('form.toLong', language);
    Object.keys(data).map(field => {
      var el = data[field];
      if (!el || !isString(el)) return;
      var baseLength = maxLength && maxLength.defaultField || 100;
      var customLength = maxLength && maxLength.customField || 1000;
      if (isToLong(data[field], field, baseLength, customLength)) {
        error[field] = errMessage;
      }
    });
    if (Object.keys(error).length < 1) return true;
    setFormErrors(error);
    return false;
  };
  var onLinkClickHandler = () => {
    setShowModal(true);
    onClick();
  };
  var onHideModal = clearFormState => {
    if (clearFormState || formState !== null && formState !== void 0 && formState.success) {
      setFormState(null);
    }
    setShowModal(false);
  };
  var onResetError = fieldName => {
    if (formErrors && formErrors[fieldName]) {
      setFormErrors(prevState => VidioSection_objectSpread(VidioSection_objectSpread({}, prevState), {
        [fieldName]: null
      }));
    }
  };
  var getCarouselHtml = () => {
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, showModal && /*#__PURE__*/external_react_default().createElement(VidioModal_VidioModal, {
      accentColor: accentColor,
      formState: formState,
      additionalResponse: formState === vidioErrors.ERROR_USER_RECOGNISED,
      onHideModal: onHideModal,
      brandName: brandName,
      brandLogoUrl: brandLogoUrl,
      successType: phoneDescription ? 'sms' : 'email',
      videoProvider: videoProvider,
      serviceAvailability: serviceAvailability,
      termsAndConditionsUrl: termAndConditionsUrlLang,
      campaignUrl: campaignUrl,
      videoProviderUrl: videoProviderUrl,
      language: language,
      isPhoneRequired: isPhoneRequired,
      onCategorySelect: onCategorySelect,
      previewMode: previewMode,
      baseImageUrl: baseImageUrl,
      paywallBannerUrl: paywallBannerUrl,
      userInfo: userInfo,
      PhaseHeader: PhaseHeader
    }, !hideLanguagePicker && /*#__PURE__*/external_react_default().createElement(LanguageSelect_LanguageSelect, {
      availableLanguages: availableLanguages,
      currentLanguage: language,
      onLanguageChange: onLanguageChange
    }), /*#__PURE__*/external_react_default().createElement(Form_Form, {
      accentColor: globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.imageBoxColor,
      introMessage: introMessage,
      terms: terms,
      selectInputs: inputs,
      countries: countries,
      emailDescription: emailDescription,
      phoneDescription: phoneDescription,
      submitText: submitText,
      onSubmit: shared_handleCpdcSubmit(setFormErrors, validateLength, apiUrl, id, bountyId, getDeviceId, campaignId, language, formState, setFormState, transformVidioMessages, vidioErrors, onSubmit, userInfo, callbackReferrer),
      onEmailBlur: email => shared_handleVerifyEmail({
        email,
        verifyEmailApi,
        language,
        setFormErrors,
        setEmailToken
      }),
      errors: formErrors,
      resetFormError: resetFormError,
      language: language,
      onResetError: onResetError,
      brandName: brandName,
      videoProvider: videoProvider,
      serviceAvailability: serviceAvailability,
      termsAndConditionsUrl: termAndConditionsUrlLang,
      videoProviderUrl: videoProviderUrl,
      maxLength: maxLength,
      formId: id,
      inputFontSize: layout === null || layout === void 0 ? void 0 : layout.inputFontSize,
      isPhoneRequired: isPhoneRequired,
      isWhatsAppDefault: isWhatsAppDefault,
      textFields: textFields,
      excludedFields: excludedFields,
      codeRequestUrl: codeRequestUrl,
      codeVerifyUrl: codeVerifyUrl,
      countryApi: countryApi,
      cityApi: cityApi,
      userInfo: userInfo,
      countryData: countryData,
      emailToken: emailToken,
      PhaseHeader: PhaseHeader
    })), /*#__PURE__*/external_react_default().createElement((Carousel_default()), {
      key: language
    }, slides && slides.length ? slides.map((slide, index) => /*#__PURE__*/external_react_default().createElement((Carousel_default()).Item, {
      key: index.toString()
    }, /*#__PURE__*/external_react_default().createElement((Image_default()), {
      className: classes.image,
      onClick: onLinkClickHandler,
      src: slide.image,
      alt: slide.alt
    }))) : /*#__PURE__*/external_react_default().createElement((Carousel_default()).Item, null, /*#__PURE__*/external_react_default().createElement((Image_default()), {
      className: classes.image,
      onClick: onLinkClickHandler,
      src: src,
      alt: "Vidio banner",
      fluid: true
    }))));
  };
  var getInlineFromHtml = () => {
    var formWidth = (layout === null || layout === void 0 ? void 0 : layout.formWidth) || 6;
    var imageBoxWidth = 12 - formWidth;
    var imageAlignClass = '';
    if ((layout === null || layout === void 0 ? void 0 : layout.imageBoxPosition) === 'top') {
      formWidth = 12;
      imageBoxWidth = 12;
    }
    if ((layout === null || layout === void 0 ? void 0 : layout.imageBoxPosition) !== 'top' && (layout === null || layout === void 0 ? void 0 : layout.imageAlign) === 'top') {
      imageAlignClass = classes.BannerTop;
    } else if ((layout === null || layout === void 0 ? void 0 : layout.imageBoxPosition) !== 'top' && (layout === null || layout === void 0 ? void 0 : layout.imageAlign) === 'bottom') {
      imageAlignClass = classes.BannerBottom;
    }
    return /*#__PURE__*/external_react_default().createElement((Row_default()), {
      className: "g-0"
    }, /*#__PURE__*/external_react_default().createElement(VidioElements_VidioBanner, {
      brandLogoUrl: brandLogoUrl,
      animationUrl: animationUrl,
      colProps: {
        imageBoxWidth,
        imageAlignClass,
        vidioFormBrandCol: classes.vidioFormBanner,
        backgroundColor: globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.imageBoxColor
      },
      inlineHeaderProps: {
        formState,
        brandName,
        brandLogoUrl,
        language,
        accentColor,
        isPhoneRequired,
        paywallBannerUrl
      }
    }), /*#__PURE__*/external_react_default().createElement((Col_default()), {
      lg: formWidth,
      className: "".concat(classes.VideoFormApplicationCol, " ").concat(!brandLogoUrl ? "mx-auto" : '')
    }, !hideLanguagePicker && /*#__PURE__*/external_react_default().createElement(LanguageSelect_LanguageSelect, {
      availableLanguages: availableLanguages,
      currentLanguage: language,
      onLanguageChange: onLanguageChange,
      className: "mt-2",
      color: globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.mainColor
    }), /*#__PURE__*/external_react_default().createElement(VidioElements_VidioFormBody, {
      formState: formState,
      introMessage: introMessage,
      termsAndConditionsUrl: termsAndConditionsUrl,
      serviceAvailability: serviceAvailability,
      videoProvider: videoProvider,
      additionalResponse: formState === vidioErrors.ERROR_USER_RECOGNISED,
      videoProviderUrl: videoProviderUrl,
      campaignUrl: campaignUrl,
      brandName: brandName,
      successType: phoneDescription ? 'sms' : 'email',
      onHideModal: onHideModal,
      language: language,
      color: globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.mainColor,
      isPhoneRequired: isPhoneRequired,
      onCategorySelect: onCategorySelect,
      baseImageUrl: baseImageUrl,
      onPostConnectCategorySubmitted: onPostConnectCategorySubmitted,
      submittedCategoryIds: submittedCategoryIds,
      userInfo: userInfo,
      PhaseHeader: PhaseHeader
    }, /*#__PURE__*/external_react_default().createElement(Form_Form, {
      formState: formState,
      accentColor: globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.imageBoxColor
      // Form now has a static white background
      // color={globalSettings?.mainColor}
      ,
      color: "#000",
      terms: terms,
      introMessage: introMessage,
      selectInputs: inputs,
      countries: countries,
      emailDescription: emailDescription,
      phoneDescription: phoneDescription,
      submitText: submitText,
      onSubmit: shared_handleCpdcSubmit(setFormErrors, validateLength, apiUrl, id, bountyId, getDeviceId, campaignId, language, formState, setFormState, transformVidioMessages, vidioErrors, onSubmit, userInfo, callbackReferrer, campaignName, environment),
      onEmailBlur: email => shared_handleVerifyEmail({
        email,
        verifyEmailApi,
        language,
        setFormErrors,
        setEmailToken
      }),
      errors: formErrors,
      resetFormError: resetFormError,
      language: language,
      onResetError: onResetError,
      brandName: brandName,
      videoProvider: videoProvider,
      serviceAvailability: serviceAvailability,
      termsAndConditionsUrl: termAndConditionsUrlLang,
      videoProviderUrl: videoProviderUrl,
      maxLength: maxLength,
      formId: id,
      inputFontSize: layout === null || layout === void 0 ? void 0 : layout.inputFontSize,
      isPhoneRequired: isPhoneRequired,
      isWhatsAppDefault: isWhatsAppDefault,
      textFields: textFields,
      excludedFields: excludedFields,
      codeRequestUrl: codeRequestUrl,
      codeVerifyUrl: codeVerifyUrl,
      countryApi: countryApi,
      cityApi: cityApi,
      userInfo: userInfo,
      countryData: countryData,
      emailToken: emailToken,
      PhaseHeader: PhaseHeader
    }))));
  };
  var versionToDisplay = 'unknown';
  try {
    versionToDisplay = "3.3.6"; // eslint-disable-line no-undef
  } catch (error) {
    console.warn('Cannot get version of application.');
  }
  return /*#__PURE__*/external_react_default().createElement(containers_ComponentContainer, {
    style: customStyle
  }, inlineForm ? getInlineFromHtml() : getCarouselHtml(), /*#__PURE__*/external_react_default().createElement("div", {
    "data-test-version": "".concat(versionToDisplay)
  }));
};
/* harmony default export */ const VidioSection_VidioSection = (createTranslationProvider(VidioSection));
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/PostQuestions/ModalForm/ModalForm.module.scss
var ModalForm_module = __webpack_require__(356);
;// CONCATENATED MODULE: ./src/components/PostQuestions/ModalForm/ModalForm.module.scss

      var ModalForm_module_exported = {};

      
      
      
      
      
      
      
      
      if (ModalForm_module/* default */.Z && ModalForm_module/* default.locals */.Z.locals) {
              ModalForm_module_exported.locals = ModalForm_module/* default.locals */.Z.locals;
            }
            

var ModalForm_module_refs = 0;
var ModalForm_module_update;
var ModalForm_module_options = {};

ModalForm_module_options.styleTagTransform = (styleTagTransform_default());
ModalForm_module_options.setAttributes = (setAttributesWithoutAttributes_default());

      ModalForm_module_options.insert = insertBySelector_default().bind(null, "head");
    
ModalForm_module_options.domAPI = (styleDomAPI_default());
ModalForm_module_options.insertStyleElement = (insertStyleElement_default());

ModalForm_module_exported.use = function(insertOptions) {
  ModalForm_module_options.options = insertOptions || {};

  if (!(ModalForm_module_refs++)) {
    ModalForm_module_update = injectStylesIntoStyleTag_default()(ModalForm_module/* default */.Z, ModalForm_module_options);
  }

  return ModalForm_module_exported;
};
ModalForm_module_exported.unuse = function() {
  if (ModalForm_module_refs > 0 && !--ModalForm_module_refs) {
    ModalForm_module_update();
    ModalForm_module_update = null;
  }
};




       /* harmony default export */ const ModalForm_ModalForm_module = (ModalForm_module_exported);

;// CONCATENATED MODULE: ./src/components/PostQuestions/Form/FormHeader.js



var FormHeader = _ref => {
  var {
    formState,
    brandName,
    brandLogoUrl,
    language,
    rounded = true,
    fullWidth = false
  } = _ref;
  return render(formState, brandName, brandLogoUrl, language, rounded, fullWidth);
};
function render(formState, brandName, brandLogoUrl, language) {
  var rounded = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var fullWidth = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  if (!formState && brandLogoUrl) {
    return /*#__PURE__*/external_react_default().createElement((Image_default()), {
      "data-test-id": "modal-brand-log",
      src: brandLogoUrl,
      alt: "".concat(brandName, " logo"),
      fluid: true,
      rounded: rounded,
      className: fullWidth ? 'w-100' : ''
    });
  }
  if (formState) {
    return /*#__PURE__*/external_react_default().createElement("div", null, formState.success ? defaultTransFunction('form.successTitle', language) : defaultTransFunction('form.errorTitle', language));
  }
  return null;
}
/* harmony default export */ const Form_FormHeader = (FormHeader);
;// CONCATENATED MODULE: ./src/components/PostQuestions/Form/FormBody.js

var FormBody = _ref => {
  var {
    children,
    formState,
    successMessage,
    color = '#000000'
  } = _ref;
  if (formState !== null && formState !== void 0 && formState.success) {
    return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("p", {
      style: {
        color,
        textAlign: 'center'
      }
    }, " ", successMessage, " "));
  }
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, formState !== null && formState !== void 0 && formState.message ? /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", {
    style: {
      color,
      textAlign: 'center'
    }
  }, formState.message), formState !== null && formState !== void 0 && formState.supplementalMessage ? /*#__PURE__*/external_react_default().createElement("p", {
    style: {
      color,
      textAlign: 'center'
    }
  }, formState.supplementalMessage) : null) : null, children);
};
/* harmony default export */ const Form_FormBody = (FormBody);
;// CONCATENATED MODULE: ./src/components/PostQuestions/ModalForm/ModalForm.js








var ModalForm = _ref => {
  var {
    children,
    formState,
    onHideModal,
    brandName,
    brandLogoUrl,
    successMessage,
    language,
    isInitError,
    isInitialising,
    onRetryInit,
    previewMode = false
  } = _ref;
  var classes = ModalForm_ModalForm_module.locals || {};
  (0,external_react_.useEffect)(() => {
    ModalForm_ModalForm_module.use();
  }, []);
  var showLoader = !isInitError && isInitialising;
  var showInitError = isInitError;
  var showForm = !isInitError && !isInitialising; // Includes "Success" state
  var backdropState = previewMode ? true : 'static';
  return /*#__PURE__*/external_react_default().createElement((Modal_default()), {
    show: true,
    centered: true,
    backdrop: backdropState,
    keyboard: false,
    className: classes.defaultModalForm,
    onHide: onHideModal
  }, /*#__PURE__*/external_react_default().createElement((Modal_default()).Header, {
    closeButton: true
  }, /*#__PURE__*/external_react_default().createElement((Modal_default()).Title, null, /*#__PURE__*/external_react_default().createElement(Form_FormHeader, {
    formState: formState,
    brandName: brandName,
    brandLogoUrl: brandLogoUrl,
    language: language
  }))), /*#__PURE__*/external_react_default().createElement((Modal_default()).Body, null, showLoader && /*#__PURE__*/external_react_default().createElement("p", {
    className: classes.loader
  }, "One moment.."), showInitError && /*#__PURE__*/external_react_default().createElement("p", {
    className: classes.center
  }, /*#__PURE__*/external_react_default().createElement(components_Translate, {
    langKey: "postQuestionInitError",
    language: language
  }), /*#__PURE__*/external_react_default().createElement(Button, {
    variant: "text",
    onClick: onRetryInit,
    style: {
      border: 0,
      background: 'none'
    }
  }, /*#__PURE__*/external_react_default().createElement(components_Translate, {
    langKey: "form.tryAgain",
    language: language
  })), "."), showForm && /*#__PURE__*/external_react_default().createElement(Form_FormBody, {
    formState: formState,
    successMessage: successMessage
  }, children)));
};
/* harmony default export */ const ModalForm_ModalForm = (ModalForm);
;// CONCATENATED MODULE: ./src/components/PostQuestions/Form/Form.js
function Form_Form_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Form_Form_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Form_Form_ownKeys(Object(source), !0).forEach(function (key) { Form_Form_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Form_Form_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Form_Form_defineProperty(obj, key, value) { key = Form_Form_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function Form_Form_toPropertyKey(arg) { var key = Form_Form_toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function Form_Form_toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }









var initialValues = _ref => {
  var {
    selectInputs,
    textFields
  } = _ref;
  var values = {};
  var customFields = [...textFields, ...selectInputs];
  for (var input of customFields) {
    var value = input.isMulti ? [] : '';
    values[input.name] = value;
  }
  return values;
};
var validationSchema = (selectInputs, textFields) => {
  var schema = external_yup_namespaceObject.object().shape({});
  var questionFields = [...selectInputs, ...textFields];
  var requiredFields = questionFields.filter(input => input.required);
  requiredFields.forEach(input => {
    if (input.answers) {
      schema.fields[input.name] = input.isMulti ? external_yup_namespaceObject.array().min(1, 'You must select at least one answer') : external_yup_namespaceObject.string().required('You must select an answer');
    } else {
      schema.fields[input.name] = external_yup_namespaceObject.string().required('You must enter an answer');
    }
    schema._nodes.push(input.name);
  });
  return schema;
};
var Form_Form_Form = _ref2 => {
  var {
    formId = '',
    accentColor = '#000000',
    color = '#000000',
    selectInputs = [],
    introMessage,
    footerMessage,
    submitText = 'form.submitTitle',
    language,
    inputFontSize,
    formErrors,
    onResetError = () => {},
    textFields = [],
    isPostingForm,
    onSubmit
  } = _ref2;
  var classes = Form_Form_module.locals || {};
  (0,external_react_.useEffect)(() => {
    Form_Form_module.use();
  }, []);
  var inputStyle = {
    fontSize: inputFontSize
  };
  var renderFormInputs = (setFieldValue, values, errors, touched) => {
    var questionFields = [];
    selectInputs.forEach(el => {
      questionFields.push( /*#__PURE__*/external_react_default().createElement(FormInput_FormInput, {
        key: el.name,
        required: el.required || false,
        name: el.name,
        label: el.label,
        type: el.type || 'text',
        placeholder: el.placeholder || '',
        answers: el.answers || '',
        errors: Form_getError(el.name, errors, touched, formErrors),
        controlId: "formCustom".concat(el.name, "_").concat(formId),
        text: el.text,
        style: inputStyle,
        onInputChangeHandler: event => {
          var _ref3, _event$value;
          var value = el.isMulti && Array.isArray(event) ? event.map(o => o.value) : (_ref3 = (_event$value = event === null || event === void 0 ? void 0 : event.value) !== null && _event$value !== void 0 ? _event$value : event) !== null && _ref3 !== void 0 ? _ref3 : [];
          setFieldValue([el.name], value);
          onResetError(el.name);
        },
        getOptionValue: option => option.value,
        value: values[el.name],
        isInvalid: !!(formErrors !== null && formErrors !== void 0 && formErrors[el.name] || errors[el.name] && touched[el.name]),
        isMulti: el.isMulti
      }));
    });
    textFields.forEach(el => {
      questionFields.push( /*#__PURE__*/external_react_default().createElement(FormInput_FormInput, {
        key: el.name,
        required: el.required || false,
        name: el.name,
        label: el.label,
        placeholder: el.placeholder || '',
        errors: Form_getError(el.name, errors, touched, formErrors),
        controlId: "formCustom".concat(el.name, "_").concat(formId),
        style: inputStyle,
        text: el.text,
        onInputChangeHandler: _ref4 => {
          var {
            target
          } = _ref4;
          setFieldValue([el.name], target.value);
          onResetError(el.name);
        },
        value: values[el.name],
        isInvalid: !!(formErrors !== null && formErrors !== void 0 && formErrors[el.name] || errors[el.name] && touched[el.name])
      }));
    });
    return questionFields;
  };
  var beforeSubmitHandler = (values, formik) => {
    var formValues = Form_Form_objectSpread({}, values);

    // convert all array values to comma-delimited strings
    for (var [key, value] of Object.entries(formValues)) {
      if (Array.isArray(value)) {
        formValues[key] = value.join(',');
      }
    }
    onSubmit(formValues, formik);
  };
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: classes.formOuter
  }, /*#__PURE__*/external_react_default().createElement(external_formik_namespaceObject.Formik, {
    onSubmit: beforeSubmitHandler,
    validateOnChange: false // So errors can be manually set prior to submit
    ,
    enableReinitialize: true // formik somehow persists old init values without this
    ,
    initialValues: initialValues({
      selectInputs,
      textFields
    }),
    validationSchema: validationSchema(selectInputs, textFields)
  }, _ref5 => {
    var {
      handleSubmit,
      // handleChange,
      values,
      errors,
      // status,
      setFieldValue,
      // setFieldError,
      // setFieldTouched,
      // setErrors,
      touched
    } = _ref5;
    return /*#__PURE__*/external_react_default().createElement((Form_default()), {
      noValidate: true,
      onSubmit: handleSubmit,
      style: {
        color
      }
    }, introMessage, renderFormInputs(setFieldValue, values, errors, touched), footerMessage ? /*#__PURE__*/external_react_default().createElement("p", null, footerMessage) : null, errors && errors.formData && /*#__PURE__*/external_react_default().createElement((Alert_default()), {
      variant: "danger"
    }, errors.formData), /*#__PURE__*/external_react_default().createElement((Button_default()), {
      variant: "primary",
      type: "submit",
      disabled: isPostingForm,
      style: {
        backgroundColor: accentColor,
        outlineColor: accentColor,
        borderColor: color
      }
    }, defaultTransFunction(submitText, language)));
  }));
};
function Form_getError(fieldName, errors, touched) {
  var SSerrors = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (SSerrors[fieldName]) {
    return SSerrors[fieldName];
  }
  return errors[fieldName] && touched[fieldName] ? errors[fieldName] : null;
}
/* harmony default export */ const PostQuestions_Form_Form = (Form_Form_Form);
;// CONCATENATED MODULE: ./src/components/PostQuestions/PostQuestions.handleSubmit.js

function handlePostQuestionSubmit(setFormErrors, setPostingForm, validateLength, apiUrl, id, cpdcId, categoryId, campaignId, bountyId, getDeviceId, language, setFormState, transformVidioMessages, vidioErrors, previewMode) {
  var onPostConnectCategorySubmitted = arguments.length > 15 && arguments[15] !== undefined ? arguments[15] : () => {};
  var submittedCategoryIds = arguments.length > 16 && arguments[16] !== undefined ? arguments[16] : [];
  return formData => {
    var _window, _window$BountyMedia, _window$BountyMedia$g;
    var length = validateLength(formData);
    if (!length || previewMode) {
      return;
    }
    setPostingForm(true);
    var url = apiUrl.replace(':cpdcId', cpdcId).replace(':categoryId', categoryId);
    external_axios_default().post(url, {
      formId: id,
      bountyId: bountyId !== null && bountyId !== void 0 ? bountyId : (_window = window) === null || _window === void 0 ? void 0 : (_window$BountyMedia = _window.BountyMedia) === null || _window$BountyMedia === void 0 ? void 0 : (_window$BountyMedia$g = _window$BountyMedia.getBountyId) === null || _window$BountyMedia$g === void 0 ? void 0 : _window$BountyMedia$g.call(_window$BountyMedia),
      campaignId,
      deviceId: getDeviceId(),
      referrer: document.referrer,
      formData
    }, {
      headers: language ? {
        'x-language': language
      } : undefined
    }).then(() => {
      setFormState({
        success: true
      });

      // update the ids that have been submitted
      onPostConnectCategorySubmitted([...submittedCategoryIds, categoryId]);
    }).catch(error => {
      var _error$response$data$, _error$response, _error$response$data, _error$response2, _error$response3;
      var errorMessage;
      var supplementalMessage = (_error$response$data$ = error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.supplemental) !== null && _error$response$data$ !== void 0 ? _error$response$data$ : '';
      if ((error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status) === 400) {
        var _error$response$data2;
        errorMessage = transformVidioMessages(vidioErrors.VALIDATION, language);
        if ((_error$response$data2 = error.response.data) !== null && _error$response$data2 !== void 0 && _error$response$data2._errors) {
          setFormErrors(error.response.data._errors);
        } else {
          setFormState({
            success: false,
            message: errorMessage,
            supplementalMessage
          });
        }
      } else if ((error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) === 403) {
        errorMessage = transformVidioMessages(error.response.data.reason, language);
        setFormState({
          success: false,
          message: errorMessage,
          supplementalMessage
        });
      } else {
        errorMessage = transformVidioMessages(vidioErrors.SERVER_ERROR, language);
        setFormState({
          success: false,
          message: errorMessage,
          supplementalMessage
        });
      }
    }).finally(() => setPostingForm(false));
  };
}
/* harmony default export */ const PostQuestions_handleSubmit = (handlePostQuestionSubmit);
;// CONCATENATED MODULE: ./src/components/PostQuestions/PostQuestions.hooks.js
function PostQuestions_hooks_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PostQuestions_hooks_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PostQuestions_hooks_ownKeys(Object(source), !0).forEach(function (key) { PostQuestions_hooks_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PostQuestions_hooks_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function PostQuestions_hooks_defineProperty(obj, key, value) { key = PostQuestions_hooks_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function PostQuestions_hooks_toPropertyKey(arg) { var key = PostQuestions_hooks_toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function PostQuestions_hooks_toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }







var usePostQuestions = _ref => {
  var {
    /* Source: SSR (static) */
    id,
    apiGetFormUrl,
    apiPostUrl,
    /* Source: Vidio module (dynamic) */
    language,
    cpdcId,
    campaignId,
    categoryId,
    bountyId,
    getDeviceId,
    config,
    /* Dashboard */
    previewMode = false,
    openPreviewTick = 0,
    previewState = {},
    /* Storybook, Default states */
    defaultState = {
      initialised: false,
      isInitError: false,
      loading: false,
      formState: null,
      disableGetForm: false,
      showModal: false,
      selectInputs: [],
      textFields: [],
      introMessage: '',
      footerMessage: '',
      successMessage: '',
      formErrors: {}
    },
    onPostConnectCategorySubmitted,
    submittedCategoryIds
  } = _ref;
  var [formUid, setFormUid] = (0,external_react_.useState)(0);
  var [initialised, setInitialised] = (0,external_react_.useState)(defaultState.initialised);
  var [isInitError, setIsInitError] = (0,external_react_.useState)(defaultState.isInitError);
  var [showModal, setShowModal] = (0,external_react_.useState)(!!cpdcId || defaultState.showModal);
  var [introMessage, setIntroMessage] = (0,external_react_.useState)(defaultState.introMessage);
  var [footerMessage, setFooterMessage] = (0,external_react_.useState)(defaultState.footerMessage);
  var [successMessage, setSuccessMessage] = (0,external_react_.useState)(defaultState.successMessage);
  var [selectInputs, setSelectInputs] = (0,external_react_.useState)(defaultState.selectInputs);
  var [textFields, setTextFields] = (0,external_react_.useState)(defaultState.textFields);
  var [isPostingForm, setPostingForm] = (0,external_react_.useState)(false);
  var [formState, setFormState] = (0,external_react_.useState)(defaultState.formState);
  var [formErrors, setFormErrors] = (0,external_react_.useState)(defaultState.formErrors);
  var getFormData = () => {
    if (defaultState.disableGetForm || previewMode) {
      return;
    }
    setIsInitError(false);
    var url = apiGetFormUrl.replace(':campaignId', campaignId).replace(':categoryId', categoryId);
    external_axios_default().get(url).then(response => {
      var _data$translations$la, _data$translations;
      var {
        data
      } = response;
      var translation = (_data$translations$la = (_data$translations = data.translations) === null || _data$translations === void 0 ? void 0 : _data$translations[language]) !== null && _data$translations$la !== void 0 ? _data$translations$la : data.translations.en;
      if (!translation) {
        throw new Error('PostQuestion form result found no translation');
      }
      setIntroMessage(translation.introMessage);
      setFooterMessage(translation.footerMessage);
      setSuccessMessage(translation.successMessage);
      setSelectInputs(translation.inputs);
      setTextFields(translation.textFields);
      setInitialised(true);
    }).catch(error => {
      setIsInitError(true);
      console.error(error);
    });
  };
  var validateLength = data => {
    var error = {};
    var errMessage = defaultTransFunction('form.toLong', language);
    Object.keys(data).map(field => {
      var el = data[field];
      if (!el || !isString(el)) return;
      var baseLength = (config === null || config === void 0 ? void 0 : config.maxLength) && config.maxLength.defaultField || 100;
      var customLength = (config === null || config === void 0 ? void 0 : config.maxLength) && config.maxLength.customField || 1000;
      if (isToLong(data[field], field, baseLength, customLength)) {
        error[field] = errMessage;
      }
    });
    if (Object.keys(error).length < 1) return true;
    setFormErrors(error);
    return false;
  };
  var onHideModal = () => {
    if (formState) {
      setFormState(null);
    }
    setShowModal(false);
  };
  var onResetError = fieldName => {
    if (formErrors && formErrors[fieldName]) {
      setFormErrors(prevState => PostQuestions_hooks_objectSpread(PostQuestions_hooks_objectSpread({}, prevState), {
        [fieldName]: null
      }));
    }
  };
  (0,external_react_.useEffect)(() => {
    if (cpdcId && categoryId || openPreviewTick) {
      setFormUid(x => x + 1);
      setShowModal(true);
    }
  }, [cpdcId, categoryId, openPreviewTick]);
  (0,external_react_.useEffect)(() => {
    if (showModal) {
      getFormData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  /* Dashboard preview state changes */

  (0,external_react_.useEffect)(() => {
    if (previewMode && previewState) {
      setIntroMessage(previewState.introMessage);
      setFooterMessage(previewState.footerMessage);
      setSuccessMessage(previewState.successMessage);
      setSelectInputs(previewState.selectInputs);
      setTextFields(previewState.textFields);
      setInitialised(true);
    }
  }, [previewMode, previewState]);
  var getters = {
    formUid,
    showModal,
    formState,
    formErrors,
    isPostingForm,
    selectInputs,
    textFields,
    introMessage,
    footerMessage,
    successMessage,
    language,
    isInitialising: !initialised && showModal || defaultState.loading,
    isInitError
  };
  var actions = {
    onResetError,
    onHideModal,
    onRetryInit: getFormData,
    onSubmit: PostQuestions_handleSubmit(setFormErrors, setPostingForm, validateLength, apiPostUrl, id, cpdcId, categoryId, campaignId, bountyId, getDeviceId, language, setFormState, transformVidioMessages, vidioErrors, previewMode, onPostConnectCategorySubmitted, submittedCategoryIds)
  };
  return [getters, actions];
};
/* harmony default export */ const PostQuestions_hooks = (usePostQuestions);
;// CONCATENATED MODULE: ./src/components/PostQuestions/PostQuestions.js






var PostQuestionCategoriesPreview = /*#__PURE__*/(0,external_react_.lazy)(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 457)));

/**
 * Post Questions flow
 *
 * 1. Mounted, invisible in page (as module, showModal: false)
 * 2. When data is available, pass required props: cpdcId, categoryId, ...
 * 3. Init (step i): showModal = true (loading state)
 * 4. Init (step ii): getFormData() triggered (loading state)
 * 5. Display form (or retry option)
 * 6. Submit form (step i): (local validation, display errors, allow retries)
 * 7. Submit form (step ii): Server validation (display errors, allow retries)
 * 8. Display success message
 *
 * Translations:
 *  Language comes from the vidio component
 *  Language defaults to 'en' on the translation object if the vidio language does not match
 *      available translations in the Post Question config
 *
 * IMPORTANT: Full language support still TBD in future sprint
 */

var PostQuestions = props => {
  var classes = Form_Form_module.locals || {};
  (0,external_react_.useEffect)(() => {
    Form_Form_module.use();
  }, []);
  var [getters, actions] = PostQuestions_hooks(props);
  var {
    id,
    brandName = '',
    brandLogoUrl = '',
    submitText = 'form.submitTitle',
    language = 'en',
    customStyle = {},
    config = {
      accentColor: '#000000',
      backgroundColor: '#ffffff',
      imageBoxColor: '#000',
      color: '#000000'
    },
    /* Dashboard preview mode  */
    previewMode = false,
    categoryPreview = {},
    onOpenPreviewModal = () => {},
    baseImageUrl = ''
  } = props;
  var {
    formUid,
    isInitialising,
    isInitError,
    showModal,
    formState,
    formErrors,
    isPostingForm,
    selectInputs,
    textFields,
    introMessage,
    footerMessage,
    successMessage
  } = getters;
  var {
    onResetError,
    onHideModal,
    onSubmit,
    onRetryInit
  } = actions;
  if (!showModal && previewMode) {
    return /*#__PURE__*/external_react_default().createElement(external_react_.Suspense, {
      fallback: null
    }, /*#__PURE__*/external_react_default().createElement(PostQuestionCategoriesPreview, {
      postQuestions: categoryPreview,
      language: language,
      color: config.color,
      onCategorySelect: onOpenPreviewModal,
      baseImageUrl: baseImageUrl,
      previewMode: true
    }));
  }
  if (!showModal) {
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, previewMode && /*#__PURE__*/external_react_default().createElement(external_react_.Suspense, {
    fallback: null
  }, /*#__PURE__*/external_react_default().createElement(PostQuestionCategoriesPreview, {
    postQuestions: categoryPreview,
    language: language,
    color: config.color,
    onCategorySelect: onOpenPreviewModal,
    baseImageUrl: baseImageUrl,
    previewMode: true
  })), /*#__PURE__*/external_react_default().createElement(containers_ComponentContainer, {
    style: customStyle
  }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement(ModalForm_ModalForm, {
    accentColor: config === null || config === void 0 ? void 0 : config.accentColor,
    formState: formState,
    onHideModal: onHideModal,
    brandName: brandName,
    brandLogoUrl: brandLogoUrl,
    language: language,
    isInitialising: isInitialising,
    isInitError: isInitError,
    onRetryInit: onRetryInit,
    successMessage: successMessage,
    previewMode: previewMode
  }, /*#__PURE__*/external_react_default().createElement(PostQuestions_Form_Form, {
    key: formUid,
    formId: id,
    introMessage: introMessage ? /*#__PURE__*/external_react_default().createElement("p", null, introMessage) : null,
    brandName: brandName,
    accentColor: config === null || config === void 0 ? void 0 : config.accentColor,
    selectInputs: selectInputs,
    textFields: textFields,
    submitText: submitText,
    footerMessage: footerMessage,
    language: language,
    formErrors: formErrors,
    onResetError: onResetError,
    inputFontSize: config === null || config === void 0 ? void 0 : config.inputFontSize,
    isPostingForm: isPostingForm,
    onSubmit: onSubmit
  })))));
};
/* harmony default export */ const PostQuestions_PostQuestions = (PostQuestions);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/VidioSection/VidioForm/VidioForm.module.scss
var VidioForm_module = __webpack_require__(219);
;// CONCATENATED MODULE: ./src/components/VidioSection/VidioForm/VidioForm.module.scss

      var VidioForm_module_exported = {};

      
      
      
      
      
      
      
      
      if (VidioForm_module/* default */.Z && VidioForm_module/* default.locals */.Z.locals) {
              VidioForm_module_exported.locals = VidioForm_module/* default.locals */.Z.locals;
            }
            

var VidioForm_module_refs = 0;
var VidioForm_module_update;
var VidioForm_module_options = {};

VidioForm_module_options.styleTagTransform = (styleTagTransform_default());
VidioForm_module_options.setAttributes = (setAttributesWithoutAttributes_default());

      VidioForm_module_options.insert = insertBySelector_default().bind(null, "head");
    
VidioForm_module_options.domAPI = (styleDomAPI_default());
VidioForm_module_options.insertStyleElement = (insertStyleElement_default());

VidioForm_module_exported.use = function(insertOptions) {
  VidioForm_module_options.options = insertOptions || {};

  if (!(VidioForm_module_refs++)) {
    VidioForm_module_update = injectStylesIntoStyleTag_default()(VidioForm_module/* default */.Z, VidioForm_module_options);
  }

  return VidioForm_module_exported;
};
VidioForm_module_exported.unuse = function() {
  if (VidioForm_module_refs > 0 && !--VidioForm_module_refs) {
    VidioForm_module_update();
    VidioForm_module_update = null;
  }
};




       /* harmony default export */ const VidioForm_VidioForm_module = (VidioForm_module_exported);

;// CONCATENATED MODULE: ./src/components/VidioSection/VidioForm/VidioForm.js
function VidioForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function VidioForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? VidioForm_ownKeys(Object(source), !0).forEach(function (key) { VidioForm_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : VidioForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function VidioForm_defineProperty(obj, key, value) { key = VidioForm_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function VidioForm_toPropertyKey(arg) { var key = VidioForm_toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function VidioForm_toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }



















var VidioForm = _ref => {
  var {
    additionalResponse,
    accentColor = '#000000',
    // color = '#000000',
    brandName,
    brandLogoUrl,
    animationUrl = '',
    baseImageUrl = '',
    paywallBannerUrl = '',
    PhaseHeader,
    videoProvider,
    serviceAvailability,
    termsAndConditionsUrl,
    campaignUrl,
    videoProviderUrl,
    terms,
    introMessage,
    inputs,
    campaignId,
    countries,
    getDeviceId,
    emailDescription = 'vidio.voucherLocation',
    phoneDescription = '',
    submitText = 'form.submitData',
    apiUrl,
    verifyEmailApi,
    countryApi,
    cityApi,
    id,
    language,
    availableLanguages,
    onLanguageChange,
    bountyId,
    maxLength,
    onSubmit = () => {
      /* doSomeAction - send form */
    },
    onSizeChanged = () => {},
    globalSettings,
    layout,
    isPhoneRequired,
    isWhatsAppDefault,
    textFields,
    excludedFields,
    codeRequestUrl,
    codeVerifyUrl,
    openPostQuestionForm,
    defaultState = {
      formErrors: {},
      formState: null
    },
    userInfo = {},
    countryData,
    callbackReferrer
  } = _ref;
  var dictionary = (0,external_react_.useContext)(Translation_provider);
  var classes = VidioForm_VidioForm_module.locals || {};
  var termAndConditionsUrlLang = "".concat(termsAndConditionsUrl, "/").concat(language);
  var [formState, setFormState] = (0,external_react_.useState)(defaultState.formState);
  var [formErrors, setFormErrors] = (0,external_react_.useState)(defaultState.formErrors);
  var [emailToken, setEmailToken] = (0,external_react_.useState)('');
  var resetFormError = key => {
    setFormErrors(state => {
      delete state[key];
      return state;
    });
  };
  var formWidth = (layout === null || layout === void 0 ? void 0 : layout.formWidth) || 6;
  var imageBoxWidth = 12 - formWidth;
  var imageAlignClass = '';
  if ((layout === null || layout === void 0 ? void 0 : layout.imageBoxPosition) === 'top') {
    formWidth = 12;
    imageBoxWidth = 12;
  }
  if ((layout === null || layout === void 0 ? void 0 : layout.imageBoxPosition) !== 'top' && (layout === null || layout === void 0 ? void 0 : layout.imageAlign) === 'top') {
    imageAlignClass = classes.BannerTop;
  } else if ((layout === null || layout === void 0 ? void 0 : layout.imageBoxPosition) !== 'top' && (layout === null || layout === void 0 ? void 0 : layout.imageAlign) === 'bottom') {
    imageAlignClass = classes.BannerBottom;
  }
  (0,external_react_.useEffect)(() => {
    VidioForm_VidioForm_module.use();
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  (0,external_react_.useEffect)(onSizeChanged, [formState, formErrors]);
  var onCategorySelect = (cpdcId, categoryId) => {
    openPostQuestionForm({
      cpdcId,
      campaignId,
      categoryId,
      bountyId,
      getDeviceId,
      brandName,
      config: {
        accentColor,
        backgroundColor: globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.imageBoxColor,
        color: globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.mainColor,
        inputFontSize: layout === null || layout === void 0 ? void 0 : layout.inputFontSize
      }
    });
  };
  var validateLength = data => {
    var error = {};
    var errMessage = defaultTransFunction('form.toLong', language, null, dictionary);
    Object.keys(data).map(field => {
      var el = data[field];
      if (!el || !isString(el)) return;
      var baseLength = maxLength && maxLength.defaultField || 100;
      var customLength = maxLength && maxLength.customField || 1000;
      if (isToLong(data[field], field, baseLength, customLength)) {
        error[field] = errMessage;
      }
    });
    if (Object.keys(error).length < 1) return true;
    setFormErrors(error);
    return false;
  };
  var onHideModal = () => {
    if (formState !== null && formState !== void 0 && formState.success) {
      setFormState(null);
    }
    window.close();
  };
  var onResetError = fieldName => {
    if (formErrors && formErrors[fieldName]) {
      setFormErrors(prevState => VidioForm_objectSpread(VidioForm_objectSpread({}, prevState), {
        [fieldName]: null
      }));
    }
  };
  var versionToDisplay = 'unknown';
  try {
    versionToDisplay = "3.3.6"; // eslint-disable-line no-undef
  } catch (error) {
    console.warn('Cannot get version of application.');
  }
  return /*#__PURE__*/external_react_default().createElement((Container_default()), null, /*#__PURE__*/external_react_default().createElement((Row_default()), {
    className: "g-0"
  }, /*#__PURE__*/external_react_default().createElement(VidioElements_VidioBanner, {
    brandLogoUrl: brandLogoUrl,
    animationUrl: animationUrl,
    colProps: {
      imageBoxWidth,
      imageAlignClass,
      vidioFormBrandCol: classes.VidioFormBrandCol,
      backgroundColor: globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.imageBoxColor
    },
    inlineHeaderProps: {
      formState,
      brandName,
      brandLogoUrl,
      language,
      isPhoneRequired,
      paywallBannerUrl
    }
  }), /*#__PURE__*/external_react_default().createElement((Col_default()), {
    lg: formWidth,
    className: "".concat(classes.VideoFormApplicationCol, " ").concat(!brandLogoUrl ? "mx-auto" : '', " px-4")
  }, /*#__PURE__*/external_react_default().createElement(VidioElements_VidioFormBody, {
    formState: formState,
    termsAndConditionsUrl: termsAndConditionsUrl,
    serviceAvailability: serviceAvailability,
    videoProvider: videoProvider,
    additionalResponse: additionalResponse,
    videoProviderUrl: videoProviderUrl,
    campaignUrl: campaignUrl,
    brandName: brandName,
    successType: phoneDescription ? 'sms' : 'email',
    onHideModal: onHideModal,
    language: language,
    color: globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.mainColor,
    isPhoneRequired: isPhoneRequired,
    onCategorySelect: onCategorySelect,
    baseImageUrl: baseImageUrl,
    userInfo: userInfo,
    PhaseHeader: PhaseHeader
  }, /*#__PURE__*/external_react_default().createElement(LanguageSelect_LanguageSelect, {
    availableLanguages: availableLanguages,
    currentLanguage: language,
    onLanguageChange: onLanguageChange,
    color: globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.mainColor
  }), /*#__PURE__*/external_react_default().createElement(Form_Form, {
    terms: terms,
    selectInputs: inputs,
    countries: countries,
    introMessage: introMessage,
    emailDescription: emailDescription,
    phoneDescription: phoneDescription,
    submitText: submitText,
    onSubmit: shared_handleCpdcSubmit(setFormErrors, validateLength, apiUrl, id, bountyId, getDeviceId, campaignId, language, formState, setFormState, transformVidioMessages, vidioErrors, onSubmit, userInfo, callbackReferrer),
    onEmailBlur: email => shared_handleVerifyEmail({
      email,
      verifyEmailApi,
      language,
      setFormErrors,
      setEmailToken
    }),
    errors: formErrors,
    resetFormError: resetFormError,
    language: language,
    brandName: brandName,
    videoProvider: videoProvider,
    serviceAvailability: serviceAvailability,
    termsAndConditionsUrl: termAndConditionsUrlLang,
    videoProviderUrl: videoProviderUrl,
    accentColor: globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.imageBoxColor,
    color: globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.mainColor,
    onResetError: onResetError,
    maxLength: maxLength,
    formId: id,
    inputFontSize: layout === null || layout === void 0 ? void 0 : layout.inputFontSize,
    isPhoneRequired: isPhoneRequired,
    isWhatsAppDefault: isWhatsAppDefault,
    textFields: textFields,
    excludedFields: excludedFields,
    codeRequestUrl: codeRequestUrl,
    codeVerifyUrl: codeVerifyUrl,
    countryApi: countryApi,
    cityApi: cityApi,
    userInfo: userInfo,
    countryData: countryData,
    emailToken: emailToken,
    PhaseHeader: PhaseHeader
  })))), /*#__PURE__*/external_react_default().createElement("div", {
    "data-test-version": "".concat(versionToDisplay)
  }));
};
/* harmony default export */ const VidioForm_VidioForm = (createTranslationProvider(VidioForm));

// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/components/GenericSelect/GenericSelect.module.scss
var GenericSelect_module = __webpack_require__(562);
;// CONCATENATED MODULE: ./src/components/GenericSelect/GenericSelect.module.scss

      var GenericSelect_module_exported = {};

      
      
      
      
      
      
      
      
      if (GenericSelect_module/* default */.Z && GenericSelect_module/* default.locals */.Z.locals) {
              GenericSelect_module_exported.locals = GenericSelect_module/* default.locals */.Z.locals;
            }
            

var GenericSelect_module_refs = 0;
var GenericSelect_module_update;
var GenericSelect_module_options = {};

GenericSelect_module_options.styleTagTransform = (styleTagTransform_default());
GenericSelect_module_options.setAttributes = (setAttributesWithoutAttributes_default());

      GenericSelect_module_options.insert = insertBySelector_default().bind(null, "head");
    
GenericSelect_module_options.domAPI = (styleDomAPI_default());
GenericSelect_module_options.insertStyleElement = (insertStyleElement_default());

GenericSelect_module_exported.use = function(insertOptions) {
  GenericSelect_module_options.options = insertOptions || {};

  if (!(GenericSelect_module_refs++)) {
    GenericSelect_module_update = injectStylesIntoStyleTag_default()(GenericSelect_module/* default */.Z, GenericSelect_module_options);
  }

  return GenericSelect_module_exported;
};
GenericSelect_module_exported.unuse = function() {
  if (GenericSelect_module_refs > 0 && !--GenericSelect_module_refs) {
    GenericSelect_module_update();
    GenericSelect_module_update = null;
  }
};




       /* harmony default export */ const GenericSelect_GenericSelect_module = (GenericSelect_module_exported);

;// CONCATENATED MODULE: ./src/components/GenericSelect/GenericSelect.js
var GenericSelect_excluded = ["label", "name", "className", "options", "onChange", "errorMessage", "value", "isMulti"];
function GenericSelect_extends() { GenericSelect_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return GenericSelect_extends.apply(this, arguments); }
function GenericSelect_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function GenericSelect_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GenericSelect_ownKeys(Object(source), !0).forEach(function (key) { GenericSelect_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GenericSelect_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function GenericSelect_defineProperty(obj, key, value) { key = GenericSelect_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function GenericSelect_toPropertyKey(arg) { var key = GenericSelect_toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function GenericSelect_toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function GenericSelect_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = GenericSelect_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function GenericSelect_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Select = _ref => {
  var {
      label,
      name,
      className,
      options,
      onChange,
      errorMessage,
      value = null,
      isMulti
    } = _ref,
    props = GenericSelect_objectWithoutProperties(_ref, GenericSelect_excluded);
  var classes = GenericSelect_GenericSelect_module.locals || {};
  (0,external_react_.useEffect)(() => {
    GenericSelect_GenericSelect_module.use();
  }, []);
  var selectedValue = (() => {
    if (value === 'object' && !isMulti) {
      return value;
    }
    return options.find(option => option.value === value);
  })();
  var onChangeHandler = event => {
    var _event$value;
    if (isMulti && Array.isArray(event)) {
      return onChange(event.map(o => o.value));
    }
    return onChange((_event$value = event.value) !== null && _event$value !== void 0 ? _event$value : '');
  };
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: className !== null && className !== void 0 ? className : ''
  }, /*#__PURE__*/external_react_default().createElement("label", {
    className: errorMessage ? "mb-0 ".concat(classes.inputContainer) : classes.inputContainer,
    htmlFor: name
  }, /*#__PURE__*/external_react_default().createElement("p", {
    className: classes.label
  }, label), /*#__PURE__*/external_react_default().createElement((external_react_select_default()), GenericSelect_extends({
    id: name,
    isMulti: isMulti,
    className: classes.select,
    classNamePrefix: "react-select",
    onChange: onChangeHandler,
    options: options,
    name: name,
    value: selectedValue,
    placeholder: "",
    theme: _theme => GenericSelect_objectSpread(GenericSelect_objectSpread({}, _theme), {}, {
      colors: GenericSelect_objectSpread(GenericSelect_objectSpread({}, _theme.colors), {}, {
        primary: '#f57300',
        primary75: 'rgba(245, 115, 0, 0.75)',
        primary50: 'rgba(245, 115, 0, 0.5)',
        primary25: 'rgba(245, 115, 0, 0.25)'
      })
    }),
    styles: reactSelectStyle
  }, props))), errorMessage && /*#__PURE__*/external_react_default().createElement("p", {
    className: "text-danger ".concat(classes.error)
  }, errorMessage));
};
/* harmony default export */ const GenericSelect = (Select);
;// CONCATENATED MODULE: ./src/index.js













})();

module.exports = __webpack_exports__;
/******/ })()
;